export const GOOD_SERVICE_CODE_OPTIONS = [
  { value: "000000", label: "000000 - Barang/Jasa (umum/default)" },

  // ===== BARANG (HS) =====
  // Bab 01 - Binatang hidup
  { value: "010000", label: "01.00.00 - Binatang hidup" },
  {
    value: "010100",
    label: "01.01.00 - Kuda, keledai, bagal dan hinnie, hidup",
  },
  { value: "010200", label: "01.02.00 - Binatang hidup jenis lembu" },
  { value: "010300", label: "01.03.00 - Babi hidup" },
  { value: "010400", label: "01.04.00 - Biri-biri dan kambing, hidup" },
  {
    value: "010500",
    label: "01.05.00 - Unggas hidup (ayam, bebek, angsa, kalkun, ayam guinea)",
  },
  { value: "010600", label: "01.06.00 - Binatang hidup lainnya" },
  // Bab 02 - Daging dan sisa daging yang dapat dimakan
  {
    value: "020000",
    label: "02.00.00 - Daging dan sisa daging yang dapat dimakan",
  },
  {
    value: "020100",
    label: "02.01.00 - Daging binatang jenis lembu, segar atau dingin",
  },
  { value: "020200", label: "02.02.00 - Daging binatang jenis lembu, beku" },
  { value: "020300", label: "02.03.00 - Daging babi, segar, dingin atau beku" },
  {
    value: "020400",
    label: "02.04.00 - Daging biri-biri atau kambing, segar, dingin atau beku",
  },
  {
    value: "020500",
    label:
      "02.05.00 - Daging kuda, keledai, bagal atau hinnie, segar, dingin atau beku",
  },
  {
    value: "020600",
    label:
      "02.06.00 - Sisa yang dapat dimakan dari lembu, babi, biri-biri, kambing, kuda dll",
  },
  {
    value: "020700",
    label:
      "02.07.00 - Daging dan sisa unggas pos 01.05, segar, dingin atau beku",
  },
  {
    value: "020800",
    label:
      "02.08.00 - Daging dan sisa binatang lainnya, segar, dingin atau beku",
  },
  {
    value: "020900",
    label: "02.09.00 - Lemak babi tanpa daging dan lemak unggas",
  },
  {
    value: "021000",
    label:
      "02.10.00 - Daging dan sisanya diasinkan/dikeringkan/diasapi; tepung daging",
  },
  // Bab 03 - Ikan dan krustasea, moluska serta invertebrata air lainnya
  {
    value: "030000",
    label:
      "03.00.00 - Ikan dan krustasea, moluska serta invertebrata air lainnya",
  },
  { value: "030100", label: "03.01.00 - Ikan hidup" },
  { value: "030200", label: "03.02.00 - Ikan, segar atau dingin" },
  { value: "030300", label: "03.03.00 - Ikan beku" },
  {
    value: "030400",
    label: "03.04.00 - Fillet dan daging ikan lainnya, segar, dingin atau beku",
  },
  {
    value: "030500",
    label: "03.05.00 - Ikan dikeringkan, diasinkan atau diasapi",
  },
  { value: "030600", label: "03.06.00 - Krustasea" },
  { value: "030700", label: "03.07.00 - Moluska" },
  {
    value: "030800",
    label: "03.08.00 - Invertebrata air selain krustasea dan moluska",
  },
  {
    value: "030900",
    label:
      "03.09.00 - Tepung, tepung kasar dan pelet dari ikan/krustasea/moluska",
  },
  // Bab 04 - Produk susu; telur; madu
  {
    value: "040000",
    label:
      "04.00.00 - Produk susu; telur unggas; madu alam; produk hewani ytdl",
  },
  {
    value: "040100",
    label:
      "04.01.00 - Susu dan kepala susu, tidak dipekatkan/tanpa tambahan gula",
  },
  {
    value: "040200",
    label:
      "04.02.00 - Susu dan kepala susu, dipekatkan atau dengan tambahan gula",
  },
  {
    value: "040300",
    label:
      "04.03.00 - Yoghurt; susu mentega, kefir dan susu/krim fermentasi lainnya",
  },
  {
    value: "040400",
    label: "04.04.00 - Whey; produk dari unsur susu alam ytdl",
  },
  {
    value: "040500",
    label:
      "04.05.00 - Mentega dan lemak/minyak lainnya dari susu; dairy spreads",
  },
  { value: "040600", label: "04.06.00 - Keju dan dadih susu" },
  {
    value: "040700",
    label: "04.07.00 - Telur unggas bercangkang, segar, diawetkan atau dimasak",
  },
  {
    value: "040800",
    label: "04.08.00 - Telur unggas tanpa cangkang dan kuning telur",
  },
  { value: "040900", label: "04.09.00 - Madu alam" },
  {
    value: "041000",
    label: "04.10.00 - Serangga dan produk hewani yang dapat dimakan ytdl",
  },
  // Bab 05 - Produk hewani ytdl
  { value: "050000", label: "05.00.00 - Produk hewani ytdl" },
  {
    value: "050100",
    label: "05.01.00 - Rambut manusia, tidak dikerjakan; sisa rambut manusia",
  },
  {
    value: "050200",
    label: "05.02.00 - Bulu dan bulu kasar babi; bulu untuk membuat sikat",
  },
  {
    value: "050400",
    label: "05.04.00 - Usus, kandung kemih dan lambung binatang selain ikan",
  },
  {
    value: "050500",
    label: "05.05.00 - Kulit dan bagian unggas berbulu; bulu unggas",
  },
  {
    value: "050600",
    label: "05.06.00 - Tulang dan teras tanduk, tidak dikerjakan dll",
  },
  {
    value: "050700",
    label: "05.07.00 - Gading, tempurung kura-kura, tanduk, kuku, cakar, paruh",
  },
  {
    value: "050800",
    label: "05.08.00 - Koral; cangkang moluska, krustasea atau echinodermata",
  },
  {
    value: "050900",
    label:
      "05.09.00 - Ambar, kastor, jebat dan kesturi; kelenjar untuk farmasi",
  },
  {
    value: "051000",
    label:
      "05.10.00 - Ambar, kastor, jebat dan kesturi; produk binatang untuk farmasi",
  },
  {
    value: "051100",
    label:
      "05.11.00 - Produk hewani ytdl; binatang mati Bab 1/3 tidak layak konsumsi",
  },
  // Bab 06 - Pohon hidup dan tanaman lainnya
  {
    value: "060000",
    label:
      "06.00.00 - Pohon hidup dan tanaman lainnya; umbi; bunga potong; daun ornamen",
  },
  {
    value: "060100",
    label:
      "06.01.00 - Umbi, bonggol, akar berbonggol; tanaman dan akar chicory",
  },
  {
    value: "060200",
    label:
      "06.02.00 - Tanaman hidup lainnya termasuk akar, potongan dan cangkokan",
  },
  { value: "060300", label: "06.03.00 - Bunga dan kuncup bunga potong" },
  {
    value: "060400",
    label:
      "06.04.00 - Daun, dahan dan bagian tanaman lainnya untuk karangan/pajangan",
  },
  // Bab 07 - Sayuran
  {
    value: "070000",
    label:
      "07.00.00 - Sayuran dan akar serta bonggol tertentu yang dapat dimakan",
  },
  { value: "070100", label: "07.01.00 - Kentang, segar atau dingin" },
  { value: "070200", label: "07.02.00 - Tomat, segar atau dingin" },
  {
    value: "070300",
    label:
      "07.03.00 - Bawang bombay, merah, putih, bakung/perai dll, segar atau dingin",
  },
  {
    value: "070400",
    label: "07.04.00 - Kubis, bunga kol, kohlrabi, kale dll, segar atau dingin",
  },
  {
    value: "070500",
    label: "07.05.00 - Selada dan chicory, segar atau dingin",
  },
  {
    value: "070600",
    label:
      "07.06.00 - Wortel, lobak cina, bit salad, lobak dll, segar atau dingin",
  },
  {
    value: "070700",
    label: "07.07.00 - Ketimun dan ketimun acar, segar atau dingin",
  },
  {
    value: "070800",
    label: "07.08.00 - Sayuran polongan, dikupas atau tidak, segar atau dingin",
  },
  { value: "070900", label: "07.09.00 - Sayuran lainnya, segar atau dingin" },
  {
    value: "071000",
    label: "07.10.00 - Sayuran tidak dimasak atau dikukus/direbus, beku",
  },
  {
    value: "071100",
    label:
      "07.11.00 - Sayuran diawetkan sementara, tidak cocok konsumsi langsung",
  },
  {
    value: "071200",
    label: "07.12.00 - Sayuran dikeringkan, utuh/potongan/irisan/bubuk",
  },
  {
    value: "071300",
    label: "07.13.00 - Sayuran polongan dikeringkan, dikupas/dikuliti/dibelah",
  },
  {
    value: "071400",
    label:
      "07.14.00 - Ubi kayu, arrowroot, ubi jalar dan akar/bonggol berpati tinggi",
  },
  // Bab 08 - Buah
  {
    value: "080000",
    label: "08.00.00 - Buah dan buah bertempurung; kulit jeruk atau melon",
  },
  {
    value: "080100",
    label:
      "08.01.00 - Kelapa, kacang Brasil dan kacang mede, segar atau dikeringkan",
  },
  {
    value: "080200",
    label: "08.02.00 - Buah bertempurung lainnya, segar atau dikeringkan",
  },
  {
    value: "080300",
    label: "08.03.00 - Pisang termasuk plantain, segar atau dikeringkan",
  },
  {
    value: "080400",
    label: "08.04.00 - Korma, ara, nanas, alpukat, jambu, mangga, manggis",
  },
  { value: "080500", label: "08.05.00 - Buah jeruk, segar atau dikeringkan" },
  { value: "080600", label: "08.06.00 - Anggur, segar atau dikeringkan" },
  {
    value: "080700",
    label: "08.07.00 - Melon termasuk semangka dan pepaya, segar",
  },
  { value: "080800", label: "08.08.00 - Apel, pir dan quince, segar" },
  {
    value: "080900",
    label: "08.09.00 - Aprikot, ceri, persik, plum dan sloe, segar",
  },
  { value: "081000", label: "08.10.00 - Buah lainnya, segar" },
  { value: "081100", label: "08.11.00 - Buah dan buah bertempurung, beku" },
  {
    value: "081200",
    label: "08.12.00 - Buah diawetkan sementara, tidak cocok konsumsi langsung",
  },
  {
    value: "081300",
    label:
      "08.13.00 - Buah kering selain pos 08.01-08.06; campuran buah kering",
  },
  {
    value: "081400",
    label:
      "08.14.00 - Kulit buah jeruk atau melon, segar/beku/dikeringkan/diawetkan",
  },
  // Bab 09 - Kopi, teh, mate dan rempah-rempah
  { value: "090000", label: "09.00.00 - Kopi, teh, mate dan rempah-rempah" },
  {
    value: "090100",
    label:
      "09.01.00 - Kopi, digongseng atau dihilangkan kafeinnya maupun tidak",
  },
  { value: "090200", label: "09.02.00 - Teh, diberi rasa maupun tidak" },
  { value: "090300", label: "09.03.00 - Mate" },
  {
    value: "090400",
    label: "09.04.00 - Lada (genus Piper); buah Capsicum atau Pimenta",
  },
  { value: "090500", label: "09.05.00 - Vanila" },
  { value: "090600", label: "09.06.00 - Kayu manis dan bunga kayu manis" },
  { value: "090700", label: "09.07.00 - Cengkeh utuh, bunga dan tangkai" },
  { value: "090800", label: "09.08.00 - Biji pala, bunga pala dan kapulaga" },
  {
    value: "090900",
    label: "09.09.00 - Biji adas manis, badian, ketumbar, jintan dll",
  },
  {
    value: "091000",
    label: "09.10.00 - Jahe, saffron, turmeric, thyme, daun salam, kari dll",
  },
  // Bab 10 - Serealia
  { value: "100000", label: "10.00.00 - Serealia" },
  { value: "100100", label: "10.01.00 - Gandum dan meslin" },
  { value: "100200", label: "10.02.00 - Gandum hitam (rye)" },
  { value: "100300", label: "10.03.00 - Barli" },
  { value: "100400", label: "10.04.00 - Oat" },
  { value: "100500", label: "10.05.00 - Jagung" },
  { value: "100600", label: "10.06.00 - Beras" },
  { value: "100700", label: "10.07.00 - Butiran sorghum" },
  {
    value: "100800",
    label: "10.08.00 - Buckwheat, millet dan biji canary; serealia lainnya",
  },
  // Bab 11 - Produk industri penggilingan
  {
    value: "110000",
    label:
      "11.00.00 - Produk industri penggilingan; malt; pati; inulin; gluten gandum",
  },
  { value: "110100", label: "11.01.00 - Tepung gandum atau tepung meslin" },
  {
    value: "110200",
    label: "11.02.00 - Tepung serealia selain gandum atau meslin",
  },
  {
    value: "110300",
    label: "11.03.00 - Menir, tepung kasar dan pelet serealia",
  },
  {
    value: "110400",
    label: "11.04.00 - Butir serealia dikerjakan secara lain; lembaga serealia",
  },
  {
    value: "110500",
    label: "11.05.00 - Tepung, bubuk, serpih, butir dan pelet kentang",
  },
  {
    value: "110600",
    label:
      "11.06.00 - Tepung dan bubuk dari sayuran polongan/sagu/akar/bonggol",
  },
  { value: "110700", label: "11.07.00 - Malt, digongseng maupun tidak" },
  { value: "110800", label: "11.08.00 - Pati; inulin" },
  {
    value: "110900",
    label: "11.09.00 - Gluten gandum, dikeringkan maupun tidak",
  },
  // Bab 12 - Biji dan buah mengandung minyak
  {
    value: "120000",
    label:
      "12.00.00 - Biji dan buah mengandung minyak; tanaman industri/obat; jerami",
  },
  { value: "120100", label: "12.01.00 - Kacang kedelai, pecah maupun tidak" },
  {
    value: "120200",
    label: "12.02.00 - Kacang tanah, tidak digongseng/dimasak",
  },
  { value: "120300", label: "12.03.00 - Kopra" },
  {
    value: "120400",
    label: "12.04.00 - Biji rami (linseed), pecah maupun tidak",
  },
  {
    value: "120500",
    label: "12.05.00 - Biji lobak atau colza, pecah maupun tidak",
  },
  {
    value: "120600",
    label: "12.06.00 - Biji bunga matahari, pecah maupun tidak",
  },
  {
    value: "120700",
    label: "12.07.00 - Biji dan buah mengandung minyak lainnya",
  },
  {
    value: "120800",
    label:
      "12.08.00 - Tepung halus/kasar dari biji atau buah mengandung minyak",
  },
  { value: "120900", label: "12.09.00 - Biji, buah dan spora untuk disemai" },
  { value: "121000", label: "12.10.00 - Kerucut buah hop; lupulin" },
  {
    value: "121100",
    label: "12.11.00 - Tanaman untuk wewangian/farmasi/insektisida",
  },
  {
    value: "121200",
    label: "12.12.00 - Kacang karob, rumput laut, bit gula dan tebu dll",
  },
  {
    value: "121300",
    label: "12.13.00 - Jerami dan sekam serealia, tidak diolah",
  },
  {
    value: "121400",
    label: "12.14.00 - Swedes, mangold, akar makanan ternak, rumput kering dll",
  },
  // Bab 13 - Lak; getah, damar
  {
    value: "130000",
    label: "13.00.00 - Lak; getah, damar dan sap serta ekstrak nabati lainnya",
  },
  {
    value: "130100",
    label: "13.01.00 - Lak; getah alam, damar, getah-damar dan oleoresins",
  },
  {
    value: "130200",
    label: "13.02.00 - Sap dan ekstrak nabati; agar-agar dan bahan pengental",
  },
  // Bab 14 - Bahan anyaman nabati
  {
    value: "140000",
    label: "14.00.00 - Bahan anyaman nabati; produk nabati ytdl",
  },
  {
    value: "140100",
    label: "14.01.00 - Bahan nabati untuk anyaman (bambu, rotan, buluh dll)",
  },
  { value: "140400", label: "14.04.00 - Produk nabati ytdl" },
  // Bab 15 - Lemak dan minyak hewani/nabati
  {
    value: "150000",
    label: "15.00.00 - Lemak dan minyak hewani/nabati serta produknya; malam",
  },
  {
    value: "150100",
    label: "15.01.00 - Lemak babi termasuk lard dan lemak unggas",
  },
  {
    value: "150200",
    label: "15.02.00 - Lemak dari lembu, biri-biri atau kambing",
  },
  {
    value: "150300",
    label: "15.03.00 - Lard stearin, minyak lard, oleostearin, minyak tallow",
  },
  {
    value: "150400",
    label: "15.04.00 - Lemak dan minyak dari ikan atau binatang laut menyusui",
  },
  {
    value: "150500",
    label: "15.05.00 - Wool grease dan zat lemak turunannya termasuk lanolin",
  },
  {
    value: "150600",
    label: "15.06.00 - Lemak dan minyak binatang lainnya serta fraksinya",
  },
  { value: "150700", label: "15.07.00 - Minyak kacang kedelai dan fraksinya" },
  { value: "150800", label: "15.08.00 - Minyak kacang tanah dan fraksinya" },
  { value: "150900", label: "15.09.00 - Minyak zaitun dan fraksinya" },
  {
    value: "151000",
    label: "15.10.00 - Minyak lain dari zaitun dan fraksinya",
  },
  { value: "151100", label: "15.11.00 - Minyak kelapa sawit dan fraksinya" },
  {
    value: "151200",
    label: "15.12.00 - Minyak biji bunga matahari, safflower atau biji kapas",
  },
  {
    value: "151300",
    label: "15.13.00 - Minyak kelapa kopra, kernel sawit atau babassu",
  },
  {
    value: "151400",
    label: "15.14.00 - Minyak lobak, colza atau mustar dan fraksinya",
  },
  {
    value: "151500",
    label: "15.15.00 - Lemak dan minyak nabati/mikroba tertentu lainnya",
  },
  {
    value: "151600",
    label:
      "15.16.00 - Lemak dan minyak hewani/nabati/mikroba dihidrogenasi dll",
  },
  {
    value: "151700",
    label: "15.17.00 - Margarin; campuran lemak/minyak yang dapat dimakan",
  },
  {
    value: "151800",
    label: "15.18.00 - Lemak dan minyak dimodifikasi secara kimia",
  },
  {
    value: "152000",
    label: "15.20.00 - Gliserol; air gliserol dan larutan alkali gliserol",
  },
  {
    value: "152100",
    label:
      "15.21.00 - Malam nabati; malam lebah, malam serangga dan spermaceti",
  },
  {
    value: "152200",
    label: "15.22.00 - Degras; residu pengolahan zat berlemak atau malam",
  },
  // Bab 16 - Olahan dari daging/ikan
  {
    value: "160000",
    label:
      "16.00.00 - Olahan dari daging, ikan, krustasea, moluska atau invertebrata air",
  },
  { value: "160100", label: "16.01.00 - Sosis dan produk semacamnya" },
  {
    value: "160200",
    label:
      "16.02.00 - Daging, sisa daging, darah atau serangga diolah/diawetkan",
  },
  {
    value: "160300",
    label:
      "16.03.00 - Ekstrak dan jus dari daging, ikan atau krustasea/moluska",
  },
  {
    value: "160400",
    label: "16.04.00 - Ikan diolah atau diawetkan; kaviar dan penggantinya",
  },
  {
    value: "160500",
    label:
      "16.05.00 - Krustasea, moluska dan invertebrata air, diolah/diawetkan",
  },
  // Bab 17 - Gula dan kembang gula
  { value: "170000", label: "17.00.00 - Gula dan kembang gula" },
  {
    value: "170100",
    label: "17.01.00 - Gula tebu atau gula bit dan sukrosa murni, bentuk padat",
  },
  { value: "170200", label: "17.02.00 - Gula lainnya; sirop gula; karamel" },
  {
    value: "170300",
    label: "17.03.00 - Tetes (molasses) hasil ekstraksi atau pemurnian gula",
  },
  {
    value: "170400",
    label:
      "17.04.00 - Kembang gula termasuk coklat putih, tidak mengandung kakao",
  },
  // Bab 18 - Kakao dan olahan kakao
  { value: "180000", label: "18.00.00 - Kakao dan olahan kakao" },
  {
    value: "180100",
    label: "18.01.00 - Biji kakao, utuh atau pecah, mentah atau digongseng",
  },
  {
    value: "180200",
    label: "18.02.00 - Kulit, sekam, selaput dan sisa kakao lainnya",
  },
  {
    value: "180300",
    label: "18.03.00 - Pasta kakao, dihilangkan lemaknya maupun tidak",
  },
  { value: "180400", label: "18.04.00 - Mentega, lemak dan minyak kakao" },
  {
    value: "180500",
    label: "18.05.00 - Bubuk kakao, tanpa tambahan gula atau pemanis lainnya",
  },
  {
    value: "180600",
    label: "18.06.00 - Coklat dan olahan makanan lainnya mengandung kakao",
  },
  // Bab 19 - Olahan dari serealia, tepung, pati atau susu
  {
    value: "190000",
    label:
      "19.00.00 - Olahan dari serealia, tepung, pati atau susu; produk industri kue",
  },
  {
    value: "190100",
    label:
      "19.01.00 - Ekstrak malt; olahan makanan dari tepung/pati/ekstrak malt",
  },
  {
    value: "190200",
    label: "19.02.00 - Pasta (spagheti, makaroni, mie, lasagna dll)",
  },
  { value: "190300", label: "19.03.00 - Tapioka dan penggantinya dari pati" },
  {
    value: "190400",
    label:
      "19.04.00 - Makanan olahan dari penggembungan/penggongsengan serealia",
  },
  {
    value: "190500",
    label: "19.05.00 - Roti, kue kering, kue, biskuit dan produk roti lainnya",
  },
  // Bab 20 - Olahan dari sayuran, buah, kacang
  {
    value: "200000",
    label:
      "20.00.00 - Olahan dari sayuran, buah, kacang atau bagian tanaman lainnya",
  },
  {
    value: "200100",
    label: "20.01.00 - Sayuran, buah, kacang diawetkan dengan cuka/asam asetat",
  },
  {
    value: "200200",
    label: "20.02.00 - Tomat diolah/diawetkan selain dengan cuka/asam asetat",
  },
  {
    value: "200300",
    label: "20.03.00 - Jamur dan cendawan tanah, diolah/diawetkan",
  },
  {
    value: "200400",
    label: "20.04.00 - Sayuran lainnya diolah/diawetkan, beku",
  },
  {
    value: "200500",
    label: "20.05.00 - Sayuran lainnya diolah/diawetkan, tidak beku",
  },
  {
    value: "200600",
    label: "20.06.00 - Sayuran, buah, kacang diawetkan dengan gula",
  },
  {
    value: "200700",
    label: "20.07.00 - Selai, jeli buah, marmelade, pure dan pasta buah/kacang",
  },
  {
    value: "200800",
    label:
      "20.08.00 - Buah, kacang dan bagian tanaman lainnya diolah/diawetkan",
  },
  {
    value: "200900",
    label: "20.09.00 - Jus buah/kacang dan jus sayuran, tidak difermentasi",
  },
  // Bab 21 - Bermacam olahan yang dapat dimakan
  {
    value: "210000",
    label: "21.00.00 - Bermacam-macam olahan yang dapat dimakan",
  },
  {
    value: "210100",
    label: "21.01.00 - Ekstrak, esens dan konsentrat kopi, teh atau mate",
  },
  {
    value: "210200",
    label:
      "21.02.00 - Ragi; mikroorganisme bersel tunggal; bubuk pengembang roti",
  },
  {
    value: "210300",
    label: "21.03.00 - Saus dan olahannya; bumbu campuran; mustar olahan",
  },
  {
    value: "210400",
    label:
      "21.04.00 - Sop dan kaldu serta olahannya; olahan makanan campuran homogen",
  },
  {
    value: "210500",
    label: "21.05.00 - Es krim dan es lainnya yang dapat dimakan",
  },
  { value: "210600", label: "21.06.00 - Olahan makanan ytdl" },
  // Bab 22 - Minuman, alkohol dan cuka
  { value: "220000", label: "22.00.00 - Minuman, alkohol dan cuka" },
  {
    value: "220100",
    label:
      "22.01.00 - Air, termasuk air mineral dan air soda, tanpa tambahan gula",
  },
  {
    value: "220200",
    label:
      "22.02.00 - Air mineral/soda dengan tambahan gula; minuman non-alkohol lainnya",
  },
  { value: "220300", label: "22.03.00 - Bir terbuat dari malt" },
  {
    value: "220400",
    label: "22.04.00 - Minuman fermentasi wine dari buah anggur segar",
  },
  {
    value: "220500",
    label: "22.05.00 - Vermouth dan minuman fermentasi dari anggur diberi rasa",
  },
  {
    value: "220600",
    label: "22.06.00 - Minuman fermentasi lainnya (cider, perry, mead, sake)",
  },
  {
    value: "220700",
    label: "22.07.00 - Etil alkohol tidak didenaturasi kadar 80% atau lebih",
  },
  {
    value: "220800",
    label:
      "22.08.00 - Etil alkohol kadar kurang dari 80%; sopi manis; minuman beralkohol",
  },
  {
    value: "220900",
    label: "22.09.00 - Cuka dan pengganti cuka dari asam asetat",
  },
  // Bab 23 - Residu dan sisa dari industri makanan
  {
    value: "230000",
    label:
      "23.00.00 - Residu dan sisa dari industri makanan; olahan makanan hewan",
  },
  {
    value: "230100",
    label:
      "23.01.00 - Tepung dan pelet dari daging/ikan, tidak layak konsumsi manusia",
  },
  {
    value: "230200",
    label:
      "23.02.00 - Sekam, dedak dan residu dari pengayakan/penggilingan serealia",
  },
  {
    value: "230300",
    label:
      "23.03.00 - Residu pembuatan pati; pulp bit; ampas tebu; sisa bir/penyulingan",
  },
  {
    value: "230400",
    label: "23.04.00 - Bungkil dan residu dari ekstraksi minyak kacang kedelai",
  },
  {
    value: "230500",
    label: "23.05.00 - Bungkil dan residu dari ekstraksi minyak kacang tanah",
  },
  {
    value: "230600",
    label:
      "23.06.00 - Bungkil dan residu dari ekstraksi lemak/minyak nabati lainnya",
  },
  {
    value: "230700",
    label: "23.07.00 - Endapan dan kerak minuman fermentasi (wine lees)",
  },
  {
    value: "230800",
    label: "23.08.00 - Bahan dan sisa nabati untuk makanan hewan ytdl",
  },
  {
    value: "230900",
    label: "23.09.00 - Olahan dari jenis yang digunakan untuk makanan hewan",
  },
  // Bab 24 - Tembakau dan pengganti tembakau
  {
    value: "240000",
    label: "24.00.00 - Tembakau dan pengganti tembakau dipabrikasi",
  },
  {
    value: "240100",
    label: "24.01.00 - Tembakau belum dipabrikasi; sisa tembakau",
  },
  {
    value: "240200",
    label: "24.02.00 - Cerutu, cheroot, cerutu kecil dan sigaret",
  },
  {
    value: "240300",
    label:
      "24.03.00 - Tembakau dipabrikasi lainnya; ekstrak dan esens tembakau",
  },
  {
    value: "240400",
    label:
      "24.04.00 - Produk mengandung tembakau/nikotin untuk inhalasi tanpa pembakaran",
  },
  // Bab 25 - Garam; belerang; tanah dan batu; kapur dan semen
  {
    value: "250000",
    label:
      "25.00.00 - Garam; belerang; tanah dan batu; bahan pemlester, kapur dan semen",
  },
  {
    value: "250100",
    label:
      "25.01.00 - Garam termasuk garam meja; natrium klorida murni; air laut",
  },
  { value: "250200", label: "25.02.00 - Pirit besi tidak digongseng" },
  {
    value: "250300",
    label:
      "25.03.00 - Belerang dari segala jenis (selain sublimasi/endapan/koloidal)",
  },
  { value: "250400", label: "25.04.00 - Grafit alam" },
  { value: "250500", label: "25.05.00 - Pasir alam dari segala jenis" },
  { value: "250600", label: "25.06.00 - Kuarsa; kuarsit" },
  { value: "250700", label: "25.07.00 - Kaolin dan tanah liat kaolin lainnya" },
  {
    value: "250800",
    label:
      "25.08.00 - Tanah liat lainnya; andalusite, kyanite, sillimanite; chamotte",
  },
  { value: "250900", label: "25.09.00 - Kapur (chalk)" },
  {
    value: "251000",
    label:
      "25.10.00 - Kalsium fosfat alam; aluminium kalsium fosfat alam; kapur fosfat",
  },
  {
    value: "251100",
    label:
      "25.11.00 - Barium sulfat alam (barit); barium karbonat alam (witherite)",
  },
  {
    value: "251200",
    label: "25.12.00 - Tanah diatomea (kieselguhr, tripolite, diatomit)",
  },
  {
    value: "251300",
    label:
      "25.13.00 - Batu apung; amril; korundum alam; garnet alam; ampelas alam",
  },
  { value: "251400", label: "25.14.00 - Batu sabak (slate)" },
  {
    value: "251500",
    label:
      "25.15.00 - Marmer, travertine, ecaussine dan batu berkapur lainnya; alabaster",
  },
  {
    value: "251600",
    label:
      "25.16.00 - Granit, porphyry, basal, batu pasir untuk monumen/bangunan",
  },
  {
    value: "251700",
    label: "25.17.00 - Kerikil, gravel, batu pecah; macadam; granul batuan",
  },
  { value: "251800", label: "25.18.00 - Dolomit" },
  {
    value: "251900",
    label:
      "25.19.00 - Magnesium karbonat alam (magnesit); magnesia; magnesium oksida",
  },
  { value: "252000", label: "25.20.00 - Gips; anhidrit; plester" },
  {
    value: "252100",
    label:
      "25.21.00 - Fluks batu kapur; batu kapur dan batu mengandung kapur lainnya",
  },
  {
    value: "252200",
    label: "25.22.00 - Kapur tohor, kapur kembang dan kapur hidrolis",
  },
  {
    value: "252300",
    label:
      "25.23.00 - Semen portland, alumina, terak, super sulfat dan semen hidrolis",
  },
  { value: "252400", label: "25.24.00 - Asbes" },
  { value: "252500", label: "25.25.00 - Mika termasuk belahannya; sisa mika" },
  { value: "252600", label: "25.26.00 - Steatit alam; talek" },
  {
    value: "252800",
    label: "25.28.00 - Borat alam dan konsentratnya; asam borat alam",
  },
  {
    value: "252900",
    label: "25.29.00 - Felspar; leucite; nepheline; fluorspar",
  },
  { value: "253000", label: "25.30.00 - Bahan mineral ytdl" },
  // Bab 26 - Bijih logam, terak dan abu
  { value: "260000", label: "26.00.00 - Bijih logam, terak dan abu" },
  { value: "260100", label: "26.01.00 - Bijih besi dan konsentratnya" },
  { value: "260200", label: "26.02.00 - Bijih mangan dan konsentratnya" },
  { value: "260300", label: "26.03.00 - Bijih tembaga dan konsentratnya" },
  { value: "260400", label: "26.04.00 - Bijih nikel dan konsentratnya" },
  { value: "260500", label: "26.05.00 - Bijih kobalt dan konsentratnya" },
  { value: "260600", label: "26.06.00 - Bijih aluminium dan konsentratnya" },
  { value: "260700", label: "26.07.00 - Bijih timbal dan konsentratnya" },
  { value: "260800", label: "26.08.00 - Bijih seng dan konsentratnya" },
  { value: "260900", label: "26.09.00 - Bijih timah dan konsentratnya" },
  { value: "261000", label: "26.10.00 - Bijih kromium dan konsentratnya" },
  { value: "261100", label: "26.11.00 - Bijih tungsten dan konsentratnya" },
  {
    value: "261200",
    label: "26.12.00 - Bijih uranium atau torium dan konsentratnya",
  },
  { value: "261300", label: "26.13.00 - Bijih molibdenum dan konsentratnya" },
  { value: "261400", label: "26.14.00 - Bijih titanium dan konsentratnya" },
  {
    value: "261500",
    label:
      "26.15.00 - Bijih niobium, tantalum, vanadium atau zirkonium dan konsentratnya",
  },
  { value: "261600", label: "26.16.00 - Bijih logam mulia dan konsentratnya" },
  { value: "261700", label: "26.17.00 - Bijih lainnya dan konsentratnya" },
  {
    value: "261800",
    label: "26.18.00 - Terak butiran dari pembuatan besi atau baja",
  },
  {
    value: "261900",
    label:
      "26.19.00 - Terak, sampah, kerak logam dari pembuatan besi atau baja",
  },
  {
    value: "262000",
    label: "26.20.00 - Terak, abu dan residu mengandung logam/arsenik",
  },
  {
    value: "262100",
    label: "26.21.00 - Terak dan abu lainnya termasuk abu rumput laut",
  },
  // Bab 27 - Bahan bakar mineral, minyak mineral
  {
    value: "270000",
    label:
      "27.00.00 - Bahan bakar mineral, minyak mineral dan produk sulingannya",
  },
  {
    value: "270100",
    label:
      "27.01.00 - Batu bara; briket, ovoid dan bahan bakar padat dari batu bara",
  },
  { value: "270200", label: "27.02.00 - Lignit, diaglomerasi maupun tidak" },
  { value: "270300", label: "27.03.00 - Gambut termasuk serasah gambut" },
  {
    value: "270400",
    label: "27.04.00 - Kokas dan semi-kokas dari batu bara/lignit/gambut",
  },
  {
    value: "270500",
    label:
      "27.05.00 - Gas batu bara, gas air, gas produser dan gas semacam itu",
  },
  {
    value: "270600",
    label:
      "27.06.00 - Ter sulingan dari batu bara/lignit/gambut; ter mineral lainnya",
  },
  {
    value: "270700",
    label: "27.07.00 - Minyak dari penyulingan ter batu bara bersuhu tinggi",
  },
  {
    value: "270800",
    label:
      "27.08.00 - Pek dan pek kokas dari ter batu bara/ter mineral lainnya",
  },
  {
    value: "270900",
    label:
      "27.09.00 - Minyak petroleum dan minyak dari mineral mengandung bitumen, mentah",
  },
  {
    value: "271000",
    label: "27.10.00 - Minyak petroleum, selain mentah; minyak sisa",
  },
  {
    value: "271100",
    label: "27.11.00 - Gas petroleum dan gas hidrokarbon lainnya",
  },
  {
    value: "271200",
    label: "27.12.00 - Jeli petroleum; malam parafin; malam petroleum dll",
  },
  {
    value: "271300",
    label: "27.13.00 - Kokas petroleum, bitumen petroleum dan residu lainnya",
  },
  {
    value: "271400",
    label: "27.14.00 - Bitumen dan aspal alam; shale/pasir ter; asphaltite",
  },
  {
    value: "271500",
    label: "27.15.00 - Campuran mengandung bitumen (mastik, cut-back)",
  },
  {
    value: "271600",
    label: "27.16.00 - Bahan bakar padat lainnya dari batu bara",
  },
  // Bab 28 - Bahan kimia anorganik
  {
    value: "280000",
    label: "28.00.00 - Bahan kimia anorganik; senyawa logam mulia/radioaktif",
  },
  { value: "280100", label: "28.01.00 - Fluorin, klorin, bromin dan iodin" },
  {
    value: "280200",
    label: "28.02.00 - Belerang sublimasi/endapan; belerang koloidal",
  },
  {
    value: "280300",
    label: "28.03.00 - Karbon (carbon black dan bentuk karbon lainnya ytdl)",
  },
  {
    value: "280400",
    label: "28.04.00 - Hidrogen, gas mulia dan non logam lainnya",
  },
  {
    value: "280500",
    label: "28.05.00 - Logam alkali/alkali tanah; logam tanah jarang; merkuri",
  },
  {
    value: "280600",
    label: "28.06.00 - Hidrogen klorida (asam klorida); asam klorosulfat",
  },
  { value: "280700", label: "28.07.00 - Asam sulfat; oleum" },
  { value: "280800", label: "28.08.00 - Asam nitrat; asam sulfonitrat" },
  {
    value: "280900",
    label: "28.09.00 - Difosfor pentaoksida; asam fosfat; asam polifosfat",
  },
  { value: "281000", label: "28.10.00 - Oksida boron; asam borat" },
  {
    value: "281100",
    label: "28.11.00 - Asam anorganik lainnya dan senyawa oksigen anorganik",
  },
  {
    value: "281200",
    label: "28.12.00 - Halida dan halida oksida dari bukan logam",
  },
  {
    value: "281300",
    label: "28.13.00 - Sulfida dari bukan logam; fosfor trisulfida komersial",
  },
  {
    value: "281400",
    label: "28.14.00 - Amonia, anhidrat atau dalam larutan air",
  },
  {
    value: "281500",
    label:
      "28.15.00 - Natrium hidroksida (soda api); kalium hidroksida; peroksida",
  },
  {
    value: "281600",
    label:
      "28.16.00 - Hidroksida dan peroksida magnesium; oksida strontium/barium",
  },
  { value: "281700", label: "28.17.00 - Seng oksida; seng peroksida" },
  {
    value: "281800",
    label:
      "28.18.00 - Korundum artifisial; aluminium oksida; aluminium hidroksida",
  },
  { value: "281900", label: "28.19.00 - Kromium oksida dan hidroksida" },
  { value: "282000", label: "28.20.00 - Mangan oksida" },
  {
    value: "282100",
    label: "28.21.00 - Besi oksida dan hidroksida; tanah warna",
  },
  { value: "282200", label: "28.22.00 - Kobalt oksida dan hidroksida" },
  { value: "282300", label: "28.23.00 - Titanium oksida" },
  {
    value: "282400",
    label: "28.24.00 - Timbal oksida; timbal merah dan timbal oranye",
  },
  {
    value: "282500",
    label:
      "28.25.00 - Hidrazin dan hidroksilamin; logam oksida/hidroksida lainnya",
  },
  {
    value: "282600",
    label: "28.26.00 - Fluorida; fluorosilikat; garam fluorin kompleks lainnya",
  },
  {
    value: "282700",
    label: "28.27.00 - Klorida, bromida dan iodida serta oksidanya",
  },
  { value: "282800", label: "28.28.00 - Hipoklorit; klorit; hipobromit" },
  { value: "282900", label: "28.29.00 - Klorat dan perklorat; bromat; iodat" },
  { value: "283000", label: "28.30.00 - Sulfida; polisulfida" },
  { value: "283100", label: "28.31.00 - Ditionit dan sulfoksilat" },
  { value: "283200", label: "28.32.00 - Sulfit; tiosulfat" },
  { value: "283300", label: "28.33.00 - Sulfat; alum; peroksosulfat" },
  { value: "283400", label: "28.34.00 - Nitrit; nitrat" },
  {
    value: "283500",
    label: "28.35.00 - Fosfinat; fosfonat; fosfat; polifosfat",
  },
  {
    value: "283600",
    label: "28.36.00 - Karbonat; peroksokarbonat; amonium karbonat komersial",
  },
  {
    value: "283700",
    label: "28.37.00 - Sianida, sianida oksida dan sianida kompleks",
  },
  {
    value: "283900",
    label: "28.39.00 - Silikat; silikat logam alkali komersial",
  },
  { value: "284000", label: "28.40.00 - Borat; peroksoborat; perborat" },
  {
    value: "284100",
    label: "28.41.00 - Garam dari asam oksometalik atau peroksometalik",
  },
  {
    value: "284200",
    label:
      "28.42.00 - Garam lainnya dari asam anorganik termasuk aluminosilikat",
  },
  {
    value: "284300",
    label: "28.43.00 - Logam mulia koloidal; senyawa logam mulia; amalgam",
  },
  {
    value: "284400",
    label: "28.44.00 - Unsur kimia radioaktif dan isotop radioaktif",
  },
  {
    value: "284500",
    label: "28.45.00 - Isotop selain pos 28.44 dan senyawanya",
  },
  {
    value: "284600",
    label: "28.46.00 - Senyawa logam tanah jarang, itrium atau skandium",
  },
  { value: "284700", label: "28.47.00 - Hidrogen peroksida" },
  { value: "284900", label: "28.49.00 - Karbida" },
  {
    value: "285000",
    label: "28.50.00 - Hidrida, nitrida, azida, silisida dan borida",
  },
  {
    value: "285200",
    label: "28.52.00 - Senyawa anorganik/organik dari merkuri",
  },
  {
    value: "285300",
    label:
      "28.53.00 - Fosfida; senyawa anorganik lainnya; air suling; udara cair",
  },
  // Bab 29 - Bahan kimia organik
  { value: "290000", label: "29.00.00 - Bahan kimia organik" },
  { value: "290100", label: "29.01.00 - Hidrokarbon asiklik" },
  { value: "290200", label: "29.02.00 - Hidrokarbon siklik" },
  { value: "290300", label: "29.03.00 - Turunan halogenasi dari hidrokarbon" },
  {
    value: "290400",
    label:
      "29.04.00 - Turunan sulfonasi, nitrasi atau nitrosasi dari hidrokarbon",
  },
  { value: "290500", label: "29.05.00 - Alkohol asiklik dan turunannya" },
  { value: "290600", label: "29.06.00 - Alkohol siklik dan turunannya" },
  { value: "290700", label: "29.07.00 - Fenol; fenol-alkohol" },
  {
    value: "290800",
    label: "29.08.00 - Turunan dari fenol atau fenol-alkohol",
  },
  {
    value: "290900",
    label: "29.09.00 - Eter, eter-alkohol, eter-fenol; peroksida",
  },
  {
    value: "291000",
    label: "29.10.00 - Epoksida, epoksi alkohol, epoksi fenol dan epoksi eter",
  },
  {
    value: "291100",
    label: "29.11.00 - Asetal dan hemiasetal serta turunannya",
  },
  {
    value: "291200",
    label: "29.12.00 - Aldehida; polimer siklik aldehida; paraformaldehida",
  },
  { value: "291300", label: "29.13.00 - Turunan dari produk pos 29.12" },
  { value: "291400", label: "29.14.00 - Keton dan kinon serta turunannya" },
  {
    value: "291500",
    label: "29.15.00 - Asam monokarboksilat asiklik jenuh dan turunannya",
  },
  {
    value: "291600",
    label:
      "29.16.00 - Asam monokarboksilat asiklik tidak jenuh/siklik dan turunannya",
  },
  { value: "291700", label: "29.17.00 - Asam polikarboksilat dan turunannya" },
  {
    value: "291800",
    label: "29.18.00 - Asam karboksilat dengan fungsi oksigen tambahan",
  },
  { value: "291900", label: "29.19.00 - Ester fosfat dan garamnya" },
  {
    value: "292000",
    label: "29.20.00 - Ester dari asam anorganik bukan logam lainnya",
  },
  { value: "292100", label: "29.21.00 - Senyawa berfungsi amina" },
  { value: "292200", label: "29.22.00 - Senyawa amino berfungsi oksigen" },
  {
    value: "292300",
    label: "29.23.00 - Garam dan hidroksida amonium kuarterner; lesitin",
  },
  {
    value: "292400",
    label: "29.24.00 - Senyawa berfungsi karboksiamida; amida asam karbonat",
  },
  {
    value: "292500",
    label: "29.25.00 - Senyawa berfungsi karboksiimida (sakarin); imina",
  },
  { value: "292600", label: "29.26.00 - Senyawa berfungsi nitril" },
  { value: "292700", label: "29.27.00 - Senyawa diazo-, azo- atau azoksi" },
  {
    value: "292800",
    label: "29.28.00 - Turunan organik dari hidrazin atau hidroksilamina",
  },
  {
    value: "292900",
    label: "29.29.00 - Senyawa dengan fungsi nitrogen lainnya",
  },
  { value: "293000", label: "29.30.00 - Senyawa organo-belerang" },
  { value: "293100", label: "29.31.00 - Senyawa organo-anorganik lainnya" },
  {
    value: "293200",
    label: "29.32.00 - Senyawa heterosiklik dengan hetero atom oksigen",
  },
  {
    value: "293300",
    label: "29.33.00 - Senyawa heterosiklik dengan hetero atom nitrogen",
  },
  {
    value: "293400",
    label: "29.34.00 - Asam nukleat dan garamnya; senyawa heterosiklik lainnya",
  },
  { value: "293500", label: "29.35.00 - Sulfonamida" },
  { value: "293600", label: "29.36.00 - Provitamin dan vitamin" },
  {
    value: "293700",
    label: "29.37.00 - Hormon, prostaglandin, tromboksan dan leukotrien",
  },
  { value: "293800", label: "29.38.00 - Glikosida dan turunannya" },
  { value: "293900", label: "29.39.00 - Alkaloid dan turunannya" },
  {
    value: "294000",
    label: "29.40.00 - Gula murni kimia lainnya; gula eter/asetal/ester",
  },
  { value: "294100", label: "29.41.00 - Antibiotik" },
  { value: "294200", label: "29.42.00 - Senyawa organik lainnya" },
  // Bab 30 - Produk farmasi
  { value: "300000", label: "30.00.00 - Produk farmasi" },
  {
    value: "300100",
    label: "30.01.00 - Kelenjar dan organ untuk terapeutik; heparin",
  },
  {
    value: "300200",
    label: "30.02.00 - Darah manusia/hewan; antiserum; vaksin; toksin; kultur",
  },
  {
    value: "300300",
    label:
      "30.03.00 - Obat (dua atau lebih konstituen), bukan dosis/kemasan eceran",
  },
  {
    value: "300400",
    label: "30.04.00 - Obat dalam dosis tertentu atau kemasan eceran",
  },
  {
    value: "300500",
    label: "30.05.00 - Kapas, kasa, pembalut dan barang semacamnya",
  },
  {
    value: "300600",
    label: "30.06.00 - Barang farmasi yang dirinci dalam Catatan 4 Bab 30",
  },
  // Bab 31 - Pupuk
  { value: "310000", label: "31.00.00 - Pupuk" },
  { value: "310100", label: "31.01.00 - Pupuk hewani atau nabati" },
  {
    value: "310200",
    label: "31.02.00 - Pupuk mineral atau kimia, mengandung nitrogen",
  },
  {
    value: "310300",
    label: "31.03.00 - Pupuk mineral atau kimia, mengandung fosfat",
  },
  {
    value: "310400",
    label: "31.04.00 - Pupuk mineral atau kimia, mengandung kalium",
  },
  {
    value: "310500",
    label: "31.05.00 - Pupuk mineral/kimia dengan dua/tiga unsur penyubur",
  },
  // Bab 32 - Ekstrak penyamak/pencelup; cat
  {
    value: "320000",
    label:
      "32.00.00 - Ekstrak penyamak/pencelup; bahan pewarna; cat dan pernis; tinta",
  },
  {
    value: "320100",
    label: "32.01.00 - Ekstrak penyamak dari bahan nabati; tanin dan garamnya",
  },
  {
    value: "320200",
    label:
      "32.02.00 - Zat penyamak organik sintetik/anorganik; preparat penyamak",
  },
  {
    value: "320300",
    label: "32.03.00 - Bahan pewarna dari nabati atau hewani",
  },
  { value: "320400", label: "32.04.00 - Bahan pewarna organik sintetik" },
  {
    value: "320500",
    label: "32.05.00 - Lak warna; preparat berdasarkan lak warna",
  },
  {
    value: "320600",
    label: "32.06.00 - Bahan pewarna lainnya; produk anorganik luminofor",
  },
  {
    value: "320700",
    label:
      "32.07.00 - Pigmen olahan; glasir; frit kaca dan kaca lainnya bentuk bubuk",
  },
  {
    value: "320800",
    label: "32.08.00 - Cat dan pernis dari polimer dalam media bukan air",
  },
  {
    value: "320900",
    label: "32.09.00 - Cat dan pernis dari polimer dalam media air",
  },
  {
    value: "321000",
    label: "32.10.00 - Cat dan pernis lainnya; pigmen air olahan",
  },
  { value: "321100", label: "32.11.00 - Olahan pengering (prepared driers)" },
  {
    value: "321200",
    label:
      "32.12.00 - Pigmen termasuk bubuk/serpih metalik; stamping foil; bahan celup",
  },
  {
    value: "321300",
    label:
      "32.13.00 - Pewarna untuk seniman, pelajar atau pelukis papan petunjuk",
  },
  {
    value: "321400",
    label:
      "32.14.00 - Dempul kaca, semen resin, kompon mendempul dan mastik lainnya",
  },
  {
    value: "321500",
    label: "32.15.00 - Tinta cetak, tinta tulis/gambar dan tinta lainnya",
  },
  // Bab 33 - Minyak atsiri dan resinoida; kosmetika
  {
    value: "330000",
    label:
      "33.00.00 - Minyak atsiri dan resinoida; preparat wewangian, kosmetika atau rias",
  },
  {
    value: "330100",
    label: "33.01.00 - Minyak atsiri; resinoida; ekstrak oleoresin",
  },
  {
    value: "330200",
    label: "33.02.00 - Campuran zat bau-bauan untuk industri/minuman",
  },
  { value: "330300", label: "33.03.00 - Parfum dan cairan pewangi" },
  {
    value: "330400",
    label: "33.04.00 - Preparat kecantikan/rias dan perawatan kulit",
  },
  { value: "330500", label: "33.05.00 - Preparat untuk rambut" },
  {
    value: "330600",
    label: "33.06.00 - Preparat kesehatan mulut atau gigi; dental floss",
  },
  {
    value: "330700",
    label: "33.07.00 - Preparat cukur, deodoran, mandi, perontok bulu dll",
  },
  // Bab 34 - Sabun, surfaktan, lilin
  {
    value: "340000",
    label:
      "34.00.00 - Sabun, bahan aktif permukaan, preparat pembersih, lilin dll",
  },
  {
    value: "340100",
    label:
      "34.01.00 - Sabun; produk/preparat aktif permukaan organik sebagai sabun",
  },
  {
    value: "340200",
    label:
      "34.02.00 - Bahan aktif permukaan organik selain sabun; preparat pencuci",
  },
  {
    value: "340300",
    label: "34.03.00 - Preparat pelumas (cutting-oil, anti-karat dll)",
  },
  { value: "340400", label: "34.04.00 - Malam artifisial dan malam olahan" },
  {
    value: "340500",
    label:
      "34.05.00 - Poles dan krim untuk alas kaki, perabotan, lantai, logam dll",
  },
  { value: "340600", label: "34.06.00 - Lilin, taper dan sejenisnya" },
  {
    value: "340700",
    label:
      "34.07.00 - Pasta untuk model; preparat untuk gigi dengan dasar plester",
  },
  // Bab 35 - Zat albumina; pati dimodifikasi; perekat; enzim
  {
    value: "350000",
    label: "35.00.00 - Zat albumina; pati dimodifikasi; perekat; enzim",
  },
  {
    value: "350100",
    label: "35.01.00 - Kasein, kaseinat dan turunan kasein; lem kasein",
  },
  {
    value: "350200",
    label: "35.02.00 - Albumin; albuminat dan turunan albumin lainnya",
  },
  {
    value: "350300",
    label: "35.03.00 - Gelatin dan turunannya; isinglass; lem hewani lainnya",
  },
  {
    value: "350400",
    label:
      "35.04.00 - Pepton dan turunannya; zat protein lainnya; bubuk kulit jangat",
  },
  {
    value: "350500",
    label: "35.05.00 - Dekstrin dan pati dimodifikasi lainnya; lem dari pati",
  },
  {
    value: "350600",
    label: "35.06.00 - Lem olahan dan perekat olahan lainnya ytdl",
  },
  { value: "350700", label: "35.07.00 - Enzim; enzim olahan ytdl" },
  // Bab 36 - Bahan peledak; piroteknik; korek api
  {
    value: "360000",
    label:
      "36.00.00 - Bahan peledak; produk piroteknik; korek api; paduan piroforik",
  },
  { value: "360100", label: "36.01.00 - Bubuk propelan" },
  {
    value: "360200",
    label: "36.02.00 - Bahan peledak olahan, selain bubuk propelan",
  },
  {
    value: "360300",
    label: "36.03.00 - Sekering pengaman; kabel peledak; detonator listrik",
  },
  {
    value: "360400",
    label:
      "36.04.00 - Kembang api, suar pemberi sinyal dan barang piroteknik lainnya",
  },
  {
    value: "360500",
    label: "36.05.00 - Korek api, selain barang piroteknik pos 36.04",
  },
  {
    value: "360600",
    label:
      "36.06.00 - Ferro-cerium dan paduan piroforik lainnya; bahan mudah terbakar",
  },
  // Bab 37 - Barang fotografi atau sinematografi
  { value: "370000", label: "37.00.00 - Barang fotografi atau sinematografi" },
  {
    value: "370100",
    label:
      "37.01.00 - Pelat dan film fotografi lembaran, peka cahaya, tidak disinari",
  },
  {
    value: "370200",
    label:
      "37.02.00 - Film fotografi dalam gulungan, peka cahaya, tidak disinari",
  },
  {
    value: "370300",
    label:
      "37.03.00 - Kertas, kertas karton dan tekstil fotografi, peka cahaya",
  },
  {
    value: "370400",
    label:
      "37.04.00 - Pelat, film, kertas fotografi, disinari tetapi tidak dicuci",
  },
  {
    value: "370500",
    label: "37.05.00 - Pelat dan film fotografi, disinari dan dicuci",
  },
  {
    value: "370600",
    label: "37.06.00 - Film sinematografi, disinari dan dicuci",
  },
  { value: "370700", label: "37.07.00 - Preparat kimia untuk fotografi" },
  // Bab 38 - Aneka produk kimia
  { value: "380000", label: "38.00.00 - Aneka produk kimia" },
  {
    value: "380100",
    label:
      "38.01.00 - Grafit artifisial; grafit koloidal; preparat berbasis grafit",
  },
  {
    value: "380200",
    label: "38.02.00 - Karbon aktif; produk mineral alam aktif; jelaga hewani",
  },
  { value: "380300", label: "38.03.00 - Minyak tall, dimurnikan maupun tidak" },
  {
    value: "380400",
    label: "38.04.00 - Residu alkali dari pembuatan pulp kayu; lignin sulfonat",
  },
  {
    value: "380500",
    label: "38.05.00 - Getah, terpentin kayu/sulfat dan minyak terpena lainnya",
  },
  {
    value: "380600",
    label: "38.06.00 - Asam rosin dan asam damar serta turunannya; run gum",
  },
  {
    value: "380700",
    label: "38.07.00 - Ter kayu; kreosot kayu; nafta kayu; pek nabati",
  },
  {
    value: "380800",
    label:
      "38.08.00 - Insektisida, rodentisida, fungisida, herbisida, desinfektan dll",
  },
  {
    value: "380900",
    label:
      "38.09.00 - Bahan penyempurnaan; pembawa bahan celup; dressing dan mordant",
  },
  {
    value: "381000",
    label:
      "38.10.00 - Preparat untuk permukaan logam; flux untuk menyolder/mengelas",
  },
  {
    value: "381100",
    label:
      "38.11.00 - Aditif untuk minyak mineral (anti-knock, anti-korosi dll)",
  },
  {
    value: "381200",
    label:
      "38.12.00 - Akselerator karet; peliat; stabilisator untuk karet/plastik",
  },
  {
    value: "381300",
    label: "38.13.00 - Preparat dan bahan pengisi alat pemadam kebakaran",
  },
  {
    value: "381400",
    label: "38.14.00 - Pelarut dan pengencer organik; penghapus cat/pernis",
  },
  {
    value: "381500",
    label: "38.15.00 - Inisiator reaksi, akselerator dan katalisator",
  },
  {
    value: "381600",
    label: "38.16.00 - Semen, mortar, beton tahan api; campuran adukan dolomit",
  },
  {
    value: "381700",
    label: "38.17.00 - Campuran alkilbenzena dan alkilnaftalena",
  },
  {
    value: "381800",
    label: "38.18.00 - Unsur/senyawa kimia diolah untuk elektronik",
  },
  {
    value: "381900",
    label: "38.19.00 - Cairan rem hidrolik dan cairan untuk transmisi hidrolik",
  },
  {
    value: "382000",
    label: "38.20.00 - Preparat anti beku dan cairan untuk mencairkan es",
  },
  {
    value: "382100",
    label: "38.21.00 - Media kultur olahan untuk mikroorganisme/sel",
  },
  {
    value: "382200",
    label:
      "38.22.00 - Reagen diagnosa atau laboratorium; bahan referensi bersertifikat",
  },
  {
    value: "382300",
    label:
      "38.23.00 - Asam lemak monokarboksilat industri; alkohol lemak industri",
  },
  {
    value: "382400",
    label: "38.24.00 - Olahan pengikat untuk acuan; produk kimia industri ytdl",
  },
  {
    value: "382500",
    label:
      "38.25.00 - Produk residu industri kimia ytdl; limbah; sewage sludge",
  },
  { value: "382600", label: "38.26.00 - Biodiesel dan campurannya" },
  {
    value: "382700",
    label:
      "38.27.00 - Campuran turunan halogenasi dari metana, etana atau propana",
  },
  // Bab 39 - Plastik dan barang daripadanya
  { value: "390000", label: "39.00.00 - Plastik dan barang daripadanya" },
  {
    value: "390100",
    label: "39.01.00 - Polimer dari etilena, dalam bentuk asal",
  },
  {
    value: "390200",
    label: "39.02.00 - Polimer dari propilena atau olefin lainnya, bentuk asal",
  },
  {
    value: "390300",
    label: "39.03.00 - Polimer dari stirena, dalam bentuk asal",
  },
  {
    value: "390400",
    label:
      "39.04.00 - Polimer dari vinil klorida atau olefin halogenasi lainnya",
  },
  {
    value: "390500",
    label: "39.05.00 - Polimer dari vinil asetat atau vinil ester lainnya",
  },
  { value: "390600", label: "39.06.00 - Polimer akrilik dalam bentuk asal" },
  {
    value: "390700",
    label:
      "39.07.00 - Poliasetal, polieter, resin epoksida, polikarbonat, poliester",
  },
  { value: "390800", label: "39.08.00 - Poliamida dalam bentuk asal" },
  {
    value: "390900",
    label: "39.09.00 - Amino-resin, resin fenolik dan poliuretan, bentuk asal",
  },
  { value: "391000", label: "39.10.00 - Silikon dalam bentuk asal" },
  {
    value: "391100",
    label: "39.11.00 - Resin petroleum, kumaron-indena, politerpena dll",
  },
  {
    value: "391200",
    label: "39.12.00 - Selulosa dan turunan kimianya ytdl, bentuk asal",
  },
  {
    value: "391300",
    label: "39.13.00 - Polimer alam dan polimer alam dimodifikasi, bentuk asal",
  },
  {
    value: "391400",
    label: "39.14.00 - Penukar ion dari polimer pos 39.01-39.13",
  },
  { value: "391500", label: "39.15.00 - Sisa, reja dan skrap dari plastik" },
  {
    value: "391600",
    label: "39.16.00 - Monofilamen, batang kecil, stik dan profil dari plastik",
  },
  {
    value: "391700",
    label:
      "39.17.00 - Pembuluh, pipa dan selang serta kelengkapannya dari plastik",
  },
  {
    value: "391800",
    label: "39.18.00 - Penutup lantai/dinding/langit-langit dari plastik",
  },
  {
    value: "391900",
    label:
      "39.19.00 - Pelat, lembaran, film, foil, pita berperekat dari plastik",
  },
  {
    value: "392000",
    label:
      "39.20.00 - Pelat, lembaran, film, foil dan strip lain dari plastik, non seluler",
  },
  {
    value: "392100",
    label:
      "39.21.00 - Pelat, lembaran, film, foil dan strip lainnya dari plastik",
  },
  {
    value: "392200",
    label:
      "39.22.00 - Bak mandi, wastafel, kloset dan perlengkapan saniter dari plastik",
  },
  {
    value: "392300",
    label: "39.23.00 - Wadah untuk mengangkut/mengemas barang dari plastik",
  },
  {
    value: "392400",
    label:
      "39.24.00 - Perangkat makan, dapur dan peralatan rumah tangga dari plastik",
  },
  { value: "392500", label: "39.25.00 - Perangkat bangunan dari plastik ytdl" },
  {
    value: "392600",
    label: "39.26.00 - Barang lain dari plastik dan dari bahan pos 39.01-39.14",
  },
  // Bab 40 - Karet dan barang daripadanya
  { value: "400000", label: "40.00.00 - Karet dan barang daripadanya" },
  {
    value: "400100",
    label:
      "40.01.00 - Karet alam, balata, getah perca, guayule, chicle, bentuk asal",
  },
  {
    value: "400200",
    label: "40.02.00 - Karet sintetik dan factice dari minyak, bentuk asal",
  },
  {
    value: "400300",
    label:
      "40.03.00 - Reclaimed rubber dalam bentuk asal atau pelat/lembaran/strip",
  },
  {
    value: "400400",
    label:
      "40.04.00 - Sisa, reja dan skrap karet selain karet keras; bubuk/butir",
  },
  {
    value: "400500",
    label: "40.05.00 - Karet campuran, tidak divulkanisasi, bentuk asal",
  },
  {
    value: "400600",
    label:
      "40.06.00 - Bentuk lain dari karet tidak divulkanisasi (batang, pembuluh dll)",
  },
  { value: "400700", label: "40.07.00 - Benang dan tali karet divulkanisasi" },
  {
    value: "400800",
    label:
      "40.08.00 - Pelat, lembaran, strip, batang dan profil dari karet divulkanisasi",
  },
  {
    value: "400900",
    label: "40.09.00 - Pembuluh, pipa dan selang dari karet divulkanisasi",
  },
  {
    value: "401000",
    label:
      "40.10.00 - Ban atau belting pengangkut/penggerak dari karet divulkanisasi",
  },
  { value: "401100", label: "40.11.00 - Ban bertekanan, baru, dari karet" },
  {
    value: "401200",
    label:
      "40.12.00 - Ban bertekanan bekas/ditelapaki ulang; ban padat; telapak ban",
  },
  { value: "401300", label: "40.13.00 - Ban dalam, dari karet" },
  {
    value: "401400",
    label: "40.14.00 - Barang higienis atau farmasi termasuk dot, dari karet",
  },
  {
    value: "401500",
    label:
      "40.15.00 - Pakaian dan aksesori (termasuk sarung tangan) dari karet",
  },
  {
    value: "401600",
    label: "40.16.00 - Barang lain dari karet divulkanisasi selain karet keras",
  },
  {
    value: "401700",
    label: "40.17.00 - Karet keras (ebonit) dan barang daripadanya",
  },
  // Bab 41 - Jangat dan kulit mentah
  {
    value: "410000",
    label:
      "41.00.00 - Jangat dan kulit mentah selain kulit berbulu dan kulit samak",
  },
  {
    value: "410100",
    label:
      "41.01.00 - Hide dan skin mentah dari lembu/kerbau atau hewan jenis kuda",
  },
  {
    value: "410200",
    label: "41.02.00 - Skin mentah dari biri-biri atau biri-biri muda",
  },
  { value: "410300", label: "41.03.00 - Hide dan skin mentah lainnya" },
  {
    value: "410400",
    label: "41.04.00 - Hide dan skin lembu/kuda disamak atau crust, tanpa bulu",
  },
  {
    value: "410500",
    label: "41.05.00 - Skin biri-biri disamak atau crust, tanpa wol",
  },
  {
    value: "410600",
    label: "41.06.00 - Hide dan skin hewan lainnya disamak atau crust",
  },
  {
    value: "410700",
    label: "41.07.00 - Kulit samak lembu/kuda diolah lebih lanjut, tanpa bulu",
  },
  {
    value: "411200",
    label: "41.12.00 - Kulit samak biri-biri diolah lebih lanjut, tanpa wol",
  },
  {
    value: "411300",
    label: "41.13.00 - Kulit samak hewan lainnya diolah lebih lanjut",
  },
  {
    value: "411400",
    label: "41.14.00 - Kulit chamois; kulit paten dan kulit dilapisi logam",
  },
  {
    value: "411500",
    label:
      "41.15.00 - Kulit komposisi; reja dan sisa kulit samak; debu/bubuk/tepung kulit",
  },
  // Bab 42 - Barang dari kulit samak; saddlery; tas
  {
    value: "420000",
    label:
      "42.00.00 - Barang dari kulit samak; saddlery; barang bepergian; tas",
  },
  {
    value: "420100",
    label: "42.01.00 - Saddlery dan harness untuk semua binatang",
  },
  {
    value: "420200",
    label: "42.02.00 - Peti, koper, tas tangan, dompet dan kemasan semacam itu",
  },
  {
    value: "420300",
    label: "42.03.00 - Pakaian dan aksesori pakaian dari kulit samak/komposisi",
  },
  {
    value: "420500",
    label: "42.05.00 - Barang lainnya dari kulit samak atau kulit komposisi",
  },
  {
    value: "420600",
    label:
      "42.06.00 - Barang dari usus, kulit goldbeater, kandung kemih atau urat",
  },
  // Bab 43 - Kulit berbulu dan bulu artifisial
  {
    value: "430000",
    label:
      "43.00.00 - Kulit berbulu dan bulu artifisial serta barang daripadanya",
  },
  { value: "430100", label: "43.01.00 - Kulit berbulu mentah" },
  {
    value: "430200",
    label: "43.02.00 - Kulit berbulu disamak atau dikerjakan",
  },
  {
    value: "430300",
    label: "43.03.00 - Pakaian, aksesori dan barang lainnya dari kulit berbulu",
  },
  {
    value: "430400",
    label: "43.04.00 - Bulu artifisial dan barang daripadanya",
  },
  // Bab 44 - Kayu dan barang dari kayu; arang kayu
  {
    value: "440000",
    label: "44.00.00 - Kayu dan barang dari kayu; arang kayu",
  },
  {
    value: "440100",
    label:
      "44.01.00 - Kayu bakar; kayu dalam bentuk keping/pecahan; serbuk gergaji",
  },
  { value: "440200", label: "44.02.00 - Arang kayu termasuk arang tempurung" },
  {
    value: "440300",
    label: "44.03.00 - Kayu kasar, dihilangkan kulit/gubalnya maupun tidak",
  },
  {
    value: "440400",
    label:
      "44.04.00 - Kayu simpai; galah; tiang pancang; tongkat kayu; kepingan kayu",
  },
  { value: "440500", label: "44.05.00 - Wol kayu; tepung kayu" },
  {
    value: "440600",
    label: "44.06.00 - Bantalan (cross-tie) rel kereta api atau trem dari kayu",
  },
  {
    value: "440700",
    label: "44.07.00 - Kayu digergaji/dibelah memanjang, tebal melebihi 6 mm",
  },
  {
    value: "440800",
    label:
      "44.08.00 - Lembaran untuk veneering; kayu untuk kayu lapis, tebal <= 6 mm",
  },
  {
    value: "440900",
    label:
      "44.09.00 - Kayu (strip/frieze) untuk lantai papan, dibentuk tidak terputus",
  },
  {
    value: "441000",
    label: "44.10.00 - Papan partikel, papan OSB dan papan semacam itu",
  },
  {
    value: "441100",
    label:
      "44.11.00 - Papan fiber dari kayu atau bahan mengandung lignin lainnya",
  },
  {
    value: "441200",
    label:
      "44.12.00 - Kayu lapis, panel veneer dan kayu dilaminasi semacam itu",
  },
  {
    value: "441300",
    label:
      "44.13.00 - Kayu dipadatkan, berbentuk blok, pelat, strip atau profil",
  },
  {
    value: "441400",
    label:
      "44.14.00 - Bingkai kayu untuk lukisan, foto, cermin atau benda semacam itu",
  },
  {
    value: "441500",
    label: "44.15.00 - Peti, kotak, krat, drum dan pengemas dari kayu; palet",
  },
  {
    value: "441600",
    label:
      "44.16.00 - Tahang, tong, bejana, pasu dan produk pembuat tong dari kayu",
  },
  {
    value: "441700",
    label:
      "44.17.00 - Perkakas, gagang perkakas, badan/gagang sapu/sikat dari kayu",
  },
  {
    value: "441800",
    label: "44.18.00 - Produk pertukangan dan bahan bangunan rumah dari kayu",
  },
  {
    value: "441900",
    label: "44.19.00 - Perangkat makan dan perangkat dapur dari kayu",
  },
  {
    value: "442000",
    label:
      "44.20.00 - Tatakan kayu dan kayu bertatah; patung kecil; perabotan kayu",
  },
  { value: "442100", label: "44.21.00 - Barang lainnya dari kayu" },
  // Bab 45 - Gabus dan barang dari gabus
  { value: "450000", label: "45.00.00 - Gabus dan barang dari gabus" },
  {
    value: "450100",
    label: "45.01.00 - Gabus alam, mentah atau diolah sederhana; gabus sisa",
  },
  {
    value: "450200",
    label:
      "45.02.00 - Gabus alam dikupas atau dibentuk; blok, pelat, lembaran atau strip",
  },
  { value: "450300", label: "45.03.00 - Barang dari gabus alam" },
  {
    value: "450400",
    label: "45.04.00 - Gabus diaglomerasi dan barang daripadanya",
  },
  // Bab 46 - Barang dari jerami, esparto dan bahan anyaman lainnya
  {
    value: "460000",
    label:
      "46.00.00 - Barang dari jerami/esparto/anyaman lainnya; keranjang dan anyaman",
  },
  {
    value: "460100",
    label:
      "46.01.00 - Anyaman dan produk dari bahan anyaman (mat, matting, tirai)",
  },
  {
    value: "460200",
    label:
      "46.02.00 - Keranjang, barang anyaman dan barang lainnya; barang dari loofah",
  },
  // Bab 47 - Pulp dari kayu; kertas pulihan
  {
    value: "470000",
    label:
      "47.00.00 - Pulp dari kayu/bahan selulosa berserat; kertas/karton pulihan",
  },
  { value: "470100", label: "47.01.00 - Pulp kayu mekanik" },
  { value: "470200", label: "47.02.00 - Pulp kayu kimia, dissolving grade" },
  {
    value: "470300",
    label:
      "47.03.00 - Pulp kayu kimia, soda atau sulfat, selain dissolving grade",
  },
  {
    value: "470400",
    label: "47.04.00 - Pulp kayu kimia, sulfit, selain dissolving grade",
  },
  {
    value: "470500",
    label: "47.05.00 - Pulp kayu dari kombinasi proses mekanik dan kimia",
  },
  {
    value: "470600",
    label:
      "47.06.00 - Pulp dari serat kertas/karton pulihan atau bahan selulosa lainnya",
  },
  {
    value: "470700",
    label: "47.07.00 - Kertas atau kertas karton pulihan, sisa dan skrap",
  },
  // Bab 48 - Kertas dan kertas karton
  {
    value: "480000",
    label:
      "48.00.00 - Kertas dan kertas karton; barang dari pulp kertas/kertas/karton",
  },
  {
    value: "480100",
    label: "48.01.00 - Kertas koran, dalam gulungan atau lembaran",
  },
  {
    value: "480200",
    label: "48.02.00 - Kertas/karton tidak dilapisi untuk penulisan/pencetakan",
  },
  {
    value: "480300",
    label:
      "48.03.00 - Kertas toilet/tisu, handuk, serbet untuk rumah tangga/saniter",
  },
  {
    value: "480400",
    label: "48.04.00 - Kertas kraft dan kertas karton tidak dilapisi",
  },
  {
    value: "480500",
    label: "48.05.00 - Kertas dan kertas karton tidak dilapisi lainnya",
  },
  {
    value: "480600",
    label:
      "48.06.00 - Perkamen nabati, kertas tahan lemak, kertas kalkir, glasin",
  },
  {
    value: "480700",
    label: "48.07.00 - Kertas/karton komposit direkatkan dengan perekat",
  },
  {
    value: "480800",
    label:
      "48.08.00 - Kertas/karton bergelombang, dikisutkan, diembos atau dilubangi",
  },
  {
    value: "480900",
    label:
      "48.09.00 - Kertas karbon, kertas self-copy dan kertas transfer lainnya",
  },
  {
    value: "481000",
    label:
      "48.10.00 - Kertas/karton dilapisi kaolin atau zat anorganik lainnya",
  },
  {
    value: "481100",
    label:
      "48.11.00 - Kertas/karton dilapisi, diresapi, diwarnai atau dicetak ytdl",
  },
  {
    value: "481200",
    label: "48.12.00 - Blok, lempengan dan pelat saring dari pulp kertas",
  },
  {
    value: "481300",
    label:
      "48.13.00 - Kertas sigaret, dipotong/bentuk buklet atau tabung maupun tidak",
  },
  {
    value: "481400",
    label:
      "48.14.00 - Wallpaper dan penutup dinding; kertas transparansi jendela",
  },
  {
    value: "481600",
    label:
      "48.16.00 - Kertas karbon/self-copy/transfer lainnya; stensil; pelat offset",
  },
  {
    value: "481700",
    label: "48.17.00 - Amplop, kartu surat, kartu pos polos; kotak alat tulis",
  },
  {
    value: "481800",
    label:
      "48.18.00 - Kertas toilet; saputangan; tisu; handuk; seprei dari kertas",
  },
  {
    value: "481900",
    label: "48.19.00 - Kardus, kotak, peti, tas dan kemasan dari kertas/karton",
  },
  {
    value: "482000",
    label:
      "48.20.00 - Buku daftar/kas/catatan; map; formulir; album; sampul buku",
  },
  {
    value: "482100",
    label: "48.21.00 - Label kertas atau kertas karton dari segala jenis",
  },
  {
    value: "482200",
    label:
      "48.22.00 - Bobbin, kelos, cop dan alat penunjang dari pulp/kertas/karton",
  },
  {
    value: "482300",
    label:
      "48.23.00 - Kertas/karton lainnya dipotong; barang lain dari pulp/kertas",
  },
  // Bab 49 - Buku, koran, gambar cetakan
  {
    value: "490000",
    label:
      "49.00.00 - Buku, koran, gambar cetakan dan produk industri percetakan",
  },
  {
    value: "490100",
    label:
      "49.01.00 - Buku cetakan, brosur, selebaran dan barang cetakan semacam itu",
  },
  { value: "490200", label: "49.02.00 - Koran, jurnal dan majalah berkala" },
  {
    value: "490300",
    label:
      "49.03.00 - Buku bergambar, menggambar atau mewarnai untuk anak-anak",
  },
  {
    value: "490400",
    label: "49.04.00 - Buku musik, dicetak atau dalam bentuk manuskrip",
  },
  {
    value: "490500",
    label:
      "49.05.00 - Peta dan peta hidrografi; atlas; peta dinding; bola dunia",
  },
  {
    value: "490600",
    label:
      "49.06.00 - Rancangan dan gambar untuk arsitektur/permesinan/industri",
  },
  {
    value: "490700",
    label:
      "49.07.00 - Perangko, meterai; uang kertas; cek; sertifikat saham/obligasi",
  },
  { value: "490800", label: "49.08.00 - Gambar tempel (decalcomania)" },
  {
    value: "490900",
    label: "49.09.00 - Kartu pos dicetak; kartu ucapan, pesan atau pengumuman",
  },
  {
    value: "491000",
    label:
      "49.10.00 - Berbagai jenis kalender, dicetak, termasuk blok kalender",
  },
  {
    value: "491100",
    label: "49.11.00 - Barang cetakan lainnya termasuk gambar dan foto cetakan",
  },
  // Bab 50 - Sutra
  { value: "500000", label: "50.00.00 - Sutra" },
  {
    value: "500100",
    label: "50.01.00 - Kepompong ulat sutra cocok untuk digulung",
  },
  { value: "500200", label: "50.02.00 - Sutra mentah tidak dipintal" },
  {
    value: "500300",
    label: "50.03.00 - Sisa sutra termasuk kepompong tidak cocok digulung",
  },
  {
    value: "500400",
    label:
      "50.04.00 - Benang sutra (selain dari sisa sutra), tidak untuk eceran",
  },
  {
    value: "500500",
    label: "50.05.00 - Benang pintal dari sisa sutra, tidak untuk eceran",
  },
  {
    value: "500600",
    label: "50.06.00 - Benang sutra untuk eceran; benang ulat sutra",
  },
  {
    value: "500700",
    label: "50.07.00 - Kain tenunan dari sutra atau sisa sutra",
  },
  // Bab 51 - Wol, bulu hewan
  {
    value: "510000",
    label:
      "51.00.00 - Wol, bulu hewan halus/kasar; benang bulu kuda dan kain tenunan",
  },
  { value: "510100", label: "51.01.00 - Wol, tidak digaruk atau disisir" },
  {
    value: "510200",
    label: "51.02.00 - Bulu hewan halus atau kasar, tidak digaruk atau disisir",
  },
  {
    value: "510300",
    label: "51.03.00 - Sisa dari wol atau bulu hewan halus/kasar",
  },
  {
    value: "510400",
    label: "51.04.00 - Garnetted stock dari wol atau bulu hewan halus/kasar",
  },
  {
    value: "510500",
    label: "51.05.00 - Wol dan bulu hewan halus/kasar, digaruk atau disisir",
  },
  {
    value: "510600",
    label: "51.06.00 - Benang dari wol digaruk, tidak untuk eceran",
  },
  {
    value: "510700",
    label: "51.07.00 - Benang dari wol disisir, tidak untuk eceran",
  },
  {
    value: "510800",
    label:
      "51.08.00 - Benang dari bulu hewan halus digaruk/disisir, tidak untuk eceran",
  },
  {
    value: "510900",
    label: "51.09.00 - Benang dari wol atau bulu hewan halus, untuk eceran",
  },
  {
    value: "511000",
    label: "51.10.00 - Benang dari bulu hewan kasar atau bulu kuda",
  },
  {
    value: "511100",
    label: "51.11.00 - Kain tenunan dari wol/bulu hewan halus digaruk",
  },
  {
    value: "511200",
    label: "51.12.00 - Kain tenunan dari wol/bulu hewan halus disisir",
  },
  {
    value: "511300",
    label: "51.13.00 - Kain tenunan dari bulu hewan kasar atau bulu kuda",
  },
  // Bab 52 - Kapas
  { value: "520000", label: "52.00.00 - Kapas" },
  { value: "520100", label: "52.01.00 - Kapas, tidak digaruk atau disisir" },
  {
    value: "520200",
    label: "52.02.00 - Sisa kapas termasuk sisa benang dan garnetted stock",
  },
  { value: "520300", label: "52.03.00 - Kapas, digaruk atau disisir" },
  { value: "520400", label: "52.04.00 - Benang jahit dari kapas" },
  {
    value: "520500",
    label: "52.05.00 - Benang kapas (kapas >=85%), tidak untuk eceran",
  },
  {
    value: "520600",
    label: "52.06.00 - Benang kapas (kapas <85%), tidak untuk eceran",
  },
  {
    value: "520700",
    label: "52.07.00 - Benang kapas selain benang jahit, untuk eceran",
  },
  {
    value: "520800",
    label: "52.08.00 - Kain tenunan kapas (>=85%), <=200 g/m2",
  },
  {
    value: "520900",
    label: "52.09.00 - Kain tenunan kapas (>=85%), >200 g/m2",
  },
  {
    value: "521000",
    label:
      "52.10.00 - Kain tenunan kapas (<85%) campur serat buatan, <=200 g/m2",
  },
  {
    value: "521100",
    label:
      "52.11.00 - Kain tenunan kapas (<85%) campur serat buatan, >200 g/m2",
  },
  { value: "521200", label: "52.12.00 - Kain tenunan lainnya dari kapas" },
  // Bab 53 - Serat tekstil nabati lainnya
  {
    value: "530000",
    label:
      "53.00.00 - Serat tekstil nabati lainnya; benang kertas dan kain tenunannya",
  },
  {
    value: "530100",
    label: "53.01.00 - Lena (flax), mentah atau diolah tetapi tidak dipintal",
  },
  {
    value: "530200",
    label:
      "53.02.00 - True hemp (Cannabis sativa), mentah atau diolah tetapi tidak dipintal",
  },
  {
    value: "530300",
    label: "53.03.00 - Serat jute dan serat tekstil kulit pohon lainnya",
  },
  {
    value: "530500",
    label:
      "53.05.00 - Serat kelapa, abaca, rami dan serat tekstil nabati lainnya",
  },
  { value: "530600", label: "53.06.00 - Benang lena" },
  {
    value: "530700",
    label:
      "53.07.00 - Benang dari serat jute atau serat tekstil kulit pohon lainnya",
  },
  {
    value: "530800",
    label: "53.08.00 - Benang dari serat tekstil nabati lainnya; benang kertas",
  },
  { value: "530900", label: "53.09.00 - Kain tenunan dari lena" },
  {
    value: "531000",
    label: "53.10.00 - Kain tenunan dari serat jute atau kulit pohon lainnya",
  },
  {
    value: "531100",
    label:
      "53.11.00 - Kain tenunan dari serat tekstil nabati lainnya; benang kertas",
  },
  // Bab 54 - Filamen buatan
  {
    value: "540000",
    label: "54.00.00 - Filamen buatan; strip dari bahan tekstil buatan",
  },
  { value: "540100", label: "54.01.00 - Benang jahit dari filamen buatan" },
  {
    value: "540200",
    label:
      "54.02.00 - Benang filamen sintetik selain benang jahit, tidak untuk eceran",
  },
  {
    value: "540300",
    label:
      "54.03.00 - Benang filamen artifisial selain benang jahit, tidak untuk eceran",
  },
  {
    value: "540400",
    label: "54.04.00 - Monofilamen sintetik >=67 desiteks; strip",
  },
  {
    value: "540500",
    label: "54.05.00 - Monofilamen artifisial >=67 desiteks; strip",
  },
  {
    value: "540600",
    label: "54.06.00 - Benang filamen buatan selain benang jahit, untuk eceran",
  },
  {
    value: "540700",
    label: "54.07.00 - Kain tenunan dari benang filamen sintetik",
  },
  {
    value: "540800",
    label: "54.08.00 - Kain tenunan dari benang filamen artifisial",
  },
  // Bab 55 - Serat stapel buatan
  { value: "550000", label: "55.00.00 - Serat stapel buatan" },
  { value: "550100", label: "55.01.00 - Tow filamen sintetik" },
  { value: "550200", label: "55.02.00 - Tow filamen artifisial" },
  {
    value: "550300",
    label:
      "55.03.00 - Serat stapel sintetik, tidak digaruk/disisir untuk dipintal",
  },
  {
    value: "550400",
    label:
      "55.04.00 - Serat stapel artifisial, tidak digaruk/disisir untuk dipintal",
  },
  {
    value: "550500",
    label: "55.05.00 - Sisa serat buatan termasuk noil dan garnetted stock",
  },
  {
    value: "550600",
    label: "55.06.00 - Serat stapel sintetik, digaruk/disisir untuk dipintal",
  },
  {
    value: "550700",
    label: "55.07.00 - Serat stapel artifisial, digaruk/disisir untuk dipintal",
  },
  {
    value: "550800",
    label: "55.08.00 - Benang jahit dari serat stapel buatan",
  },
  {
    value: "550900",
    label: "55.09.00 - Benang dari serat stapel sintetik, tidak untuk eceran",
  },
  {
    value: "551000",
    label: "55.10.00 - Benang dari serat stapel artifisial, tidak untuk eceran",
  },
  {
    value: "551100",
    label: "55.11.00 - Benang dari serat stapel buatan, untuk eceran",
  },
  {
    value: "551200",
    label: "55.12.00 - Kain tenunan serat stapel sintetik (>=85%)",
  },
  {
    value: "551300",
    label:
      "55.13.00 - Kain tenunan serat stapel sintetik (<85%) campur kapas, <=170 g/m2",
  },
  {
    value: "551400",
    label:
      "55.14.00 - Kain tenunan serat stapel sintetik (<85%) campur kapas, >170 g/m2",
  },
  {
    value: "551500",
    label: "55.15.00 - Kain tenunan lainnya dari serat stapel sintetik",
  },
  {
    value: "551600",
    label: "55.16.00 - Kain tenunan dari serat stapel artifisial",
  },
  // Bab 56 - Gumpalan, kain kempa, bukan tenunan; tali
  {
    value: "560000",
    label:
      "56.00.00 - Gumpalan, kain kempa dan bukan tenunan; benang khusus; tali, tambang",
  },
  {
    value: "560100",
    label: "56.01.00 - Gumpalan bahan tekstil; flock, debu tekstil",
  },
  { value: "560200", label: "56.02.00 - Kain kempa (felt)" },
  { value: "560300", label: "56.03.00 - Bukan tenunan (nonwovens)" },
  {
    value: "560400",
    label:
      "56.04.00 - Benang dan tali karet ditutupi tekstil; benang tekstil dilapisi",
  },
  { value: "560500", label: "56.05.00 - Benang berlogam (metallised yarn)" },
  {
    value: "560600",
    label: "56.06.00 - Benang berpalut (gimped yarn); benang chenille",
  },
  {
    value: "560700",
    label: "56.07.00 - Benang pintal, tali, tambang dan kabel",
  },
  {
    value: "560800",
    label:
      "56.08.00 - Jaring disimpul; jaring ikan dan jaring lainnya dari bahan tekstil",
  },
  {
    value: "560900",
    label: "56.09.00 - Barang dari benang, tali, tambang atau kabel ytdl",
  },
  // Bab 57 - Karpet
  {
    value: "570000",
    label: "57.00.00 - Karpet dan tekstil penutup lantai lainnya",
  },
  {
    value: "570100",
    label: "57.01.00 - Karpet dan penutup lantai tekstil disimpul",
  },
  {
    value: "570200",
    label:
      "57.02.00 - Karpet tenunan, tidak berumbai (termasuk Kelem, Schumacks)",
  },
  { value: "570300", label: "57.03.00 - Karpet berumbai (tufted)" },
  {
    value: "570400",
    label: "57.04.00 - Karpet dari kain kempa, tidak berumbai",
  },
  {
    value: "570500",
    label: "57.05.00 - Karpet dan penutup lantai tekstil lainnya",
  },
  // Bab 58 - Kain tenunan khusus; renda; sulaman
  {
    value: "580000",
    label:
      "58.00.00 - Kain tenunan khusus; kain berjumbai; renda; permadani dinding; sulaman",
  },
  {
    value: "580100",
    label: "58.01.00 - Kain tenunan berbulu dan kain chenille",
  },
  {
    value: "580200",
    label: "58.02.00 - Terry towelling; kain tekstil berumbai",
  },
  { value: "580300", label: "58.03.00 - Kasa (gauze)" },
  {
    value: "580400",
    label: "58.04.00 - Kain tule dan kain jaring lainnya; renda",
  },
  {
    value: "580500",
    label:
      "58.05.00 - Permadani dinding tenunan tangan (Gobelin, Flander, Aubusson dll)",
  },
  { value: "580600", label: "58.06.00 - Kain pita tenunan" },
  {
    value: "580700",
    label:
      "58.07.00 - Label, lencana dan barang dari bahan tekstil, tidak disulam",
  },
  {
    value: "580800",
    label: "58.08.00 - Kain jalinan; perapih hiasan; jumbai, pompon",
  },
  {
    value: "580900",
    label: "58.09.00 - Kain tenunan dari benang logam/berlogam pos 56.05",
  },
  {
    value: "581000",
    label: "58.10.00 - Kain sulaman dalam lembaran, strip atau motif",
  },
  {
    value: "581100",
    label: "58.11.00 - Quilted textile products dalam lembaran",
  },
  // Bab 59 - Kain tekstil diresapi/dilapisi; tekstil teknis
  {
    value: "590000",
    label:
      "59.00.00 - Kain tekstil diresapi/dilapisi/dilaminasi; barang tekstil untuk industri",
  },
  {
    value: "590100",
    label:
      "59.01.00 - Kain tekstil dilapisi perekat/pati; kain kalkir; kanvas lukis; buckram",
  },
  {
    value: "590200",
    label: "59.02.00 - Kain untuk ban (tyre cord) dari nilon/poliester/rayon",
  },
  {
    value: "590300",
    label: "59.03.00 - Kain tekstil diresapi/dilapisi dengan plastik",
  },
  {
    value: "590400",
    label:
      "59.04.00 - Linoleum; penutup lantai dengan lapisan di atas dasar tekstil",
  },
  { value: "590500", label: "59.05.00 - Penutup dinding tekstil" },
  { value: "590600", label: "59.06.00 - Kain tekstil berkaret" },
  {
    value: "590700",
    label:
      "59.07.00 - Kain tekstil diresapi/dilapisi secara lain; kanvas dilukis (layar pentas)",
  },
  {
    value: "590800",
    label: "59.08.00 - Sumbu tekstil untuk lampu/kompor; kaos lampu gas pijar",
  },
  {
    value: "590900",
    label: "59.09.00 - Selang tekstil dan tabung tekstil semacam itu",
  },
  {
    value: "591000",
    label: "59.10.00 - Ban/belting penggerak/pengangkut dari bahan tekstil",
  },
  {
    value: "591100",
    label: "59.11.00 - Produk dan barang tekstil untuk penggunaan teknis",
  },
  // Bab 60 - Kain rajutan atau kaitan
  { value: "600000", label: "60.00.00 - Kain rajutan atau kain kaitan" },
  {
    value: "600100",
    label: "60.01.00 - Kain berbulu (pile) rajutan atau kaitan; kain terry",
  },
  {
    value: "600200",
    label:
      "60.02.00 - Kain rajutan/kaitan lebar <=30 cm, benang elastomer/karet >=5%",
  },
  {
    value: "600300",
    label: "60.03.00 - Kain rajutan/kaitan lebar <=30 cm lainnya",
  },
  {
    value: "600400",
    label:
      "60.04.00 - Kain rajutan/kaitan lebar >30 cm, benang elastomer/karet >=5%",
  },
  { value: "600500", label: "60.05.00 - Kain rajut lusi (warp knit)" },
  { value: "600600", label: "60.06.00 - Kain rajutan atau kaitan lainnya" },
  // Bab 61 - Pakaian rajutan/kaitan
  {
    value: "610000",
    label: "61.00.00 - Pakaian dan aksesori pakaian, rajutan atau kaitan",
  },
  {
    value: "610100",
    label:
      "61.01.00 - Mantel panjang/jaket dll, pria/anak laki-laki, rajutan/kaitan",
  },
  {
    value: "610200",
    label:
      "61.02.00 - Mantel panjang/jaket dll, wanita/anak perempuan, rajutan/kaitan",
  },
  {
    value: "610300",
    label:
      "61.03.00 - Setelan, jas, celana panjang dll, pria/anak laki-laki, rajutan",
  },
  {
    value: "610400",
    label:
      "61.04.00 - Setelan, gaun, rok, celana dll, wanita/anak perempuan, rajutan",
  },
  {
    value: "610500",
    label: "61.05.00 - Kemeja pria atau anak laki-laki, rajutan/kaitan",
  },
  {
    value: "610600",
    label: "61.06.00 - Blus, kemeja wanita atau anak perempuan, rajutan/kaitan",
  },
  {
    value: "610700",
    label:
      "61.07.00 - Celana dalam, piyama, pakaian mandi dll, pria, rajutan/kaitan",
  },
  {
    value: "610800",
    label:
      "61.08.00 - Rok dalam, panty, gaun malam, piyama dll, wanita, rajutan/kaitan",
  },
  {
    value: "610900",
    label:
      "61.09.00 - T-shirt, singlet dan kaus kutang lainnya, rajutan/kaitan",
  },
  {
    value: "611000",
    label: "61.10.00 - Jersey, pullover, cardigan, rompi, rajutan/kaitan",
  },
  {
    value: "611100",
    label: "61.11.00 - Garmen dan aksesori pakaian untuk bayi, rajutan/kaitan",
  },
  {
    value: "611200",
    label: "61.12.00 - Track suit, ski suit dan pakaian renang, rajutan/kaitan",
  },
  {
    value: "611300",
    label: "61.13.00 - Garmen dari kain rajutan/kaitan pos 59.03/59.06/59.07",
  },
  { value: "611400", label: "61.14.00 - Garmen lainnya, rajutan atau kaitan" },
  {
    value: "611500",
    label:
      "61.15.00 - Panty hose, stocking, kaus kaki dan hosiery lainnya, rajutan/kaitan",
  },
  {
    value: "611600",
    label: "61.16.00 - Sarung tangan, mitten dan mitt, rajutan/kaitan",
  },
  {
    value: "611700",
    label: "61.17.00 - Aksesori pakaian jadi lainnya, rajutan/kaitan",
  },
  // Bab 62 - Pakaian bukan rajutan/kaitan
  {
    value: "620000",
    label: "62.00.00 - Pakaian dan aksesori pakaian, bukan rajutan atau kaitan",
  },
  {
    value: "620100",
    label: "62.01.00 - Mantel panjang/jaket dll, pria/anak laki-laki",
  },
  {
    value: "620200",
    label: "62.02.00 - Mantel panjang/jaket dll, wanita/anak perempuan",
  },
  {
    value: "620300",
    label: "62.03.00 - Setelan, jas, celana panjang dll, pria/anak laki-laki",
  },
  {
    value: "620400",
    label: "62.04.00 - Setelan, gaun, rok, celana dll, wanita/anak perempuan",
  },
  { value: "620500", label: "62.05.00 - Kemeja pria atau anak laki-laki" },
  {
    value: "620600",
    label: "62.06.00 - Blus, kemeja wanita atau anak perempuan",
  },
  {
    value: "620700",
    label: "62.07.00 - Singlet, celana dalam, piyama dll, pria/anak laki-laki",
  },
  {
    value: "620800",
    label:
      "62.08.00 - Singlet, petticoat, panty, gaun malam dll, wanita/anak perempuan",
  },
  { value: "620900", label: "62.09.00 - Garmen dan aksesori pakaian bayi" },
  {
    value: "621000",
    label: "62.10.00 - Garmen dari kain pos 56.02/56.03/59.03/59.06/59.07",
  },
  {
    value: "621100",
    label: "62.11.00 - Track suit, ski suit dan pakaian renang; garmen lainnya",
  },
  {
    value: "621200",
    label: "62.12.00 - Brassiere, girdle, korset, brace, suspender, garter",
  },
  { value: "621300", label: "62.13.00 - Saputangan" },
  {
    value: "621400",
    label: "62.14.00 - Syal, scarf, muffler, mantilla, veil dan sejenisnya",
  },
  { value: "621500", label: "62.15.00 - Dasi, dasi kupu-kupu dan cravat" },
  { value: "621600", label: "62.16.00 - Sarung tangan, mitten dan mitt" },
  {
    value: "621700",
    label: "62.17.00 - Aksesori pakaian jadi lainnya; bagian garmen",
  },
  // Bab 63 - Barang tekstil jadi lainnya; pakaian bekas
  {
    value: "630000",
    label:
      "63.00.00 - Barang tekstil sudah jadi lainnya; pakaian bekas; gombal",
  },
  {
    value: "630100",
    label: "63.01.00 - Selimut dan selimut kecil untuk perjalanan",
  },
  {
    value: "630200",
    label: "63.02.00 - Linen untuk tempat tidur, meja, toilet dan dapur",
  },
  {
    value: "630300",
    label: "63.03.00 - Tirai termasuk gorden dan kerai dalam",
  },
  {
    value: "630400",
    label: "63.04.00 - Barang perabotan lainnya (selain pos 94.04)",
  },
  {
    value: "630500",
    label: "63.05.00 - Kantong dan karung untuk membungkus barang",
  },
  {
    value: "630600",
    label:
      "63.06.00 - Terpal, awning, kerai matahari; tenda; layar; barang berkemah",
  },
  {
    value: "630700",
    label: "63.07.00 - Barang jadi lainnya termasuk pola pakaian",
  },
  {
    value: "630800",
    label:
      "63.08.00 - Set kain tenunan dan benang untuk dibuat barang tekstil, eceran",
  },
  {
    value: "630900",
    label: "63.09.00 - Pakaian bekas dan barang bekas lainnya",
  },
  {
    value: "631000",
    label:
      "63.10.00 - Rag bekas/baru; skrap dari benang, tali, tambang atau kabel",
  },
  // Bab 64 - Alas kaki
  {
    value: "640000",
    label: "64.00.00 - Alas kaki, pelindung kaki dan bagiannya",
  },
  {
    value: "640100",
    label:
      "64.01.00 - Alas kaki tahan air dengan sol dan bagian atas karet/plastik",
  },
  {
    value: "640200",
    label:
      "64.02.00 - Alas kaki lainnya dengan sol dan bagian atas karet/plastik",
  },
  {
    value: "640300",
    label:
      "64.03.00 - Alas kaki dengan sol karet/plastik/kulit dan bagian atas kulit",
  },
  {
    value: "640400",
    label:
      "64.04.00 - Alas kaki dengan sol karet/plastik/kulit dan bagian atas tekstil",
  },
  { value: "640500", label: "64.05.00 - Alas kaki lainnya" },
  {
    value: "640600",
    label: "64.06.00 - Bagian dari alas kaki; sol dalam; pelindung kaki",
  },
  // Bab 65 - Tutup kepala
  { value: "650000", label: "65.00.00 - Tutup kepala dan bagiannya" },
  {
    value: "650100",
    label: "65.01.00 - Bentuk topi, badan topi dan tudung topi dari kain kempa",
  },
  {
    value: "650200",
    label: "65.02.00 - Model topi dianyam atau dirakit dari strip",
  },
  {
    value: "650400",
    label: "65.04.00 - Topi dan tutup kepala dianyam atau dirakit dari strip",
  },
  {
    value: "650500",
    label:
      "65.05.00 - Topi dan tutup kepala rajutan/kaitan atau dari renda/kain kempa",
  },
  { value: "650600", label: "65.06.00 - Tutup kepala lainnya" },
  {
    value: "650700",
    label: "65.07.00 - Ikat kepala, pelapis, tutup, dasar dan rangka topi",
  },
  // Bab 66 - Payung, tongkat jalan
  {
    value: "660000",
    label:
      "66.00.00 - Payung, tongkat jalan, tongkat duduk, cambuk dan bagiannya",
  },
  { value: "660100", label: "66.01.00 - Payung dan payung panas" },
  {
    value: "660200",
    label:
      "66.02.00 - Tongkat jalan, tongkat duduk, cambuk, pecut dan sejenisnya",
  },
  {
    value: "660300",
    label: "66.03.00 - Bagian, hiasan dan aksesori barang pos 66.01 atau 66.02",
  },
  // Bab 67 - Bulu unggas olahan; bunga artifisial
  {
    value: "670000",
    label:
      "67.00.00 - Bulu unggas olahan; bunga artifisial; barang dari rambut manusia",
  },
  {
    value: "670100",
    label:
      "67.01.00 - Kulit dan bagian unggas dengan bulu; bulu dan barang daripadanya",
  },
  {
    value: "670200",
    label: "67.02.00 - Bunga, daun dan buah artifisial serta bagiannya",
  },
  {
    value: "670300",
    label: "67.03.00 - Rambut manusia ditata/ditipiskan; wol/bulu untuk wig",
  },
  {
    value: "670400",
    label:
      "67.04.00 - Wig, jenggot, alis dan bulu mata palsu; barang dari rambut manusia",
  },
  // Bab 68 - Barang dari batu, plester, semen, asbes, mika
  {
    value: "680000",
    label:
      "68.00.00 - Barang dari batu, plester, semen, asbes, mika atau bahan semacam itu",
  },
  {
    value: "680100",
    label:
      "68.01.00 - Batu jalan, batu tepi jalan dan batu ubin dari batu alam",
  },
  {
    value: "680200",
    label: "68.02.00 - Batu monumen dan batu bangunan dikerjakan; kubus mosaik",
  },
  {
    value: "680300",
    label: "68.03.00 - Batu sabak dikerjakan dan barang dari batu sabak",
  },
  {
    value: "680400",
    label: "68.04.00 - Batu giling, batu asah, roda gerinda dan sejenisnya",
  },
  {
    value: "680500",
    label:
      "68.05.00 - Bubuk/butir gosok alam/artifisial dengan dasar tekstil/kertas",
  },
  {
    value: "680600",
    label:
      "68.06.00 - Wol terak, wol batuan, wol mineral; bahan mineral isolasi",
  },
  {
    value: "680700",
    label: "68.07.00 - Barang dari aspal atau bahan semacam itu",
  },
  {
    value: "680800",
    label:
      "68.08.00 - Panel, papan, ubin, blok dari serat nabati/serutan kayu diaglomerasi",
  },
  {
    value: "680900",
    label: "68.09.00 - Barang dari plester atau dari komposisinya",
  },
  {
    value: "681000",
    label: "68.10.00 - Barang dari semen, beton atau batu artifisial",
  },
  {
    value: "681100",
    label:
      "68.11.00 - Barang dari semen asbes, semen serat selulosa atau sejenisnya",
  },
  {
    value: "681200",
    label: "68.12.00 - Serat asbes pabrikasi; barang dari campuran asbes",
  },
  {
    value: "681300",
    label:
      "68.13.00 - Bahan friksi dan barang daripadanya (untuk rem, kopling dll)",
  },
  { value: "681400", label: "68.14.00 - Mika dikerjakan dan barang dari mika" },
  {
    value: "681500",
    label:
      "68.15.00 - Barang dari batu atau bahan mineral lainnya termasuk serat karbon",
  },
  // Bab 69 - Produk keramik
  { value: "690000", label: "69.00.00 - Produk keramik" },
  {
    value: "690100",
    label:
      "69.01.00 - Batu bata, blok, ubin dan barang keramik dari tanah diatomea",
  },
  {
    value: "690200",
    label:
      "69.02.00 - Batu bata, blok, ubin dan keramik tahan panas untuk konstruksi",
  },
  {
    value: "690300",
    label:
      "69.03.00 - Barang keramik tahan panas lainnya (retor, cawan lebur, mofel dll)",
  },
  {
    value: "690400",
    label:
      "69.04.00 - Batu bata bangunan, blok lantai, ubin penopang/pengisi dari keramik",
  },
  {
    value: "690500",
    label:
      "69.05.00 - Ubin atap, cerobong, lapisan cerobong, orn arsitektur dari keramik",
  },
  {
    value: "690600",
    label: "69.06.00 - Pipa, saluran, talang dan kelengkapan pipa dari keramik",
  },
  {
    value: "690700",
    label:
      "69.07.00 - Ubin dan paving, ubin perapian/dinding dari keramik; kubus mozaik",
  },
  {
    value: "690900",
    label:
      "69.09.00 - Barang keramik untuk laboratorium/kimia; palung, pot keramik",
  },
  {
    value: "691000",
    label:
      "69.10.00 - Bak cuci, wastafel, bak mandi, kloset dan perlengkapan saniter keramik",
  },
  {
    value: "691100",
    label:
      "69.11.00 - Perangkat makan, dapur dan toilet dari porselin atau keramik cina",
  },
  {
    value: "691200",
    label:
      "69.12.00 - Perangkat makan, dapur dan toilet dari keramik (selain porselin/cina)",
  },
  {
    value: "691300",
    label: "69.13.00 - Patung dan barang keramik ornamen lainnya",
  },
  { value: "691400", label: "69.14.00 - Barang keramik lainnya" },
  // Bab 70 - Kaca dan barang dari kaca
  { value: "700000", label: "70.00.00 - Kaca dan barang dari kaca" },
  {
    value: "700100",
    label:
      "70.01.00 - Pecahan dan sisa/skrap kaca (cullet); kaca bentuk butiran",
  },
  {
    value: "700200",
    label:
      "70.02.00 - Kaca bentuk bola, batang kecil atau tabung, tidak dikerjakan",
  },
  {
    value: "700300",
    label: "70.03.00 - Kaca tuang dan rolled glass, lembaran atau profil",
  },
  {
    value: "700400",
    label: "70.04.00 - Kaca tarik dan kaca tiup, dalam lembaran",
  },
  {
    value: "700500",
    label: "70.05.00 - Kaca apung dan kaca digosok/dipoles, dalam lembaran",
  },
  {
    value: "700600",
    label:
      "70.06.00 - Kaca pos 70.03/70.04/70.05 dibengkokkan, diukir, dibor dll",
  },
  {
    value: "700700",
    label: "70.07.00 - Kaca pengaman (tempered atau dilaminasi)",
  },
  {
    value: "700800",
    label: "70.08.00 - Kaca dinding isolasi berlapis (multiple-walled)",
  },
  {
    value: "700900",
    label: "70.09.00 - Cermin kaca, dibingkai maupun tidak; kaca spion",
  },
  {
    value: "701000",
    label:
      "70.10.00 - Carboy, botol, termos, kendi, ampul dan kemasan dari kaca",
  },
  {
    value: "701100",
    label:
      "70.11.00 - Sungkup kaca (bulb dan tabung) untuk lampu/tabung sinar katoda",
  },
  {
    value: "701300",
    label: "70.13.00 - Barang kaca untuk meja, dapur, toilet, dekorasi",
  },
  {
    value: "701400",
    label: "70.14.00 - Barang kaca pemberi sinyal dan elemen optik dari kaca",
  },
  {
    value: "701500",
    label: "70.15.00 - Kaca jam/arloji; kaca kacamata; bola kaca berongga",
  },
  {
    value: "701600",
    label:
      "70.16.00 - Paving blok, batu bata, ubin dari kaca padat/tuang; kaca multi seluler",
  },
  {
    value: "701700",
    label: "70.17.00 - Barang kaca laboratorium, higienis atau farmasi",
  },
  {
    value: "701800",
    label:
      "70.18.00 - Manik-manik, mutiara/batu mulia imitasi; barang kecil dari kaca",
  },
  {
    value: "701900",
    label:
      "70.19.00 - Serat kaca (glass fibres) termasuk wol kaca dan barang daripadanya",
  },
  { value: "702000", label: "70.20.00 - Barang lainnya dari kaca" },
  // Bab 71 - Mutiara, batu mulia, logam mulia; perhiasan; koin
  {
    value: "710000",
    label:
      "71.00.00 - Mutiara, batu mulia, logam mulia dan barang daripadanya; perhiasan imitasi; koin",
  },
  { value: "710100", label: "71.01.00 - Mutiara alam atau budidaya" },
  {
    value: "710200",
    label: "71.02.00 - Intan, dikerjakan maupun tidak, tidak dipasang/disusun",
  },
  {
    value: "710300",
    label: "71.03.00 - Batu mulia selain intan dan batu semi mulia",
  },
  {
    value: "710400",
    label: "71.04.00 - Batu mulia/semi mulia sintetik atau direkonstruksi",
  },
  {
    value: "710500",
    label: "71.05.00 - Debu dan bubuk dari batu mulia/semi mulia",
  },
  {
    value: "710600",
    label:
      "71.06.00 - Perak (termasuk disepuh emas/platina), tidak ditempa/setengah jadi",
  },
  {
    value: "710700",
    label: "71.07.00 - Logam tidak mulia dipalut perak, setengah jadi",
  },
  {
    value: "710800",
    label:
      "71.08.00 - Emas (termasuk disepuh platina), tidak ditempa/setengah jadi",
  },
  {
    value: "710900",
    label: "71.09.00 - Logam tidak mulia/perak dipalut emas, setengah jadi",
  },
  {
    value: "711000",
    label: "71.10.00 - Platina, tidak ditempa atau setengah jadi",
  },
  {
    value: "711100",
    label:
      "71.11.00 - Logam tidak mulia/perak/emas dipalut platina, setengah jadi",
  },
  {
    value: "711200",
    label:
      "71.12.00 - Sisa dan skrap logam mulia atau logam dipalut logam mulia",
  },
  {
    value: "711300",
    label: "71.13.00 - Barang perhiasan dan bagiannya dari logam mulia",
  },
  {
    value: "711400",
    label: "71.14.00 - Barang pandai emas/perak dan bagiannya dari logam mulia",
  },
  { value: "711500", label: "71.15.00 - Barang lainnya dari logam mulia" },
  {
    value: "711600",
    label:
      "71.16.00 - Barang dari mutiara, batu mulia/semi mulia alam/sintetik",
  },
  { value: "711700", label: "71.17.00 - Perhiasan imitasi" },
  { value: "711800", label: "71.18.00 - Koin" },
  // Bab 72 - Besi dan baja
  { value: "720000", label: "72.00.00 - Besi dan baja" },
  {
    value: "720100",
    label: "72.01.00 - Besi pig dan besi cermin (spiegeleisen)",
  },
  { value: "720200", label: "72.02.00 - Paduan fero (ferro-alloys)" },
  {
    value: "720300",
    label: "72.03.00 - Produk fero reduksi langsung; besi spon",
  },
  {
    value: "720400",
    label: "72.04.00 - Sisa dan skrap fero; ingot peleburan kembali",
  },
  {
    value: "720500",
    label: "72.05.00 - Butir dan bubuk dari besi pig/besi/baja",
  },
  {
    value: "720600",
    label: "72.06.00 - Besi dan baja bukan paduan, bentuk ingot/bentuk asal",
  },
  {
    value: "720700",
    label: "72.07.00 - Produk setengah jadi dari besi/baja bukan paduan",
  },
  {
    value: "720800",
    label:
      "72.08.00 - Canai lantaian besi/baja bukan paduan, lebar >=600 mm, panas",
  },
  {
    value: "720900",
    label:
      "72.09.00 - Canai lantaian besi/baja bukan paduan, lebar >=600 mm, dingin",
  },
  {
    value: "721000",
    label:
      "72.10.00 - Canai lantaian besi/baja bukan paduan, lebar >=600 mm, dipalut/dilapisi",
  },
  {
    value: "721100",
    label:
      "72.11.00 - Canai lantaian besi/baja bukan paduan, lebar <600 mm, tidak dilapisi",
  },
  {
    value: "721200",
    label:
      "72.12.00 - Canai lantaian besi/baja bukan paduan, lebar <600 mm, dilapisi",
  },
  {
    value: "721300",
    label:
      "72.13.00 - Batang dicanai panas, gulungan tidak beraturan, besi/baja bukan paduan",
  },
  {
    value: "721400",
    label:
      "72.14.00 - Batang lainnya besi/baja bukan paduan, ditempa/dicanai panas",
  },
  {
    value: "721500",
    label:
      "72.15.00 - Batang dan batang kecil lainnya dari besi/baja bukan paduan",
  },
  {
    value: "721600",
    label: "72.16.00 - Angle, shape dan section dari besi/baja bukan paduan",
  },
  { value: "721700", label: "72.17.00 - Kawat besi atau baja bukan paduan" },
  {
    value: "721800",
    label: "72.18.00 - Baja stainless bentuk ingot/asal; produk setengah jadi",
  },
  {
    value: "721900",
    label: "72.19.00 - Canai lantaian baja stainless, lebar >=600 mm",
  },
  {
    value: "722000",
    label: "72.20.00 - Canai lantaian baja stainless, lebar <600 mm",
  },
  {
    value: "722100",
    label:
      "72.21.00 - Batang dicanai panas, gulungan tidak beraturan, baja stainless",
  },
  {
    value: "722200",
    label: "72.22.00 - Batang lainnya, angle/shape/section dari baja stainless",
  },
  { value: "722300", label: "72.23.00 - Kawat dari baja stainless" },
  {
    value: "722400",
    label: "72.24.00 - Baja paduan lainnya ingot/asal; produk setengah jadi",
  },
  {
    value: "722500",
    label: "72.25.00 - Canai lantaian baja paduan lainnya, lebar >=600 mm",
  },
  {
    value: "722600",
    label: "72.26.00 - Canai lantaian baja paduan lainnya, lebar <600 mm",
  },
  {
    value: "722700",
    label:
      "72.27.00 - Batang dicanai panas, gulungan tidak beraturan, baja paduan lainnya",
  },
  {
    value: "722800",
    label:
      "72.28.00 - Batang lainnya, angle/shape/section baja paduan; batang bor berongga",
  },
  { value: "722900", label: "72.29.00 - Kawat dari baja paduan lainnya" },
  // Bab 73 - Barang dari besi atau baja
  { value: "730000", label: "73.00.00 - Barang dari besi atau baja" },
  {
    value: "730100",
    label: "73.01.00 - Sheet piling dari besi/baja; angle/shape/section dilas",
  },
  {
    value: "730200",
    label: "73.02.00 - Bahan konstruksi rel kereta api/trem dari besi/baja",
  },
  {
    value: "730300",
    label: "73.03.00 - Pembuluh, pipa dan profil berongga dari besi tuang",
  },
  {
    value: "730400",
    label:
      "73.04.00 - Pembuluh, pipa dan profil berongga tanpa kampuh dari besi/baja",
  },
  {
    value: "730500",
    label:
      "73.05.00 - Pembuluh dan pipa lainnya, penampang lingkaran, diameter >406,4 mm",
  },
  {
    value: "730600",
    label:
      "73.06.00 - Pembuluh, pipa dan profil berongga lainnya dari besi/baja",
  },
  {
    value: "730700",
    label: "73.07.00 - Alat kelengkapan pembuluh atau pipa dari besi/baja",
  },
  {
    value: "730800",
    label:
      "73.08.00 - Struktur dan bagiannya dari besi/baja (jembatan, menara, pintu dll)",
  },
  {
    value: "730900",
    label:
      "73.09.00 - Reservoir, tangki, tong dari besi/baja, kapasitas >300 liter",
  },
  {
    value: "731000",
    label:
      "73.10.00 - Tangki, drum, kaleng, kotak dari besi/baja, kapasitas <=300 liter",
  },
  {
    value: "731100",
    label: "73.11.00 - Kemasan untuk gas bertekanan/dicairkan dari besi/baja",
  },
  {
    value: "731200",
    label:
      "73.12.00 - Kawat dipilin, tali, kabel, sling dari besi/baja, tidak diisolasi",
  },
  {
    value: "731300",
    label: "73.13.00 - Kawat berduri dari besi/baja; kawat untuk pagar",
  },
  {
    value: "731400",
    label:
      "73.14.00 - Kain (anyaman kisi, jaring, pagar) dari kawat besi/baja; expanded metal",
  },
  { value: "731500", label: "73.15.00 - Rantai dan bagiannya dari besi/baja" },
  {
    value: "731600",
    label: "73.16.00 - Jangkar, jangkar kecil dan bagiannya dari besi/baja",
  },
  {
    value: "731700",
    label:
      "73.17.00 - Paku, pasak, paku payung, kokot dan barang semacam itu dari besi/baja",
  },
  {
    value: "731800",
    label:
      "73.18.00 - Sekrup, baut, mur, paku keling, cincin pipih dll dari besi/baja",
  },
  {
    value: "731900",
    label:
      "73.19.00 - Jarum jahit/rajut, jarum kait, pin pengaman dari besi/baja",
  },
  {
    value: "732000",
    label: "73.20.00 - Pegas dan daun untuk pegas dari besi/baja",
  },
  {
    value: "732100",
    label:
      "73.21.00 - Tungku, kompor, alat masak rumah tangga tanpa listrik dari besi/baja",
  },
  {
    value: "732200",
    label:
      "73.22.00 - Radiator pemanasan sentral; pemanas udara dari besi/baja",
  },
  {
    value: "732300",
    label:
      "73.23.00 - Barang untuk meja/dapur/rumah tangga dari besi/baja; wol besi/baja",
  },
  {
    value: "732400",
    label: "73.24.00 - Perangkat saniter dan bagiannya dari besi/baja",
  },
  {
    value: "732500",
    label: "73.25.00 - Barang tuangan lainnya dari besi atau baja",
  },
  { value: "732600", label: "73.26.00 - Barang lainnya dari besi atau baja" },
  // Bab 74 - Tembaga
  { value: "740000", label: "74.00.00 - Tembaga dan barang daripadanya" },
  {
    value: "740100",
    label: "74.01.00 - Mate tembaga; tembaga semen; tembaga endapan",
  },
  {
    value: "740200",
    label: "74.02.00 - Tembaga tidak dimurnikan; anoda tembaga",
  },
  {
    value: "740300",
    label: "74.03.00 - Tembaga dimurnikan dan paduan tembaga, tidak ditempa",
  },
  { value: "740400", label: "74.04.00 - Sisa dan skrap tembaga" },
  { value: "740500", label: "74.05.00 - Paduan utama dari tembaga" },
  { value: "740600", label: "74.06.00 - Bubuk dan serpih tembaga" },
  {
    value: "740700",
    label: "74.07.00 - Batang, batang kecil dan profil tembaga",
  },
  { value: "740800", label: "74.08.00 - Kawat tembaga" },
  {
    value: "740900",
    label: "74.09.00 - Pelat, lembaran dan strip tembaga, tebal >0,15 mm",
  },
  { value: "741000", label: "74.10.00 - Foil tembaga, tebal <=0,15 mm" },
  { value: "741100", label: "74.11.00 - Pembuluh dan pipa tembaga" },
  {
    value: "741200",
    label: "74.12.00 - Alat kelengkapan pembuluh atau pipa tembaga",
  },
  {
    value: "741300",
    label:
      "74.13.00 - Kawat dipilin, kabel, ban anyaman dari tembaga, tidak diisolasi",
  },
  {
    value: "741500",
    label: "74.15.00 - Paku, sekrup, baut, mur, paku keling dari tembaga",
  },
  {
    value: "741800",
    label:
      "74.18.00 - Barang untuk meja/dapur/rumah tangga dari tembaga; perangkat saniter",
  },
  { value: "741900", label: "74.19.00 - Barang lainnya dari tembaga" },
  // Bab 75 - Nikel
  { value: "750000", label: "75.00.00 - Nikel dan barang daripadanya" },
  {
    value: "750100",
    label: "75.01.00 - Mate nikel, sinter oksida nikel dan produk antara nikel",
  },
  { value: "750200", label: "75.02.00 - Nikel tidak ditempa" },
  { value: "750300", label: "75.03.00 - Sisa dan skrap nikel" },
  { value: "750400", label: "75.04.00 - Bubuk dan serpih nikel" },
  {
    value: "750500",
    label: "75.05.00 - Batang, batang kecil, profil dan kawat nikel",
  },
  {
    value: "750600",
    label: "75.06.00 - Pelat, lembaran, strip dan foil nikel",
  },
  {
    value: "750700",
    label: "75.07.00 - Pembuluh, pipa dan kelengkapan pipa dari nikel",
  },
  { value: "750800", label: "75.08.00 - Barang lainnya dari nikel" },
  // Bab 76 - Aluminium
  { value: "760000", label: "76.00.00 - Aluminium dan barang daripadanya" },
  { value: "760100", label: "76.01.00 - Aluminium tidak ditempa" },
  { value: "760200", label: "76.02.00 - Sisa dan skrap aluminium" },
  { value: "760300", label: "76.03.00 - Bubuk dan serpih aluminium" },
  {
    value: "760400",
    label: "76.04.00 - Batang, batang kecil dan profil aluminium",
  },
  { value: "760500", label: "76.05.00 - Kawat aluminium" },
  {
    value: "760600",
    label: "76.06.00 - Pelat, lembaran dan strip aluminium, tebal >0,2 mm",
  },
  { value: "760700", label: "76.07.00 - Aluminium foil, tebal <=0,2 mm" },
  { value: "760800", label: "76.08.00 - Pembuluh dan pipa aluminium" },
  {
    value: "760900",
    label: "76.09.00 - Alat kelengkapan pembuluh atau pipa aluminium",
  },
  {
    value: "761000",
    label:
      "76.10.00 - Struktur aluminium dan bagiannya (jembatan, menara, pintu dll)",
  },
  {
    value: "761100",
    label:
      "76.11.00 - Reservoir, tangki, tong dari aluminium, kapasitas >300 liter",
  },
  {
    value: "761200",
    label:
      "76.12.00 - Tahang, drum, kaleng, kotak dari aluminium, kapasitas <=300 liter",
  },
  {
    value: "761300",
    label:
      "76.13.00 - Tempat penyimpanan dari aluminium untuk gas bertekanan/dicairkan",
  },
  {
    value: "761400",
    label:
      "76.14.00 - Kawat pilin, kabel, ban anyaman dari aluminium, tidak diisolasi",
  },
  {
    value: "761500",
    label:
      "76.15.00 - Barang untuk meja/dapur/rumah tangga dari aluminium; perangkat saniter",
  },
  { value: "761600", label: "76.16.00 - Barang lainnya dari aluminium" },
  // Bab 78 - Timbal
  { value: "780000", label: "78.00.00 - Timbal dan barang daripadanya" },
  { value: "780100", label: "78.01.00 - Timbal tidak ditempa" },
  { value: "780200", label: "78.02.00 - Sisa dan skrap timbal" },
  {
    value: "780400",
    label:
      "78.04.00 - Pelat, lembaran, strip dan foil timbal; bubuk dan serpih timbal",
  },
  { value: "780600", label: "78.06.00 - Barang lainnya dari timbal" },
  // Bab 79 - Seng
  { value: "790000", label: "79.00.00 - Seng dan barang daripadanya" },
  { value: "790100", label: "79.01.00 - Seng tidak ditempa" },
  { value: "790200", label: "79.02.00 - Sisa dan skrap seng" },
  { value: "790300", label: "79.03.00 - Debu, bubuk dan serpihan seng" },
  {
    value: "790400",
    label: "79.04.00 - Batang, batang kecil, profil dan kawat seng",
  },
  { value: "790500", label: "79.05.00 - Pelat, lembaran, strip dan foil seng" },
  { value: "790700", label: "79.07.00 - Barang lainnya dari seng" },
  // Bab 80 - Timah
  { value: "800000", label: "80.00.00 - Timah dan barang daripadanya" },
  { value: "800100", label: "80.01.00 - Timah tidak ditempa" },
  { value: "800200", label: "80.02.00 - Sisa dan skrap timah" },
  {
    value: "800300",
    label: "80.03.00 - Batang, batang kecil, profil dan kawat timah",
  },
  { value: "800700", label: "80.07.00 - Barang lainnya dari timah" },
  // Bab 81 - Logam tidak mulia lainnya; sermet
  {
    value: "810000",
    label: "81.00.00 - Logam tidak mulia lainnya; sermet; barang daripadanya",
  },
  {
    value: "810100",
    label:
      "81.01.00 - Tungsten (wolfram) dan barang daripadanya; sisa dan skrap",
  },
  {
    value: "810200",
    label: "81.02.00 - Molibdenum dan barang daripadanya; sisa dan skrap",
  },
  {
    value: "810300",
    label: "81.03.00 - Tantalum dan barang daripadanya; sisa dan skrap",
  },
  {
    value: "810400",
    label: "81.04.00 - Magnesium dan barang daripadanya; sisa dan skrap",
  },
  {
    value: "810500",
    label:
      "81.05.00 - Mate kobalt; kobalt dan barang daripadanya; sisa dan skrap",
  },
  {
    value: "810600",
    label: "81.06.00 - Bismut dan barang daripadanya; sisa dan skrap",
  },
  {
    value: "810800",
    label: "81.08.00 - Titanium dan barang daripadanya; sisa dan skrap",
  },
  {
    value: "810900",
    label: "81.09.00 - Zirkonium dan barang daripadanya; sisa dan skrap",
  },
  {
    value: "811000",
    label: "81.10.00 - Antimoni dan barang daripadanya; sisa dan skrap",
  },
  {
    value: "811100",
    label: "81.11.00 - Mangan dan barang daripadanya; sisa dan skrap",
  },
  {
    value: "811200",
    label:
      "81.12.00 - Berilium, kromium, germanium dll dan barang dari logam tersebut",
  },
  {
    value: "811300",
    label: "81.13.00 - Sermet dan barang daripadanya; sisa dan skrap",
  },
  // Bab 82 - Perkakas, peralatan, barang tajam
  {
    value: "820000",
    label:
      "82.00.00 - Perkakas, peralatan, barang tajam, sendok dan garpu dari logam tidak mulia",
  },
  {
    value: "820100",
    label:
      "82.01.00 - Perkakas tangan (sekop, cangkul, garu, kapak, sabit, gunting bunga dll)",
  },
  {
    value: "820200",
    label: "82.02.00 - Gergaji tangan; bilah untuk segala jenis gergaji",
  },
  {
    value: "820300",
    label:
      "82.03.00 - Kikir, parut, tang, penjepit, gunting logam, pemotong pipa dll",
  },
  {
    value: "820400",
    label:
      "82.04.00 - Kunci sekrup dan kunci inggris yang digerakkan dengan tangan",
  },
  {
    value: "820500",
    label:
      "82.05.00 - Perkakas tangan ytdl; lampu tiup; vice; klem; paron; roda gerinda",
  },
  {
    value: "820600",
    label:
      "82.06.00 - Perkakas dari dua jenis atau lebih pos 82.02-82.05, dalam set eceran",
  },
  {
    value: "820700",
    label:
      "82.07.00 - Perkakas yang dapat dipertukarkan untuk perkakas tangan/mesin",
  },
  {
    value: "820800",
    label:
      "82.08.00 - Pisau dan bilah pemotong untuk mesin atau perkakas mekanik",
  },
  {
    value: "820900",
    label:
      "82.09.00 - Pelat, tongkat, ujung untuk perkakas, tidak terpasang, dari sermet",
  },
  {
    value: "821000",
    label:
      "82.10.00 - Perkakas mekanik digerakkan tangan, <=10 kg, untuk makanan/minuman",
  },
  {
    value: "821100",
    label:
      "82.11.00 - Pisau dengan bilah pemotong (termasuk pisau pangkas) dan mata pisaunya",
  },
  {
    value: "821200",
    label:
      "82.12.00 - Pisau cukur dan silet termasuk blank silet dalam bentuk strip",
  },
  {
    value: "821300",
    label:
      "82.13.00 - Gunting, gunting tukang jahit dan gunting semacam itu serta bilahnya",
  },
  {
    value: "821400",
    label:
      "82.14.00 - Barang tajam lainnya (alat pangkas rambut, parang, pisau kertas, set manikur)",
  },
  {
    value: "821500",
    label:
      "82.15.00 - Sendok, garpu, sendok sayur, pisau ikan/mentega dan perangkat semacam itu",
  },
  // Bab 83 - Bermacam barang dari logam tidak mulia
  {
    value: "830000",
    label: "83.00.00 - Bermacam-macam barang dari logam tidak mulia",
  },
  {
    value: "830100",
    label: "83.01.00 - Gembok dan kunci dari logam tidak mulia; anak kunci",
  },
  {
    value: "830200",
    label:
      "83.02.00 - Penyangga dan kelengkapan dari logam tidak mulia untuk perabotan/pintu",
  },
  {
    value: "830300",
    label:
      "83.03.00 - Lemari lapis baja, peti pengaman, pintu dan laci penyimpan",
  },
  {
    value: "830400",
    label:
      "83.04.00 - Lemari arsip, nampan dan perlengkapan kantor dari logam tidak mulia",
  },
  {
    value: "830500",
    label:
      "83.05.00 - Alat kelengkapan loose-leaf binder; jepitan; kokot dalam bentuk strip",
  },
  {
    value: "830600",
    label:
      "83.06.00 - Lonceng, gong; patung; bingkai foto; cermin dari logam tidak mulia",
  },
  {
    value: "830700",
    label: "83.07.00 - Pembuluh fleksibel dari logam tidak mulia",
  },
  {
    value: "830800",
    label:
      "83.08.00 - Jepit, gesper, kait, lubang tali dari logam tidak mulia untuk pakaian dll",
  },
  {
    value: "830900",
    label:
      "83.09.00 - Sumbat, penutup dan tutup (crown cork, capsule, segel) dari logam tidak mulia",
  },
  {
    value: "831000",
    label:
      "83.10.00 - Papan isyarat, papan nama, nomor, huruf dan lambang dari logam tidak mulia",
  },
  {
    value: "831100",
    label:
      "83.11.00 - Kawat, batang, elektroda untuk menyolder/mengelas dari logam tidak mulia",
  },
  // Bab 84 - Reaktor nuklir, ketel, mesin dan peralatan mekanis
  {
    value: "840000",
    label:
      "84.00.00 - Reaktor nuklir, ketel, mesin dan peralatan mekanis serta bagiannya",
  },
  {
    value: "840100",
    label:
      "84.01.00 - Reaktor nuklir; elemen bahan bakar; mesin separasi isotopik",
  },
  { value: "840200", label: "84.02.00 - Ketel uap air atau ketel uap lainnya" },
  {
    value: "840300",
    label: "84.03.00 - Ketel pemanasan sentral selain pos 84.02",
  },
  {
    value: "840400",
    label:
      "84.04.00 - Instalasi pembantu untuk ketel pos 84.02/84.03; kondensor",
  },
  {
    value: "840500",
    label: "84.05.00 - Generator gas produser/gas air; generator gas asetilena",
  },
  {
    value: "840600",
    label: "84.06.00 - Turbin uap air dan turbin uap lainnya",
  },
  {
    value: "840700",
    label:
      "84.07.00 - Mesin piston pembakaran dalam cetus api (bolak-balik atau berputar)",
  },
  {
    value: "840800",
    label:
      "84.08.00 - Mesin piston pembakaran dalam nyala kompresi (diesel/semi diesel)",
  },
  {
    value: "840900",
    label: "84.09.00 - Bagian untuk mesin pos 84.07 atau 84.08",
  },
  {
    value: "841000",
    label: "84.10.00 - Turbin hidrolik, kincir air dan regulatornya",
  },
  {
    value: "841100",
    label: "84.11.00 - Turbo-jet, turbo-propeller dan turbin gas lainnya",
  },
  { value: "841200", label: "84.12.00 - Mesin dan motor lainnya" },
  { value: "841300", label: "84.13.00 - Pompa untuk cairan; elevator cairan" },
  {
    value: "841400",
    label:
      "84.14.00 - Pompa udara/vakum, kompresor udara/gas dan kipas; hood ventilasi",
  },
  { value: "841500", label: "84.15.00 - Mesin pengatur suhu udara (AC)" },
  {
    value: "841600",
    label:
      "84.16.00 - Tanur pembakar untuk bahan bakar cair/padat/gas; penyala mekanis",
  },
  {
    value: "841700",
    label:
      "84.17.00 - Tanur dan oven industri/laboratorium termasuk incinerator, bukan listrik",
  },
  {
    value: "841800",
    label:
      "84.18.00 - Lemari pendingin, lemari pembeku dan perlengkapan pendingin lainnya",
  },
  {
    value: "841900",
    label:
      "84.19.00 - Mesin pengolahan dengan perubahan suhu; pemanas air bukan listrik",
  },
  {
    value: "842000",
    label:
      "84.20.00 - Mesin calender atau mesin giling lainnya (selain logam/kaca)",
  },
  {
    value: "842100",
    label:
      "84.21.00 - Mesin sentrifugal; mesin penyaring atau pemurni untuk cairan/gas",
  },
  {
    value: "842200",
    label:
      "84.22.00 - Mesin pencuci piring; mesin pengisi/penyegel/pelabel; mesin pengepak",
  },
  { value: "842300", label: "84.23.00 - Mesin penimbang; anak timbangan" },
  {
    value: "842400",
    label:
      "84.24.00 - Peralatan mekanis penyemprot cairan/bubuk; pemadam api; pistol semprot",
  },
  {
    value: "842500",
    label: "84.25.00 - Katrol dan kerekan; derek dan kapstan; dongkrak",
  },
  {
    value: "842600",
    label:
      "84.26.00 - Derek kapal; crane; rangka pengangkat; truk kerja dengan crane",
  },
  {
    value: "842700",
    label:
      "84.27.00 - Truk forklift; truk kerja dengan perlengkapan pengangkat",
  },
  {
    value: "842800",
    label:
      "84.28.00 - Mesin pengangkat/pemuat/pembongkar lainnya (lift, eskalator, konveyor)",
  },
  {
    value: "842900",
    label:
      "84.29.00 - Buldoser, grader, ekskavator, mesin gilas, berdaya gerak sendiri",
  },
  {
    value: "843000",
    label:
      "84.30.00 - Mesin pengolah/penggali/pemadat lainnya untuk tanah/mineral/bijih",
  },
  { value: "843100", label: "84.31.00 - Bagian untuk mesin pos 84.25-84.30" },
  {
    value: "843200",
    label:
      "84.32.00 - Mesin pertanian/perkebunan/kehutanan untuk penyiapan/kultivasi tanah",
  },
  {
    value: "843300",
    label:
      "84.33.00 - Mesin tuai atau mesin tebah; mesin pemotong rumput; mesin sortir",
  },
  {
    value: "843400",
    label: "84.34.00 - Mesin perah susu dan mesin produk susu",
  },
  {
    value: "843500",
    label:
      "84.35.00 - Pengepres, penghancur untuk pembuatan wine, cider, jus buah",
  },
  {
    value: "843600",
    label: "84.36.00 - Mesin pertanian/unggas/lebah lainnya; inkubator",
  },
  {
    value: "843700",
    label:
      "84.37.00 - Mesin pembersih/penyortir biji/butir; mesin industri penggilingan",
  },
  {
    value: "843800",
    label:
      "84.38.00 - Mesin untuk industri pengolahan makanan atau minuman ytdl",
  },
  {
    value: "843900",
    label: "84.39.00 - Mesin untuk membuat pulp/kertas atau kertas karton",
  },
  {
    value: "844000",
    label: "84.40.00 - Mesin penjilid buku termasuk mesin penjahit buku",
  },
  {
    value: "844100",
    label: "84.41.00 - Mesin lainnya untuk membuat pulp/kertas; mesin pemotong",
  },
  {
    value: "844200",
    label:
      "84.42.00 - Mesin untuk menyiapkan pelat, silinder cetak atau komponen cetak",
  },
  {
    value: "844300",
    label:
      "84.43.00 - Mesin cetak; mesin fotocopy dan mesin faksimili; bagian dan aksesori",
  },
  {
    value: "844400",
    label:
      "84.44.00 - Mesin untuk mengekstrusi/menarik/memotong bahan tekstil buatan",
  },
  {
    value: "844500",
    label:
      "84.45.00 - Mesin pengolahan serat tekstil; mesin pemintal/penggulung benang",
  },
  { value: "844600", label: "84.46.00 - Mesin tenun (loom)" },
  {
    value: "844700",
    label:
      "84.47.00 - Mesin rajut, stitch-bonding dan pembuat renda/bordir/jaring",
  },
  {
    value: "844800",
    label:
      "84.48.00 - Mesin pembantu untuk mesin pos 84.44-84.47; bagian dan aksesori",
  },
  {
    value: "844900",
    label:
      "84.49.00 - Mesin untuk membuat bulu kempa atau bukan tenunan; mesin membuat topi",
  },
  {
    value: "845000",
    label: "84.50.00 - Mesin cuci tipe rumah tangga atau binatu",
  },
  {
    value: "845100",
    label:
      "84.51.00 - Mesin untuk mencuci/mengeringkan/menyetrika/mencelup tekstil",
  },
  {
    value: "845200",
    label:
      "84.52.00 - Mesin jahit (selain mesin penjahit buku); jarum mesin jahit",
  },
  {
    value: "845300",
    label: "84.53.00 - Mesin untuk mengolah/menyamak kulit; membuat alas kaki",
  },
  {
    value: "845400",
    label:
      "84.54.00 - Converter, ladle, mesin cetakan ingot dan mesin tuang untuk metalurgi",
  },
  {
    value: "845500",
    label: "84.55.00 - Kilang pencanai logam (rolling mill) dan gilingannya",
  },
  {
    value: "845600",
    label: "84.56.00 - Mesin perkakas dengan laser/ultrasonik/plasma",
  },
  {
    value: "845700",
    label:
      "84.57.00 - Machining center, mesin konstruksi unit, mesin transfer untuk logam",
  },
  {
    value: "845800",
    label:
      "84.58.00 - Mesin bubut termasuk turning centre untuk menghilangkan logam",
  },
  {
    value: "845900",
    label:
      "84.59.00 - Mesin perkakas untuk mengebor/menggiling logam (selain bubut)",
  },
  {
    value: "846000",
    label:
      "84.60.00 - Mesin perkakas untuk menghaluskan/menggerinda/memoles logam/sermet",
  },
  {
    value: "846100",
    label:
      "84.61.00 - Mesin perkakas untuk mengetam/menggergaji logam atau sermet ytdl",
  },
  {
    value: "846200",
    label:
      "84.62.00 - Mesin perkakas/pengepres untuk menempa/membengkokkan logam",
  },
  {
    value: "846300",
    label:
      "84.63.00 - Mesin perkakas lainnya untuk logam/sermet tanpa menghilangkan bahan",
  },
  {
    value: "846400",
    label:
      "84.64.00 - Mesin perkakas untuk batu/keramik/beton/kaca secara dingin",
  },
  {
    value: "846500",
    label:
      "84.65.00 - Mesin perkakas untuk kayu/gabus/tulang/karet/plastik keras",
  },
  {
    value: "846600",
    label: "84.66.00 - Bagian dan aksesori untuk mesin pos 84.56-84.65",
  },
  {
    value: "846700",
    label:
      "84.67.00 - Perkakas tangan pneumatik/hidraulik atau dengan motor terpasang",
  },
  {
    value: "846800",
    label: "84.68.00 - Mesin dan aparatus untuk menyolder/mematri/mengelas",
  },
  {
    value: "847000",
    label: "84.70.00 - Mesin hitung; mesin akunting; register kas",
  },
  {
    value: "847100",
    label: "84.71.00 - Mesin pengolah data otomatis dan unitnya (komputer)",
  },
  {
    value: "847200",
    label:
      "84.72.00 - Mesin kantor lainnya (mesin duplikasi, ATM, penyortir koin dll)",
  },
  {
    value: "847300",
    label: "84.73.00 - Bagian dan aksesori untuk mesin pos 84.70-84.72",
  },
  {
    value: "847400",
    label:
      "84.74.00 - Mesin untuk menyortir/menghancurkan/mencampur tanah/batu/bijih",
  },
  {
    value: "847500",
    label:
      "84.75.00 - Mesin untuk merakit lampu listrik/elektronik; mesin pembuat kaca",
  },
  {
    value: "847600",
    label: "84.76.00 - Mesin penjual barang otomatis; mesin penukar uang",
  },
  {
    value: "847700",
    label: "84.77.00 - Mesin untuk mengerjakan karet atau plastik ytdl",
  },
  {
    value: "847800",
    label: "84.78.00 - Mesin untuk mengolah/membuat tembakau ytdl",
  },
  {
    value: "847900",
    label:
      "84.79.00 - Mesin dan peralatan mekanis dengan fungsi tersendiri ytdl",
  },
  {
    value: "848000",
    label:
      "84.80.00 - Kotak cetakan untuk pengecoran logam; pola cetakan; cetakan",
  },
  {
    value: "848100",
    label:
      "84.81.00 - Keran, klep, katup dan peralatan untuk pipa/ketel/tangki",
  },
  {
    value: "848200",
    label:
      "84.82.00 - Bantalan peluru atau bantalan gulung (ball/roller bearing)",
  },
  {
    value: "848300",
    label:
      "84.83.00 - Poros transmisi; gir dan gearing; gear box; kopling poros penyambung",
  },
  {
    value: "848400",
    label: "84.84.00 - Gasket dan sambungan dari lembaran logam; sil mekanis",
  },
  { value: "848500", label: "84.85.00 - Mesin untuk additive manufacturing" },
  {
    value: "848600",
    label:
      "84.86.00 - Mesin/aparatus untuk pembuatan wafer semikonduktor/IC/panel layar",
  },
  {
    value: "848700",
    label: "84.87.00 - Bagian mesin tanpa konektor/isolator/koil elektrik ytdl",
  },
  // Bab 85 - Mesin dan perlengkapan elektris
  {
    value: "850000",
    label:
      "85.00.00 - Mesin dan perlengkapan elektris serta bagiannya; perekam suara/gambar",
  },
  {
    value: "850100",
    label:
      "85.01.00 - Motor dan generator listrik (selain perangkat pembangkit)",
  },
  {
    value: "850200",
    label:
      "85.02.00 - Perangkat pembangkit tenaga listrik dan konverter berputar",
  },
  {
    value: "850300",
    label: "85.03.00 - Bagian untuk mesin pos 85.01 atau 85.02",
  },
  {
    value: "850400",
    label:
      "85.04.00 - Transformator elektrik, konverter statis (rectifier) dan induktor",
  },
  {
    value: "850500",
    label:
      "85.05.00 - Elektro magnet; magnet permanen; chuck elektro magnetis; rem",
  },
  { value: "850600", label: "85.06.00 - Sel primer dan baterai primer" },
  {
    value: "850700",
    label: "85.07.00 - Akumulator listrik termasuk separatornya",
  },
  { value: "850800", label: "85.08.00 - Vacuum cleaner" },
  {
    value: "850900",
    label:
      "85.09.00 - Peralatan rumah tangga mekanik elektrik dengan motor terpasang",
  },
  {
    value: "851000",
    label: "85.10.00 - Alat cukur, alat pangkas rambut dengan motor terpasang",
  },
  {
    value: "851100",
    label:
      "85.11.00 - Alat penyala/penghidup elektrik untuk mesin pembakaran dalam (busi, starter)",
  },
  {
    value: "851200",
    label:
      "85.12.00 - Perlengkapan penerangan/pemberi isyarat elektrik untuk kendaraan",
  },
  {
    value: "851300",
    label:
      "85.13.00 - Lampu listrik portabel dengan sumber energi sendiri (baterai kering)",
  },
  {
    value: "851400",
    label:
      "85.14.00 - Tanur dan oven listrik industri/laboratorium (induksi/dielectric loss)",
  },
  {
    value: "851500",
    label:
      "85.15.00 - Mesin penyolder/pematri/pengelas listrik; penyemprotan panas logam",
  },
  {
    value: "851600",
    label:
      "85.16.00 - Pemanas air listrik; setrika listrik; peralatan elektro-termal rumah tangga",
  },
  {
    value: "851700",
    label:
      "85.17.00 - Telepon termasuk smartphone; aparatus transmisi/penerima suara/data",
  },
  {
    value: "851800",
    label:
      "85.18.00 - Mikrofon, pengeras suara, headphone, earphone; amplifier audio",
  },
  {
    value: "851900",
    label: "85.19.00 - Aparatus untuk perekam atau reproduksi suara",
  },
  {
    value: "852100",
    label: "85.21.00 - Aparatus perekam atau pereproduksi video",
  },
  {
    value: "852200",
    label: "85.22.00 - Bagian dan aksesori untuk aparatus pos 85.19/85.21",
  },
  {
    value: "852300",
    label: "85.23.00 - Cakram, pita, media penyimpan non-volatile, smart card",
  },
  { value: "852400", label: "85.24.00 - Modul panel layar datar" },
  {
    value: "852500",
    label:
      "85.25.00 - Aparatus transmisi radio/televisi; kamera televisi/digital/perekam video",
  },
  {
    value: "852600",
    label:
      "85.26.00 - Aparatus radar, radio navigasi dan radio kendali jarak jauh",
  },
  {
    value: "852700",
    label: "85.27.00 - Aparatus penerima untuk penyiaran radio",
  },
  {
    value: "852800",
    label: "85.28.00 - Monitor dan proyektor; aparatus penerima televisi",
  },
  {
    value: "852900",
    label: "85.29.00 - Bagian untuk aparatus pos 85.24-85.28",
  },
  {
    value: "853000",
    label:
      "85.30.00 - Perlengkapan isyarat/pengontrol lalu lintas elektrik untuk rel/jalan/pelabuhan",
  },
  {
    value: "853100",
    label:
      "85.31.00 - Aparatus isyarat suara atau visual elektrik (bel, sirene, alarm)",
  },
  {
    value: "853200",
    label:
      "85.32.00 - Kapasitor listrik (tetap, variabel atau dapat disesuaikan)",
  },
  {
    value: "853300",
    label: "85.33.00 - Resistor listrik termasuk reostat dan potensiometer",
  },
  { value: "853400", label: "85.34.00 - Printed circuit" },
  {
    value: "853500",
    label:
      "85.35.00 - Aparatus listrik untuk memutus/melindungi sirkuit, voltase >1.000 volt",
  },
  {
    value: "853600",
    label:
      "85.36.00 - Aparatus listrik untuk memutus/melindungi sirkuit, voltase <=1.000 volt",
  },
  {
    value: "853700",
    label:
      "85.37.00 - Papan, panel, konsol untuk pengontrol/pendistribusi listrik",
  },
  {
    value: "853800",
    label: "85.38.00 - Bagian untuk aparatus pos 85.35/85.36/85.37",
  },
  {
    value: "853900",
    label:
      "85.39.00 - Lampu filamen atau lampu discharge listrik; sumber cahaya LED",
  },
  {
    value: "854000",
    label: "85.40.00 - Katup dan tabung termionik/katoda; tabung sinar katoda",
  },
  {
    value: "854100",
    label:
      "85.41.00 - Peralatan semi konduktor (dioda, transistor); sel fotovoltaik; LED",
  },
  { value: "854200", label: "85.42.00 - Sirkuit elektronik terpadu (IC)" },
  {
    value: "854300",
    label:
      "85.43.00 - Mesin dan aparatus elektrik dengan fungsi tersendiri ytdl",
  },
  {
    value: "854400",
    label: "85.44.00 - Kawat diisolasi; kabel koaksial; kabel serat optik",
  },
  {
    value: "854500",
    label: "85.45.00 - Elektroda karbon, sikat karbon, karbon lampu/baterai",
  },
  { value: "854600", label: "85.46.00 - Isolator listrik dari berbagai bahan" },
  {
    value: "854700",
    label:
      "85.47.00 - Alat kelengkapan pengisolasi untuk mesin/peralatan elektrik",
  },
  {
    value: "854800",
    label: "85.48.00 - Bagian elektrik dari mesin atau aparatus ytdl",
  },
  {
    value: "854900",
    label: "85.49.00 - Sisa dan skrap elektrik dan elektronik",
  },
  // Bab 86 - Lokomotif kereta api/trem
  {
    value: "860000",
    label: "86.00.00 - Lokomotif kereta api/trem, kendaraan rel dan bagiannya",
  },
  {
    value: "860100",
    label:
      "86.01.00 - Lokomotif rel digerakkan tenaga listrik dari luar/akumulator",
  },
  {
    value: "860200",
    label: "86.02.00 - Lokomotif rel lainnya; tender lokomotif",
  },
  {
    value: "860300",
    label:
      "86.03.00 - Gerbong kereta api/trem berdaya gerak sendiri (selain pos 86.04)",
  },
  {
    value: "860400",
    label: "86.04.00 - Kendaraan perawatan atau perbaikan kereta api/trem",
  },
  {
    value: "860500",
    label:
      "86.05.00 - Gerbong penumpang kereta api/trem tidak berdaya gerak sendiri",
  },
  {
    value: "860600",
    label: "86.06.00 - Gerbong tertutup dan wagon kereta api/trem untuk barang",
  },
  {
    value: "860700",
    label:
      "86.07.00 - Bagian dari lokomotif atau kendaraan rel kereta api/trem",
  },
  {
    value: "860800",
    label:
      "86.08.00 - Track fixture dan kelengkapan rel; perlengkapan isyarat/pengontrol",
  },
  {
    value: "860900",
    label:
      "86.09.00 - Peti kemas (kontainer) untuk satu atau lebih moda pengangkut",
  },
  // Bab 87 - Kendaraan selain rel
  {
    value: "870000",
    label:
      "87.00.00 - Kendaraan selain yang bergerak di atas rel dan bagiannya",
  },
  { value: "870100", label: "87.01.00 - Traktor (selain traktor pos 87.09)" },
  {
    value: "870200",
    label:
      "87.02.00 - Kendaraan bermotor untuk pengangkutan 10 orang atau lebih",
  },
  {
    value: "870300",
    label:
      "87.03.00 - Mobil dan kendaraan bermotor untuk pengangkutan orang (station wagon)",
  },
  {
    value: "870400",
    label: "87.04.00 - Kendaraan bermotor untuk pengangkutan barang",
  },
  {
    value: "870500",
    label:
      "87.05.00 - Kendaraan bermotor keperluan khusus (lori derek, crane, pemadam dll)",
  },
  {
    value: "870600",
    label:
      "87.06.00 - Sasis dilengkapi mesin untuk kendaraan bermotor pos 87.01-87.05",
  },
  {
    value: "870700",
    label:
      "87.07.00 - Bodi termasuk kabin untuk kendaraan bermotor pos 87.01-87.05",
  },
  {
    value: "870800",
    label: "87.08.00 - Bagian dan aksesori kendaraan bermotor pos 87.01-87.05",
  },
  {
    value: "870900",
    label:
      "87.09.00 - Truk kerja berdaya gerak sendiri tanpa perlengkapan pengangkat",
  },
  {
    value: "871000",
    label:
      "87.10.00 - Tank dan kendaraan tempur lapis baja, bermotor, dan bagiannya",
  },
  {
    value: "871100",
    label: "87.11.00 - Sepeda motor termasuk moped; kereta samping",
  },
  {
    value: "871200",
    label: "87.12.00 - Sepeda roda dua dan sepeda lainnya, tidak bermotor",
  },
  { value: "871300", label: "87.13.00 - Kendaraan untuk orang cacat" },
  {
    value: "871400",
    label: "87.14.00 - Bagian dan aksesori kendaraan pos 87.11-87.13",
  },
  { value: "871500", label: "87.15.00 - Kereta bayi dan bagiannya" },
  {
    value: "871600",
    label:
      "87.16.00 - Trailer dan semi trailer; kendaraan lain tidak digerakkan mekanik",
  },
  // Bab 88 - Kendaraan udara, luar angkasa
  {
    value: "880000",
    label: "88.00.00 - Kendaraan udara, kendaraan luar angkasa dan bagiannya",
  },
  {
    value: "880100",
    label:
      "88.01.00 - Balon udara; pesawat layang; kendaraan udara tanpa tenaga penggerak",
  },
  {
    value: "880200",
    label:
      "88.02.00 - Kendaraan udara lainnya (helikopter, pesawat); kendaraan luar angkasa",
  },
  {
    value: "880400",
    label:
      "88.04.00 - Parasut dan paraglider; rotochute; bagian dan aksesorinya",
  },
  {
    value: "880500",
    label:
      "88.05.00 - Gir peluncur kendaraan udara; pesawat latih terbang di darat",
  },
  { value: "880600", label: "88.06.00 - Kendaraan udara tak berawak" },
  {
    value: "880700",
    label: "88.07.00 - Bagian dari barang pos 88.01, 88.02 atau 88.06",
  },
  // Bab 89 - Kapal, perahu; bangunan & pekerjaan sipil
  {
    value: "890000",
    label: "89.00.00 - Kapal, perahu dan struktur terapung serta bangunan",
  },
  {
    value: "890100",
    label:
      "89.01.00 - Kapal pesiar, ekskursi, feri, kargo, tongkang untuk orang/barang",
  },
  {
    value: "890200",
    label:
      "89.02.00 - Kapal penangkap ikan; kapal pabrik dan kendaraan air pemroses ikan",
  },
  {
    value: "890300",
    label:
      "89.03.00 - Yacht dan kendaraan air untuk pelesir/olahraga; sampan dan kano",
  },
  {
    value: "890400",
    label: "89.04.00 - Kapal penarik dan pendorong (tug dan pusher craft)",
  },
  {
    value: "890500",
    label:
      "89.05.00 - Kapal suar, pemadam kebakaran, keruk, crane terapung; dok terapung",
  },
  {
    value: "890600",
    label:
      "89.06.00 - Kendaraan air lainnya termasuk kapal perang dan perahu penyelamat",
  },
  {
    value: "890700",
    label:
      "89.07.00 - Struktur terapung lainnya (rakit, tangki, pelampung suar)",
  },
  { value: "890800", label: "89.08.00 - Bangunan tempat tinggal" },
  { value: "890900", label: "89.09.00 - Bangunan bukan tempat tinggal" },
  {
    value: "891000",
    label:
      "89.10.00 - Jalan bebas hambatan, jalan raya, jalan, jalan kereta api dan landasan",
  },
  {
    value: "891100",
    label: "89.11.00 - Jembatan, jalan layang bebas hambatan dan terowongan",
  },
  {
    value: "891200",
    label:
      "89.12.00 - Pelabuhan, terusan, bendungan, irigasi dan bangunan air lainnya",
  },
  {
    value: "891300",
    label:
      "89.13.00 - Pipa saluran jarak jauh, saluran komunikasi dan listrik kabel",
  },
  {
    value: "891400",
    label: "89.14.00 - Kabel dan pipa saluran lokal dan bangunan",
  },
  { value: "891500", label: "89.15.00 - Bangunan pertambangan dan industri" },
  {
    value: "891600",
    label: "89.16.00 - Fasilitas olahraga dan rekreasi di ruang terbuka",
  },
  { value: "891700", label: "89.17.00 - Pekerjaan teknik sipil lainnya" },
  // Bab 90 - Instrumen optik, fotografi, medis
  {
    value: "900000",
    label:
      "90.00.00 - Instrumen optis, fotografi, ukur, periksa, medis dan bagiannya",
  },
  {
    value: "900100",
    label:
      "90.01.00 - Serat optik; lensa, prisma, cermin dan elemen optik tidak terpasang",
  },
  {
    value: "900200",
    label: "90.02.00 - Lensa, prisma, cermin dan elemen optik terpasang",
  },
  {
    value: "900300",
    label: "90.03.00 - Bingkai dan mounting untuk kacamata serta bagiannya",
  },
  {
    value: "900400",
    label: "90.04.00 - Kacamata, kacamata pelindung (korektif/protektif)",
  },
  {
    value: "900500",
    label:
      "90.05.00 - Teropong ganda/tunggal, teleskop optik; instrumen astronomi",
  },
  {
    value: "900600",
    label: "90.06.00 - Kamera fotografi; aparatus lampu kilat fotografi",
  },
  { value: "900700", label: "90.07.00 - Kamera dan proyektor sinematografi" },
  {
    value: "900800",
    label: "90.08.00 - Proyektor gambar; pembesar dan pengecil fotografi",
  },
  {
    value: "901000",
    label:
      "90.10.00 - Aparatus dan perlengkapan laboratorium fotografi; layar proyeksi",
  },
  { value: "901100", label: "90.11.00 - Mikroskop optik gabungan" },
  {
    value: "901200",
    label: "90.12.00 - Mikroskop selain optik; aparatus difraksi",
  },
  {
    value: "901300",
    label:
      "90.13.00 - Laser (selain dioda laser); peralatan dan instrumen optik lainnya ytdl",
  },
  {
    value: "901400",
    label:
      "90.14.00 - Kompas pencari arah; instrumen dan peralatan navigasi lainnya",
  },
  {
    value: "901500",
    label:
      "90.15.00 - Instrumen survei, hidrografi, oseanografi, meteorologi, geofisika",
  },
  {
    value: "901600",
    label: "90.16.00 - Timbangan dengan kepekaan 5 cg atau lebih peka",
  },
  {
    value: "901700",
    label:
      "90.17.00 - Instrumen penggambar/penghitung matematis; instrumen ukur panjang",
  },
  {
    value: "901800",
    label: "90.18.00 - Instrumen untuk ilmu medis/bedah/gigi/kedokteran hewan",
  },
  {
    value: "901900",
    label:
      "90.19.00 - Peralatan mekano terapi; aparatus pijat; terapi ozon/oksigen/aerosol",
  },
  {
    value: "902000",
    label: "90.20.00 - Peralatan nafas dan masker gas lainnya",
  },
  {
    value: "902100",
    label:
      "90.21.00 - Peralatan ortopedik; anggota badan artifisial; alat bantu dengar",
  },
  {
    value: "902200",
    label: "90.22.00 - Aparatus sinar X atau radiasi; radiografi/radioterapi",
  },
  {
    value: "902300",
    label:
      "90.23.00 - Instrumen, aparatus dan model untuk peragaan (pendidikan/pameran)",
  },
  {
    value: "902400",
    label:
      "90.24.00 - Mesin untuk menguji kekerasan/kekuatan/elastisitas bahan",
  },
  {
    value: "902500",
    label:
      "90.25.00 - Hidrometer, termometer, pirometer, barometer, higrometer",
  },
  {
    value: "902600",
    label:
      "90.26.00 - Instrumen untuk mengukur aliran/tinggi permukaan/tekanan cairan/gas",
  },
  {
    value: "902700",
    label:
      "90.27.00 - Instrumen untuk analisa sifat fisika atau kimia; mikrotom",
  },
  {
    value: "902800",
    label:
      "90.28.00 - Pengukur pasokan/produksi gas, cairan atau listrik; pengukur kalibrasi",
  },
  {
    value: "902900",
    label:
      "90.29.00 - Penghitung putaran/produksi; taksimeter; speedometer dan takometer",
  },
  {
    value: "903000",
    label:
      "90.30.00 - Osiloskop, penganalisa spektrum; instrumen ukur kuantitas elektrik",
  },
  {
    value: "903100",
    label:
      "90.31.00 - Instrumen, peralatan dan mesin pengukur atau pemeriksa ytdl",
  },
  {
    value: "903200",
    label:
      "90.32.00 - Instrumen dan aparatus pengatur atau pengontrol otomatis",
  },
  {
    value: "903300",
    label: "90.33.00 - Bagian dan aksesori untuk mesin/instrumen Bab 90 ytdl",
  },
  // Bab 91 - Jam dan arloji
  { value: "910000", label: "91.00.00 - Jam dan arloji serta bagiannya" },
  {
    value: "910100",
    label: "91.01.00 - Arloji tangan/saku dengan badan dari logam mulia",
  },
  {
    value: "910200",
    label: "91.02.00 - Arloji tangan/saku lainnya (selain pos 91.01)",
  },
  {
    value: "910300",
    label: "91.03.00 - Jam dengan penggerak jam (selain pos 91.04)",
  },
  {
    value: "910400",
    label: "91.04.00 - Jam panel instrumen untuk kendaraan/pesawat/kapal",
  },
  { value: "910500", label: "91.05.00 - Jam lainnya" },
  {
    value: "910600",
    label:
      "91.06.00 - Aparatus perekam waktu dan pengukur/penunjuk interval waktu",
  },
  {
    value: "910700",
    label:
      "91.07.00 - Sakelar waktu dengan penggerak jam/arloji atau motor sinkron",
  },
  {
    value: "910800",
    label: "91.08.00 - Penggerak arloji, lengkap dan dirakit",
  },
  { value: "910900", label: "91.09.00 - Penggerak jam, lengkap dan dirakit" },
  {
    value: "911000",
    label:
      "91.10.00 - Penggerak arloji/jam lengkap tidak dirakit; set penggerak",
  },
  { value: "911100", label: "91.11.00 - Badan arloji dan bagiannya" },
  {
    value: "911200",
    label:
      "91.12.00 - Badan jam dan badan semacam itu untuk barang lain Bab 91",
  },
  {
    value: "911300",
    label:
      "91.13.00 - Tali arloji, ban arloji dan gelang arloji serta bagiannya",
  },
  { value: "911400", label: "91.14.00 - Bagian lainnya dari jam atau arloji" },
  // Bab 92 - Instrumen musik
  {
    value: "920000",
    label: "92.00.00 - Instrumen musik; bagian dan aksesori barang tersebut",
  },
  {
    value: "920100",
    label:
      "92.01.00 - Piano termasuk piano otomatis; harpsichord; instrumen keyboard bersenar",
  },
  {
    value: "920200",
    label: "92.02.00 - Instrumen musik bersenar lainnya (gitar, biola, harpa)",
  },
  {
    value: "920500",
    label:
      "92.05.00 - Instrumen musik tiup (organ, akordeon, klarinet, trompet)",
  },
  {
    value: "920600",
    label:
      "92.06.00 - Instrumen musik perkusi (drum, xylophone, simbal, marakas)",
  },
  {
    value: "920700",
    label:
      "92.07.00 - Instrumen musik dengan suara dihasilkan/diperkuat secara elektrik",
  },
  {
    value: "920800",
    label: "92.08.00 - Kotak musik, organ jalanan; peluit dan terompet panggil",
  },
  {
    value: "920900",
    label:
      "92.09.00 - Bagian dan aksesori instrumen musik; metronom, garpu tala, pipa penala",
  },
  // Bab 93 - Senjata dan amunisi
  {
    value: "930000",
    label: "93.00.00 - Senjata dan amunisi; bagian dan aksesorinya",
  },
  {
    value: "930100",
    label:
      "93.01.00 - Senjata militer (selain revolver, pistol dan senjata pos 93.07)",
  },
  {
    value: "930200",
    label: "93.02.00 - Revolver dan pistol (selain pos 93.03/93.04)",
  },
  {
    value: "930300",
    label:
      "93.03.00 - Senjata api lainnya yang dioperasikan dengan bahan peledak",
  },
  {
    value: "930400",
    label:
      "93.04.00 - Senjata lainnya (senapan/pistol per/angin/gas; tongkat polisi)",
  },
  {
    value: "930500",
    label: "93.05.00 - Bagian dan aksesori dari barang pos 93.01-93.04",
  },
  {
    value: "930600",
    label:
      "93.06.00 - Bom, granat, torpedo, ranjau, misil; peluru dan amunisi lainnya",
  },
  {
    value: "930700",
    label:
      "93.07.00 - Pedang, bayonet, tombak dan senjata semacam itu serta sarungnya",
  },
  // Bab 94 - Perabotan; perlengkapan tidur; lampu
  {
    value: "940000",
    label:
      "94.00.00 - Perabotan; perlengkapan tidur; lampu; tanda iluminasi; bangunan prapabrikasi",
  },
  {
    value: "940100",
    label: "94.01.00 - Tempat duduk (selain pos 94.02) dan bagiannya",
  },
  {
    value: "940200",
    label:
      "94.02.00 - Perabotan medis/bedah/gigi; kursi cukur dan kursi semacam itu",
  },
  { value: "940300", label: "94.03.00 - Perabotan lain dan bagiannya" },
  {
    value: "940400",
    label:
      "94.04.00 - Alas kasur; barang keperluan tidur (kasur, selimut tebal, bantal)",
  },
  {
    value: "940500",
    label:
      "94.05.00 - Luminer dan alat kelengkapan penerangan; tanda iluminasi",
  },
  { value: "940600", label: "94.06.00 - Bangunan prapabrikasi" },
  // Bab 95 - Mainan, permainan, olahraga
  {
    value: "950000",
    label:
      "95.00.00 - Mainan, permainan dan keperluan olahraga; bagian dan aksesorinya",
  },
  {
    value: "950300",
    label:
      "95.03.00 - Sepeda roda tiga, skuter, mobil pedal; boneka; mainan; model skala",
  },
  {
    value: "950400",
    label:
      "95.04.00 - Konsol/mesin video game; permainan meja (biliar, kasino, boling)",
  },
  {
    value: "950500",
    label:
      "95.05.00 - Barang festival, karnaval atau hiburan; alat sulap dan lelucon",
  },
  {
    value: "950600",
    label:
      "95.06.00 - Barang untuk latihan fisik/gimnastik/atletik/olahraga; kolam renang",
  },
  {
    value: "950700",
    label:
      "95.07.00 - Joran, mata kail dan perlengkapan pancing; perlengkapan berburu",
  },
  {
    value: "950800",
    label: "95.08.00 - Sirkus keliling; wahana taman hiburan; teater keliling",
  },
  // Bab 96 - Bermacam barang hasil pabrik
  { value: "960000", label: "96.00.00 - Bermacam-macam barang hasil pabrik" },
  {
    value: "960100",
    label:
      "96.01.00 - Gading, tulang, tanduk, koral, kulit kerang dikerjakan dan barangnya",
  },
  {
    value: "960200",
    label:
      "96.02.00 - Bahan ukiran nabati/mineral dikerjakan; barang dari malam; gelatin",
  },
  {
    value: "960300",
    label:
      "96.03.00 - Sapu, sikat, pengepel, kemucing; roll pengecat; penyapu air",
  },
  { value: "960400", label: "96.04.00 - Ayakan tangan dan saringan tangan" },
  {
    value: "960500",
    label:
      "96.05.00 - Set bepergian untuk rias pribadi/menjahit/membersihkan sepatu",
  },
  {
    value: "960600",
    label:
      "96.06.00 - Kancing, kancing tekan/jepret/pijat; bentukan kancing; button blank",
  },
  { value: "960700", label: "96.07.00 - Ritsleting dan bagiannya" },
  {
    value: "960800",
    label:
      "96.08.00 - Bolpoin, pena/marker; pulpen; pensil putar/dorong; tangkai pena",
  },
  {
    value: "960900",
    label:
      "96.09.00 - Pensil (selain pos 96.08), crayon, pastel, arang gambar, kapur",
  },
  {
    value: "961000",
    label: "96.10.00 - Sabak dan papan untuk menulis atau menggambar",
  },
  {
    value: "961100",
    label:
      "96.11.00 - Stempel tanggal/meterai/nomor; set pencetak dengan tangan",
  },
  {
    value: "961200",
    label: "96.12.00 - Pita mesin ketik atau pita semacam itu; bantalan tinta",
  },
  {
    value: "961300",
    label: "96.13.00 - Pemantik sigaret dan pemantik lainnya serta bagiannya",
  },
  {
    value: "961400",
    label:
      "96.14.00 - Pipa untuk merokok termasuk cangklong dan pipa cerutu/sigaret",
  },
  {
    value: "961500",
    label:
      "96.15.00 - Sisir, jepitan perapih rambut; tusuk rambut; pengeriting rambut",
  },
  {
    value: "961600",
    label:
      "96.16.00 - Penyemprot wewangian dan penyemprot rias; pengoles bedak",
  },
  {
    value: "961700",
    label: "96.17.00 - Termos dan bejana hampa udara lainnya",
  },
  {
    value: "961800",
    label:
      "96.18.00 - Model orang-orangan untuk penjahit; otomata penghias jendela toko",
  },
  {
    value: "961900",
    label:
      "96.19.00 - Sanitary towel, pad dan tampon, popok dan barang semacam itu",
  },
  {
    value: "962000",
    label: "96.20.00 - Monopod, bipod, tripod dan barang semacam itu",
  },
  // Bab 97 - Karya seni, barang kolektor, antik
  {
    value: "970000",
    label: "97.00.00 - Karya seni, barang kolektor dan barang antik",
  },
  {
    value: "970100",
    label:
      "97.01.00 - Lukisan, gambar dan gambar pastel dikerjakan dengan tangan; kolase; mosaik",
  },
  { value: "970200", label: "97.02.00 - Ukiran, cetakan, dan litograf asli" },
  {
    value: "970300",
    label: "97.03.00 - Arca dan patung asli dari berbagai bahan",
  },
  {
    value: "970400",
    label:
      "97.04.00 - Perangko atau materai, sampul hari pertama, benda pos bermaterai",
  },
  {
    value: "970500",
    label:
      "97.05.00 - Koleksi dan barang kolektor arkeologi/sejarah/zoologi/numismatika",
  },
  {
    value: "970600",
    label: "97.06.00 - Barang antik yang umurnya melebihi 100 tahun",
  },
  // Bab 98 - Ketentuan khusus industri alat transportasi
  {
    value: "980000",
    label: "98.00.00 - Ketentuan khusus untuk industri alat transportasi",
  },
  {
    value: "980100",
    label:
      "98.01.00 - Kendaraan bermotor dalam keadaan terurai tidak lengkap; sasis dengan mesin",
  },
  {
    value: "980200",
    label:
      "98.02.00 - Komponen kendaraan bermotor dalam keadaan terurai tidak lengkap",
  },
  { value: "980400", label: "98.04.00 - Komponen kapal dari Bab 72" },
  { value: "980500", label: "98.05.00 - Komponen kapal dari Bab 73" },
  { value: "980600", label: "98.06.00 - Komponen kapal dari Bab 74" },
  { value: "980700", label: "98.07.00 - Komponen kapal dari Bab 76" },
  { value: "980800", label: "98.08.00 - Komponen kapal dari Bab 84" },
  { value: "980900", label: "98.09.00 - Komponen kapal dari Bab 85" },
  { value: "981000", label: "98.10.00 - Komponen kapal dari Bab 90" },
  { value: "981100", label: "98.11.00 - Komponen kapal dari Bab lainnya" },
  // Bab 99 - Peranti lunak dan barang digital
  {
    value: "990000",
    label: "99.00.00 - Peranti lunak dan barang digital lainnya",
  },
  {
    value: "990100",
    label:
      "99.01.00 - Peranti lunak dan barang digital lainnya ditransmisikan secara elektronik",
  },

  // ===== JASA (klasifikasi DJP) =====
  // value diberi prefix "J" agar unik terhadap kode barang; `code` = kode 6 digit untuk XML.
  // Section 01 - Jasa Konstruksi
  {
    value: "J010000",
    code: "010000",
    label: "Jasa 01.00.00 - Jasa Konstruksi",
  },
  {
    value: "J010100",
    code: "010100",
    label: "Jasa 01.01.00 - Konstruksi umum untuk bangunan",
  },
  {
    value: "J010101",
    code: "010101",
    label: "Jasa 01.01.01 - Konstruksi umum bangunan tempat tinggal",
  },
  {
    value: "J010102",
    code: "010102",
    label: "Jasa 01.01.02 - Konstruksi umum bangunan bukan tempat tinggal",
  },
  {
    value: "J010200",
    code: "010200",
    label: "Jasa 01.02.00 - Konstruksi umum pekerjaan teknik sipil",
  },
  {
    value: "J010201",
    code: "010201",
    label:
      "Jasa 01.02.01 - Konstruksi jalan bebas hambatan/raya/kereta api/landasan",
  },
  {
    value: "J010202",
    code: "010202",
    label: "Jasa 01.02.02 - Konstruksi jembatan, jalan layang dan terowongan",
  },
  {
    value: "J010203",
    code: "010203",
    label: "Jasa 01.02.03 - Konstruksi pelabuhan, terusan, bendungan, irigasi",
  },
  {
    value: "J010204",
    code: "010204",
    label:
      "Jasa 01.02.04 - Konstruksi pipa jarak jauh, saluran komunikasi dan listrik",
  },
  {
    value: "J010205",
    code: "010205",
    label: "Jasa 01.02.05 - Konstruksi pipa saluran dan kabel lokal",
  },
  {
    value: "J010206",
    code: "010206",
    label: "Jasa 01.02.06 - Konstruksi pertambangan dan bangunan industri",
  },
  {
    value: "J010207",
    code: "010207",
    label:
      "Jasa 01.02.07 - Konstruksi fasilitas olahraga dan rekreasi ruang terbuka",
  },
  {
    value: "J010209",
    code: "010209",
    label: "Jasa 01.02.09 - Konstruksi pekerjaan teknik sipil lainnya",
  },
  {
    value: "J010300",
    code: "010300",
    label: "Jasa 01.03.00 - Penyiapan tempat",
  },
  { value: "J010301", code: "010301", label: "Jasa 01.03.01 - Pembongkaran" },
  {
    value: "J010302",
    code: "010302",
    label: "Jasa 01.03.02 - Pembentukan dan pembersihan tempat",
  },
  {
    value: "J010303",
    code: "010303",
    label: "Jasa 01.03.03 - Penggalian dan pemindahan tanah",
  },
  {
    value: "J010304",
    code: "010304",
    label: "Jasa 01.03.04 - Pengeboran sumur air bersih dan sistem septik",
  },
  {
    value: "J010400",
    code: "010400",
    label: "Jasa 01.04.00 - Perakitan dan pembangunan konstruksi prafabrikan",
  },
  {
    value: "J010401",
    code: "010401",
    label: "Jasa 01.04.01 - Perakitan dan pembangunan konstruksi prafabrikan",
  },
  {
    value: "J010500",
    code: "010500",
    label: "Jasa 01.05.00 - Konstruksi ketrampilan khusus",
  },
  {
    value: "J010501",
    code: "010501",
    label: "Jasa 01.05.01 - Pemancangan tiang ke dalam tanah dan pondasi",
  },
  {
    value: "J010502",
    code: "010502",
    label: "Jasa 01.05.02 - Pemasangan kerangka konstruksi",
  },
  {
    value: "J010503",
    code: "010503",
    label: "Jasa 01.05.03 - Pemasangan atap dan pembuatan tahan air",
  },
  {
    value: "J010504",
    code: "010504",
    label: "Jasa 01.05.04 - Pemasangan beton",
  },
  {
    value: "J010505",
    code: "010505",
    label: "Jasa 01.05.05 - Pembangunan struktur baja",
  },
  {
    value: "J010506",
    code: "010506",
    label: "Jasa 01.05.06 - Tukang bangunan",
  },
  {
    value: "J010507",
    code: "010507",
    label: "Jasa 01.05.07 - Perancah (scaffolding)",
  },
  {
    value: "J010509",
    code: "010509",
    label: "Jasa 01.05.09 - Konstruksi ketrampilan khusus lainnya",
  },
  { value: "J010600", code: "010600", label: "Jasa 01.06.00 - Instalasi" },
  {
    value: "J010601",
    code: "010601",
    label: "Jasa 01.06.01 - Instalasi listrik",
  },
  {
    value: "J010602",
    code: "010602",
    label:
      "Jasa 01.06.02 - Instalasi pipa air (plumbing) dan pemasangan saluran",
  },
  {
    value: "J010603",
    code: "010603",
    label: "Jasa 01.06.03 - Instalasi peralatan pemanas ruangan",
  },
  {
    value: "J010604",
    code: "010604",
    label: "Jasa 01.06.04 - Instalasi perlengkapan gas",
  },
  { value: "J010605", code: "010605", label: "Jasa 01.06.05 - Penyekatan" },
  {
    value: "J010609",
    code: "010609",
    label: "Jasa 01.06.09 - Instalasi lainnya",
  },
  {
    value: "J010700",
    code: "010700",
    label: "Jasa 01.07.00 - Pekerjaan akhir dan penyelesaian gedung",
  },
  {
    value: "J010701",
    code: "010701",
    label: "Jasa 01.07.01 - Pemasangan kaca",
  },
  {
    value: "J010702",
    code: "010702",
    label: "Jasa 01.07.02 - Pelapisan plester",
  },
  { value: "J010703", code: "010703", label: "Jasa 01.07.03 - Pengecatan" },
  {
    value: "J010704",
    code: "010704",
    label: "Jasa 01.07.04 - Pemasangan ubin lantai dan dinding",
  },
  {
    value: "J010705",
    code: "010705",
    label:
      "Jasa 01.07.05 - Pemasangan lantai, penutupan dan pelapisan dinding lainnya",
  },
  {
    value: "J010706",
    code: "010706",
    label: "Jasa 01.07.06 - Pekerjaan tukang kayu (carpentry & joinery)",
  },
  {
    value: "J010707",
    code: "010707",
    label: "Jasa 01.07.07 - Pemasangan pagar dan susuran tangga",
  },
  {
    value: "J010709",
    code: "010709",
    label: "Jasa 01.07.09 - Pekerjaan akhir dan penyelesaian bangunan lainnya",
  },
  // Section 02 - Jasa Perdagangan Besar
  {
    value: "J020000",
    code: "020000",
    label: "Jasa 02.00.00 - Perdagangan besar",
  },
  {
    value: "J020100",
    code: "020100",
    label:
      "Jasa 02.01.00 - Perdagangan besar (bukan atas dasar balas jasa/kontrak)",
  },
  {
    value: "J020101",
    code: "020101",
    label:
      "Jasa 02.01.01 - Perdagangan besar bahan mentah pertanian dan binatang hidup",
  },
  {
    value: "J020102",
    code: "020102",
    label: "Jasa 02.01.02 - Perdagangan besar makanan, minuman dan tembakau",
  },
  {
    value: "J020103",
    code: "020103",
    label: "Jasa 02.01.03 - Perdagangan besar tekstil, pakaian dan alas kaki",
  },
  {
    value: "J020104",
    code: "020104",
    label:
      "Jasa 02.01.04 - Perdagangan besar peralatan dan perlengkapan rumah tangga",
  },
  {
    value: "J020105",
    code: "020105",
    label: "Jasa 02.01.05 - Perdagangan besar barang konsumen lainnya",
  },
  {
    value: "J020106",
    code: "020106",
    label:
      "Jasa 02.01.06 - Perdagangan besar bahan dan perangkat keras konstruksi",
  },
  {
    value: "J020107",
    code: "020107",
    label: "Jasa 02.01.07 - Perdagangan besar produk kimia dan farmasi",
  },
  {
    value: "J020108",
    code: "020108",
    label: "Jasa 02.01.08 - Perdagangan besar mesin, peralatan dan suku cadang",
  },
  {
    value: "J020109",
    code: "020109",
    label: "Jasa 02.01.09 - Perdagangan besar produk lainnya",
  },
  {
    value: "J020200",
    code: "020200",
    label:
      "Jasa 02.02.00 - Perdagangan besar atas dasar balas jasa atau kontrak",
  },
  {
    value: "J020201",
    code: "020201",
    label:
      "Jasa 02.02.01 - Perdagangan besar (kontrak) bahan mentah pertanian/binatang hidup",
  },
  {
    value: "J020202",
    code: "020202",
    label:
      "Jasa 02.02.02 - Perdagangan besar (kontrak) makanan, minuman dan tembakau",
  },
  {
    value: "J020203",
    code: "020203",
    label:
      "Jasa 02.02.03 - Perdagangan besar (kontrak) tekstil, pakaian dan alas kaki",
  },
  {
    value: "J020204",
    code: "020204",
    label: "Jasa 02.02.04 - Perdagangan besar (kontrak) peralatan rumah tangga",
  },
  {
    value: "J020205",
    code: "020205",
    label:
      "Jasa 02.02.05 - Perdagangan besar (kontrak) barang konsumen lainnya",
  },
  {
    value: "J020206",
    code: "020206",
    label:
      "Jasa 02.02.06 - Perdagangan besar (kontrak) bahan dan perangkat keras konstruksi",
  },
  {
    value: "J020207",
    code: "020207",
    label:
      "Jasa 02.02.07 - Perdagangan besar (kontrak) produk kimia dan farmasi",
  },
  {
    value: "J020208",
    code: "020208",
    label:
      "Jasa 02.02.08 - Perdagangan besar (kontrak) mesin, peralatan dan suku cadang",
  },
  {
    value: "J020209",
    code: "020209",
    label: "Jasa 02.02.09 - Perdagangan besar (kontrak) produk lainnya",
  },
  // Section 03 - Jasa Perdagangan Eceran
  {
    value: "J030000",
    code: "030000",
    label: "Jasa 03.00.00 - Perdagangan eceran",
  },
  {
    value: "J030100",
    code: "030100",
    label: "Jasa 03.01.00 - Perdagangan eceran bukan di toko khusus",
  },
  {
    value: "J030101",
    code: "030101",
    label: "Jasa 03.01.01 - Perdagangan eceran bukan di toko khusus",
  },
  {
    value: "J030200",
    code: "030200",
    label: "Jasa 03.02.00 - Perdagangan eceran di toko khusus",
  },
  {
    value: "J030201",
    code: "030201",
    label:
      "Jasa 03.02.01 - Eceran toko khusus bahan mentah pertanian/binatang hidup",
  },
  {
    value: "J030202",
    code: "030202",
    label: "Jasa 03.02.02 - Eceran toko khusus makanan, minuman dan tembakau",
  },
  {
    value: "J030203",
    code: "030203",
    label: "Jasa 03.02.03 - Eceran toko khusus tekstil, pakaian dan alas kaki",
  },
  {
    value: "J030204",
    code: "030204",
    label:
      "Jasa 03.02.04 - Eceran toko khusus peralatan dan perlengkapan rumah tangga",
  },
  {
    value: "J030205",
    code: "030205",
    label: "Jasa 03.02.05 - Eceran toko khusus barang konsumen lainnya",
  },
  {
    value: "J030206",
    code: "030206",
    label:
      "Jasa 03.02.06 - Eceran toko khusus bahan dan perangkat keras konstruksi",
  },
  {
    value: "J030207",
    code: "030207",
    label: "Jasa 03.02.07 - Eceran toko khusus produk kimia dan farmasi",
  },
  {
    value: "J030208",
    code: "030208",
    label:
      "Jasa 03.02.08 - Eceran toko khusus mesin, peralatan dan suku cadang",
  },
  {
    value: "J030209",
    code: "030209",
    label: "Jasa 03.02.09 - Eceran toko khusus produk lainnya",
  },
  {
    value: "J030300",
    code: "030300",
    label: "Jasa 03.03.00 - Perdagangan eceran via pos atau internet",
  },
  {
    value: "J030301",
    code: "030301",
    label:
      "Jasa 03.03.01 - Eceran pos/internet bahan mentah pertanian/binatang hidup",
  },
  {
    value: "J030302",
    code: "030302",
    label: "Jasa 03.03.02 - Eceran pos/internet makanan, minuman dan tembakau",
  },
  {
    value: "J030303",
    code: "030303",
    label: "Jasa 03.03.03 - Eceran pos/internet tekstil, pakaian dan alas kaki",
  },
  {
    value: "J030304",
    code: "030304",
    label: "Jasa 03.03.04 - Eceran pos/internet peralatan rumah tangga",
  },
  {
    value: "J030305",
    code: "030305",
    label: "Jasa 03.03.05 - Eceran pos/internet barang konsumen lainnya",
  },
  {
    value: "J030306",
    code: "030306",
    label:
      "Jasa 03.03.06 - Eceran pos/internet bahan dan perangkat keras konstruksi",
  },
  {
    value: "J030307",
    code: "030307",
    label: "Jasa 03.03.07 - Eceran pos/internet produk kimia dan farmasi",
  },
  {
    value: "J030308",
    code: "030308",
    label:
      "Jasa 03.03.08 - Eceran pos/internet mesin, peralatan dan suku cadang",
  },
  {
    value: "J030309",
    code: "030309",
    label: "Jasa 03.03.09 - Eceran pos/internet produk lainnya",
  },
  {
    value: "J030400",
    code: "030400",
    label: "Jasa 03.04.00 - Perdagangan eceran bukan toko lainnya",
  },
  {
    value: "J030401",
    code: "030401",
    label:
      "Jasa 03.04.01 - Eceran bukan toko bahan mentah pertanian/binatang hidup",
  },
  {
    value: "J030402",
    code: "030402",
    label: "Jasa 03.04.02 - Eceran bukan toko makanan, minuman dan tembakau",
  },
  {
    value: "J030403",
    code: "030403",
    label: "Jasa 03.04.03 - Eceran bukan toko tekstil, pakaian dan alas kaki",
  },
  {
    value: "J030404",
    code: "030404",
    label: "Jasa 03.04.04 - Eceran bukan toko peralatan rumah tangga",
  },
  {
    value: "J030405",
    code: "030405",
    label: "Jasa 03.04.05 - Eceran bukan toko barang konsumen lainnya",
  },
  {
    value: "J030406",
    code: "030406",
    label:
      "Jasa 03.04.06 - Eceran bukan toko bahan dan perangkat keras konstruksi",
  },
  {
    value: "J030407",
    code: "030407",
    label: "Jasa 03.04.07 - Eceran bukan toko produk kimia dan farmasi",
  },
  {
    value: "J030408",
    code: "030408",
    label: "Jasa 03.04.08 - Eceran bukan toko mesin, peralatan dan suku cadang",
  },
  {
    value: "J030409",
    code: "030409",
    label: "Jasa 03.04.09 - Eceran bukan toko produk lainnya",
  },
  {
    value: "J030500",
    code: "030500",
    label:
      "Jasa 03.05.00 - Perdagangan eceran atas dasar balas jasa atau kontrak",
  },
  {
    value: "J030501",
    code: "030501",
    label:
      "Jasa 03.05.01 - Eceran (kontrak) bahan mentah pertanian/binatang hidup",
  },
  {
    value: "J030502",
    code: "030502",
    label: "Jasa 03.05.02 - Eceran (kontrak) makanan, minuman dan tembakau",
  },
  {
    value: "J030503",
    code: "030503",
    label: "Jasa 03.05.03 - Eceran (kontrak) tekstil, pakaian dan alas kaki",
  },
  {
    value: "J030504",
    code: "030504",
    label:
      "Jasa 03.05.04 - Eceran (kontrak) peralatan dan perlengkapan rumah tangga",
  },
  {
    value: "J030505",
    code: "030505",
    label: "Jasa 03.05.05 - Eceran (kontrak) barang konsumen lainnya",
  },
  {
    value: "J030506",
    code: "030506",
    label:
      "Jasa 03.05.06 - Eceran (kontrak) bahan dan perangkat keras konstruksi",
  },
  {
    value: "J030507",
    code: "030507",
    label: "Jasa 03.05.07 - Eceran (kontrak) produk kimia dan farmasi",
  },
  {
    value: "J030508",
    code: "030508",
    label: "Jasa 03.05.08 - Eceran (kontrak) mesin, peralatan dan suku cadang",
  },
  {
    value: "J030509",
    code: "030509",
    label: "Jasa 03.05.09 - Eceran (kontrak) produk lainnya",
  },
  // Section 04 - Akomodasi, Makanan dan Minuman
  {
    value: "J040000",
    code: "040000",
    label: "Jasa 04.00.00 - Penyediaan akomodasi, makanan dan minuman",
  },
  {
    value: "J040100",
    code: "040100",
    label: "Jasa 04.01.00 - Akomodasi untuk wisatawan",
  },
  {
    value: "J040101",
    code: "040101",
    label: "Jasa 04.01.01 - Akomodasi penyediaan ruangan/kamar untuk wisatawan",
  },
  {
    value: "J040102",
    code: "040102",
    label: "Jasa 04.01.02 - Tempat perkemahan",
  },
  {
    value: "J040103",
    code: "040103",
    label: "Jasa 04.01.03 - Perkemahan dan rekreasi",
  },
  {
    value: "J040200",
    code: "040200",
    label: "Jasa 04.02.00 - Akomodasi penginapan lainnya",
  },
  {
    value: "J040201",
    code: "040201",
    label: "Jasa 04.02.01 - Akomodasi ruangan/kamar untuk pelajar di asrama",
  },
  {
    value: "J040202",
    code: "040202",
    label:
      "Jasa 04.02.02 - Akomodasi ruangan/kamar untuk pekerja di asrama/perkemahan",
  },
  {
    value: "J040209",
    code: "040209",
    label: "Jasa 04.02.09 - Akomodasi penyediaan ruangan/kamar lainnya",
  },
  {
    value: "J040300",
    code: "040300",
    label: "Jasa 04.03.00 - Penyediaan/pelayanan makanan",
  },
  {
    value: "J040301",
    code: "040301",
    label: "Jasa 04.03.01 - Pelayanan makanan dengan pelayanan penuh restoran",
  },
  {
    value: "J040302",
    code: "040302",
    label: "Jasa 04.03.02 - Penyediaan makanan dengan pelayanan terbatas",
  },
  {
    value: "J040309",
    code: "040309",
    label: "Jasa 04.03.09 - Katering untuk acara tertentu",
  },
  {
    value: "J040400",
    code: "040400",
    label: "Jasa 04.04.00 - Penyediaan minuman",
  },
  {
    value: "J040401",
    code: "040401",
    label: "Jasa 04.04.01 - Penyediaan minuman",
  },
  // Section 05 - Transportasi/Angkutan Penumpang
  {
    value: "J050000",
    code: "050000",
    label: "Jasa 05.00.00 - Transportasi/angkutan penumpang",
  },
  {
    value: "J050100",
    code: "050100",
    label: "Jasa 05.01.00 - Angkutan penumpang lokal dan untuk bertamasya",
  },
  {
    value: "J050101",
    code: "050101",
    label: "Jasa 05.01.01 - Angkutan darat penumpang kota dan pinggiran",
  },
  {
    value: "J050102",
    code: "050102",
    label: "Jasa 05.01.02 - Angkutan air lokal untuk penumpang",
  },
  {
    value: "J050103",
    code: "050103",
    label: "Jasa 05.01.03 - Angkutan untuk wisata",
  },
  {
    value: "J050200",
    code: "050200",
    label: "Jasa 05.02.00 - Angkutan penumpang jarak jauh",
  },
  {
    value: "J050201",
    code: "050201",
    label: "Jasa 05.02.01 - Angkutan penumpang antarkota dengan kereta api",
  },
  {
    value: "J050202",
    code: "050202",
    label: "Jasa 05.02.02 - Angkutan jalan raya antarkota untuk penumpang",
  },
  {
    value: "J050203",
    code: "050203",
    label: "Jasa 05.02.03 - Angkutan air jarak jauh untuk penumpang",
  },
  {
    value: "J050204",
    code: "050204",
    label: "Jasa 05.02.04 - Angkutan udara untuk penumpang",
  },
  {
    value: "J050205",
    code: "050205",
    label: "Jasa 05.02.05 - Angkutan luar angkasa untuk penumpang",
  },
  // Section 06 - Angkutan Barang
  {
    value: "J060000",
    code: "060000",
    label: "Jasa 06.00.00 - Angkutan barang",
  },
  {
    value: "J060100",
    code: "060100",
    label: "Jasa 06.01.00 - Angkutan barang melalui darat",
  },
  {
    value: "J060101",
    code: "060101",
    label: "Jasa 06.01.01 - Angkutan barang melalui jalan raya",
  },
  {
    value: "J060102",
    code: "060102",
    label: "Jasa 06.01.02 - Angkutan barang melalui kereta api",
  },
  {
    value: "J060103",
    code: "060103",
    label: "Jasa 06.01.03 - Angkutan melalui jaringan pipa",
  },
  {
    value: "J060200",
    code: "060200",
    label: "Jasa 06.02.00 - Angkutan air untuk barang",
  },
  {
    value: "J060201",
    code: "060201",
    label:
      "Jasa 06.02.01 - Angkutan perairan pantai/lintas samudra (kapal berpendingin)",
  },
  {
    value: "J060202",
    code: "060202",
    label: "Jasa 06.02.02 - Angkutan air di perairan dalam untuk barang",
  },
  {
    value: "J060300",
    code: "060300",
    label: "Jasa 06.03.00 - Angkutan barang melalui udara dan angkasa",
  },
  {
    value: "J060301",
    code: "060301",
    label: "Jasa 06.03.01 - Angkutan barang melalui udara",
  },
  {
    value: "J060302",
    code: "060302",
    label: "Jasa 06.03.02 - Angkutan barang melalui luar angkasa",
  },
  // Section 07 - Penyewaan Kendaraan Angkutan dengan Operator
  {
    value: "J070000",
    code: "070000",
    label:
      "Jasa 07.00.00 - Penyewaan kendaraan angkutan dengan petugas operator",
  },
  {
    value: "J070100",
    code: "070100",
    label:
      "Jasa 07.01.00 - Penyewaan kendaraan angkutan dengan petugas operator",
  },
  {
    value: "J070101",
    code: "070101",
    label: "Jasa 07.01.01 - Penyewaan kendaraan angkutan darat dengan operator",
  },
  {
    value: "J070102",
    code: "070102",
    label: "Jasa 07.01.02 - Penyewaan kapal dengan operator",
  },
  {
    value: "J070103",
    code: "070103",
    label: "Jasa 07.01.03 - Penyewaan pesawat udara dengan operator",
  },
  // Section 08 - Pendukung Angkutan
  {
    value: "J080000",
    code: "080000",
    label: "Jasa 08.00.00 - Pendukung angkutan",
  },
  {
    value: "J080100",
    code: "080100",
    label: "Jasa 08.01.00 - Bongkar muat barang",
  },
  {
    value: "J080101",
    code: "080101",
    label: "Jasa 08.01.01 - Bongkar muat kontainer",
  },
  {
    value: "J080109",
    code: "080109",
    label: "Jasa 08.01.09 - Bongkar muat kargo dan bagasi lainnya",
  },
  {
    value: "J080200",
    code: "080200",
    label: "Jasa 08.02.00 - Penyimpanan dan pergudangan",
  },
  {
    value: "J080201",
    code: "080201",
    label: "Jasa 08.02.01 - Penyimpanan dengan pendingin",
  },
  {
    value: "J080202",
    code: "080202",
    label:
      "Jasa 08.02.02 - Penyimpanan barang gas dan cair dalam jumlah banyak",
  },
  {
    value: "J080209",
    code: "080209",
    label: "Jasa 08.02.09 - Penyimpanan dan pergudangan lainnya",
  },
  {
    value: "J080300",
    code: "080300",
    label: "Jasa 08.03.00 - Pendukung untuk angkutan kereta api",
  },
  {
    value: "J080301",
    code: "080301",
    label: "Jasa 08.03.01 - Pendorong dan penarik angkutan kereta api",
  },
  {
    value: "J080309",
    code: "080309",
    label: "Jasa 08.03.09 - Pendukung lainnya untuk angkutan kereta api",
  },
  {
    value: "J080400",
    code: "080400",
    label: "Jasa 08.04.00 - Pendukung untuk angkutan darat",
  },
  { value: "J080401", code: "080401", label: "Jasa 08.04.01 - Terminal bus" },
  {
    value: "J080402",
    code: "080402",
    label: "Jasa 08.04.02 - Pengoperasian jalan raya, jembatan dan terowongan",
  },
  { value: "J080403", code: "080403", label: "Jasa 08.04.03 - Parkir" },
  {
    value: "J080404",
    code: "080404",
    label: "Jasa 08.04.04 - Derek untuk kendaraan pribadi dan komersil",
  },
  {
    value: "J080409",
    code: "080409",
    label: "Jasa 08.04.09 - Pendukung lainnya untuk angkutan darat",
  },
  {
    value: "J080500",
    code: "080500",
    label: "Jasa 08.05.00 - Pendukung untuk angkutan air",
  },
  {
    value: "J080501",
    code: "080501",
    label: "Jasa 08.05.01 - Pengoperasian pelabuhan dan jalan air",
  },
  {
    value: "J080502",
    code: "080502",
    label: "Jasa 08.05.02 - Pemandu dan penambat kapal",
  },
  {
    value: "J080503",
    code: "080503",
    label: "Jasa 08.05.03 - Kapal penyelamat dan pelampung",
  },
  {
    value: "J080509",
    code: "080509",
    label: "Jasa 08.05.09 - Pendukung lainnya untuk angkutan air",
  },
  {
    value: "J080600",
    code: "080600",
    label: "Jasa 08.06.00 - Pendukung untuk angkutan udara atau angkasa",
  },
  {
    value: "J080601",
    code: "080601",
    label:
      "Jasa 08.06.01 - Operasional bandar udara (kecuali penanganan kargo)",
  },
  {
    value: "J080602",
    code: "080602",
    label: "Jasa 08.06.02 - Pengatur lalu lintas udara",
  },
  {
    value: "J080603",
    code: "080603",
    label: "Jasa 08.06.03 - Pendukung lainnya untuk angkutan udara",
  },
  {
    value: "J080604",
    code: "080604",
    label: "Jasa 08.06.04 - Pendukung untuk angkutan luar angkasa",
  },
  {
    value: "J080900",
    code: "080900",
    label: "Jasa 08.09.00 - Pendukung angkutan lainnya",
  },
  {
    value: "J080901",
    code: "080901",
    label:
      "Jasa 08.09.01 - Agen angkutan barang dan jasa angkutan barang lainnya",
  },
  {
    value: "J080909",
    code: "080909",
    label: "Jasa 08.09.09 - Pendukung angkutan lainnya",
  },
  // Section 09 - Pos dan Kurir
  { value: "J090000", code: "090000", label: "Jasa 09.00.00 - Pos dan kurir" },
  { value: "J090100", code: "090100", label: "Jasa 09.01.00 - Pos dan kurir" },
  { value: "J090101", code: "090101", label: "Jasa 09.01.01 - Pos" },
  { value: "J090102", code: "090102", label: "Jasa 09.01.02 - Kurir" },
  {
    value: "J090103",
    code: "090103",
    label: "Jasa 09.01.03 - Pengiriman barang lokal",
  },
  // Section 10 - Distribusi Listrik, Gas dan Air (atas usaha sendiri)
  {
    value: "J100000",
    code: "100000",
    label: "Jasa 10.00.00 - Distribusi listrik, gas dan air atas usaha sendiri",
  },
  {
    value: "J100100",
    code: "100100",
    label: "Jasa 10.01.00 - Distribusi listrik dan gas atas usaha sendiri",
  },
  {
    value: "J100101",
    code: "100101",
    label:
      "Jasa 10.01.01 - Distribusi dan transmisi listrik atas usaha sendiri",
  },
  {
    value: "J100102",
    code: "100102",
    label: "Jasa 10.01.02 - Distribusi gas melalui saluran atas usaha sendiri",
  },
  {
    value: "J100200",
    code: "100200",
    label: "Jasa 10.02.00 - Distribusi air atas usaha sendiri",
  },
  {
    value: "J100201",
    code: "100201",
    label:
      "Jasa 10.02.01 - Distribusi air langsung dari sumber air (kecuali air panas/uap)",
  },
  {
    value: "J100202",
    code: "100202",
    label:
      "Jasa 10.02.02 - Distribusi uap, air panas dan air dingin dari sumber",
  },
  {
    value: "J100203",
    code: "100203",
    label: "Jasa 10.02.03 - Distribusi air selain melalui saluran",
  },
  // Section 11 - Keuangan
  {
    value: "J110000",
    code: "110000",
    label: "Jasa 11.00.00 - Keuangan dan yang berhubungan dengannya",
  },
  {
    value: "J110100",
    code: "110100",
    label:
      "Jasa 11.01.00 - Keuangan (kecuali investasi perbankan, asuransi & pensiun)",
  },
  { value: "J110101", code: "110101", label: "Jasa 11.01.01 - Bank sentral" },
  {
    value: "J110102",
    code: "110102",
    label: "Jasa 11.01.02 - Penyimpanan uang/deposito",
  },
  {
    value: "J110103",
    code: "110103",
    label: "Jasa 11.01.03 - Pemberian pinjaman",
  },
  {
    value: "J110104",
    code: "110104",
    label: "Jasa 11.01.04 - Leasing keuangan",
  },
  {
    value: "J110109",
    code: "110109",
    label: "Jasa 11.01.09 - Keuangan lainnya",
  },
  {
    value: "J110200",
    code: "110200",
    label: "Jasa 11.02.00 - Investasi perbankan",
  },
  {
    value: "J110201",
    code: "110201",
    label: "Jasa 11.02.01 - Investasi perbankan",
  },
  {
    value: "J110300",
    code: "110300",
    label: "Jasa 11.03.00 - Asuransi dan pensiun di luar reasuransi",
  },
  {
    value: "J110301",
    code: "110301",
    label: "Jasa 11.03.01 - Asuransi dan pensiun di luar reasuransi",
  },
  {
    value: "J110302",
    code: "110302",
    label: "Jasa 11.03.02 - Asuransi kecelakaan dan kesehatan",
  },
  {
    value: "J110303",
    code: "110303",
    label: "Jasa 11.03.03 - Asuransi bukan jiwa lainnya di luar reasuransi",
  },
  { value: "J110400", code: "110400", label: "Jasa 11.04.00 - Reasuransi" },
  {
    value: "J110401",
    code: "110401",
    label: "Jasa 11.04.01 - Reasuransi jiwa",
  },
  {
    value: "J110402",
    code: "110402",
    label: "Jasa 11.04.02 - Reasuransi kecelakaan dan kesehatan",
  },
  {
    value: "J110403",
    code: "110403",
    label: "Jasa 11.04.03 - Reasuransi bukan jiwa lainnya",
  },
  {
    value: "J110500",
    code: "110500",
    label:
      "Jasa 11.05.00 - Penunjang jasa keuangan selain asuransi dan pensiun",
  },
  {
    value: "J110501",
    code: "110501",
    label: "Jasa 11.05.01 - Berhubungan dengan investasi perbankan",
  },
  {
    value: "J110502",
    code: "110502",
    label: "Jasa 11.05.02 - Perdagangan perantara surat berharga dan komoditas",
  },
  {
    value: "J110503",
    code: "110503",
    label: "Jasa 11.05.03 - Manajemen portofolio (kecuali dana pensiun)",
  },
  {
    value: "J110504",
    code: "110504",
    label: "Jasa 11.05.04 - Wali amanat (trust dan custody)",
  },
  {
    value: "J110505",
    code: "110505",
    label: "Jasa 11.05.05 - Berhubungan dengan administrasi pasar uang",
  },
  {
    value: "J110509",
    code: "110509",
    label: "Jasa 11.05.09 - Pendukung lainnya untuk jasa keuangan",
  },
  {
    value: "J110600",
    code: "110600",
    label: "Jasa 11.06.00 - Penunjang untuk asuransi dan pensiun",
  },
  {
    value: "J110601",
    code: "110601",
    label: "Jasa 11.06.01 - Pedagang perantara dan agen asuransi",
  },
  {
    value: "J110602",
    code: "110602",
    label: "Jasa 11.06.02 - Pencocokan klaim asuransi",
  },
  { value: "J110603", code: "110603", label: "Jasa 11.06.03 - Aktuaria" },
  {
    value: "J110604",
    code: "110604",
    label: "Jasa 11.06.04 - Manajemen dana pensiun",
  },
  {
    value: "J110609",
    code: "110609",
    label: "Jasa 11.06.09 - Penunjang lainnya untuk asuransi dan pensiun",
  },
  {
    value: "J110700",
    code: "110700",
    label: "Jasa 11.07.00 - Penyimpanan aset keuangan",
  },
  {
    value: "J110701",
    code: "110701",
    label: "Jasa 11.07.01 - Penyimpanan aset keuangan",
  },
  // Section 12 - Real Estate
  { value: "J120000", code: "120000", label: "Jasa 12.00.00 - Real estate" },
  {
    value: "J120100",
    code: "120100",
    label: "Jasa 12.01.00 - Real estate properti milik sendiri atau disewakan",
  },
  {
    value: "J120101",
    code: "120101",
    label:
      "Jasa 12.01.01 - Persewaan tanah/bangunan milik sendiri atau disewakan",
  },
  {
    value: "J120102",
    code: "120102",
    label: "Jasa 12.01.02 - Perdagangan bangunan",
  },
  {
    value: "J120103",
    code: "120103",
    label: "Jasa 12.01.03 - Perdagangan tanah kosong dan tanah kavling",
  },
  {
    value: "J120200",
    code: "120200",
    label: "Jasa 12.02.00 - Real estate atas dasar balas jasa atau kontrak",
  },
  {
    value: "J120201",
    code: "120201",
    label: "Jasa 12.02.01 - Manajemen properti atas dasar balas jasa/kontrak",
  },
  {
    value: "J120202",
    code: "120202",
    label: "Jasa 12.02.02 - Penjualan bangunan atas dasar balas jasa/kontrak",
  },
  {
    value: "J120203",
    code: "120203",
    label: "Jasa 12.02.03 - Penjualan tanah atas dasar balas jasa/kontrak",
  },
  {
    value: "J120204",
    code: "120204",
    label: "Jasa 12.02.04 - Penilai real estate atas dasar balas jasa/kontrak",
  },
  // Section 13 - Leasing/Persewaan Tanpa Operator; Lisensi PI
  {
    value: "J130000",
    code: "130000",
    label: "Jasa 13.00.00 - Leasing atau persewaan tanpa petugas operator",
  },
  {
    value: "J130100",
    code: "130100",
    label:
      "Jasa 13.01.00 - Leasing/persewaan mesin dan perlengkapan tanpa operator",
  },
  {
    value: "J130101",
    code: "130101",
    label: "Jasa 13.01.01 - Leasing/persewaan angkutan tanpa operator",
  },
  {
    value: "J130102",
    code: "130102",
    label:
      "Jasa 13.01.02 - Leasing/persewaan mesin dan perlengkapan lainnya tanpa operator",
  },
  {
    value: "J130200",
    code: "130200",
    label: "Jasa 13.02.00 - Leasing atau persewaan barang-barang lainnya",
  },
  {
    value: "J130201",
    code: "130201",
    label:
      "Jasa 13.02.01 - Persewaan televisi, radio, perekam video dan aksesorinya",
  },
  {
    value: "J130202",
    code: "130202",
    label: "Jasa 13.02.02 - Persewaan pemutar dan keping video",
  },
  {
    value: "J130203",
    code: "130203",
    label: "Jasa 13.02.03 - Persewaan furnitur dan perlengkapan rumah tangga",
  },
  {
    value: "J130204",
    code: "130204",
    label: "Jasa 13.02.04 - Persewaan perlengkapan untuk rekreasi/tamasya",
  },
  {
    value: "J130205",
    code: "130205",
    label: "Jasa 13.02.05 - Persewaan kain linen rumah tangga",
  },
  {
    value: "J130206",
    code: "130206",
    label: "Jasa 13.02.06 - Persewaan barang tekstil, pakaian dan alas kaki",
  },
  {
    value: "J130207",
    code: "130207",
    label: "Jasa 13.02.07 - Persewaan mesin otomatis dan peralatannya",
  },
  {
    value: "J130209",
    code: "130209",
    label: "Jasa 13.02.09 - Persewaan barang-barang lainnya",
  },
  {
    value: "J130300",
    code: "130300",
    label: "Jasa 13.03.00 - Lisensi untuk hak penggunaan properti intelektual",
  },
  {
    value: "J130301",
    code: "130301",
    label: "Jasa 13.03.01 - Lisensi perangkat lunak komputer dan basis data",
  },
  {
    value: "J130302",
    code: "130302",
    label: "Jasa 13.03.02 - Lisensi hiburan, literatur dan artistik asli",
  },
  {
    value: "J130303",
    code: "130303",
    label: "Jasa 13.03.03 - Lisensi produk penelitian dan pengembangan",
  },
  {
    value: "J130304",
    code: "130304",
    label: "Jasa 13.03.04 - Lisensi merk dagang dan waralaba",
  },
  {
    value: "J130305",
    code: "130305",
    label: "Jasa 13.03.05 - Lisensi eksplorasi dan evaluasi mineral",
  },
  {
    value: "J130309",
    code: "130309",
    label: "Jasa 13.03.09 - Lisensi produk properti intelektual lainnya",
  },
  // Section 14 - Penelitian dan Pengembangan
  {
    value: "J140000",
    code: "140000",
    label: "Jasa 14.00.00 - Penelitian dan pengembangan",
  },
  {
    value: "J140100",
    code: "140100",
    label: "Jasa 14.01.00 - Penelitian dan percobaan ilmu alam dan rekayasa",
  },
  {
    value: "J140101",
    code: "140101",
    label: "Jasa 14.01.01 - Penelitian dan percobaan ilmu alam",
  },
  {
    value: "J140102",
    code: "140102",
    label:
      "Jasa 14.01.02 - Penelitian dan percobaan ilmu rekayasa dan teknologi",
  },
  {
    value: "J140103",
    code: "140103",
    label:
      "Jasa 14.01.03 - Penelitian dan percobaan ilmu kedokteran dan farmasi",
  },
  {
    value: "J140104",
    code: "140104",
    label: "Jasa 14.01.04 - Penelitian dan percobaan ilmu pertanian",
  },
  {
    value: "J140200",
    code: "140200",
    label: "Jasa 14.02.00 - Penelitian dan percobaan ilmu sosial dan humaniora",
  },
  {
    value: "J140201",
    code: "140201",
    label: "Jasa 14.02.01 - Penelitian dan percobaan ilmu sosial",
  },
  {
    value: "J140202",
    code: "140202",
    label: "Jasa 14.02.02 - Penelitian dan percobaan ilmu humaniora",
  },
  {
    value: "J140300",
    code: "140300",
    label:
      "Jasa 14.03.00 - Penelitian dan percobaan antar cabang ilmu pengetahuan",
  },
  {
    value: "J140301",
    code: "140301",
    label:
      "Jasa 14.03.01 - Penelitian dan percobaan antar cabang ilmu pengetahuan",
  },
  {
    value: "J140400",
    code: "140400",
    label: "Jasa 14.04.00 - Penelitian dan pengembangan orisinil",
  },
  {
    value: "J140401",
    code: "140401",
    label: "Jasa 14.04.01 - Penelitian dan pengembangan orisinil",
  },
  // Section 15 - Hukum dan Akuntansi
  {
    value: "J150000",
    code: "150000",
    label: "Jasa 15.00.00 - Hukum dan akuntansi",
  },
  { value: "J150100", code: "150100", label: "Jasa 15.01.00 - Hukum" },
  {
    value: "J150101",
    code: "150101",
    label: "Jasa 15.01.01 - Penasehat dan perwakilan hukum (pidana)",
  },
  {
    value: "J150102",
    code: "150102",
    label: "Jasa 15.01.02 - Penasehat dan perwakilan hukum (lainnya)",
  },
  {
    value: "J150103",
    code: "150103",
    label: "Jasa 15.01.03 - Pembuatan dokumen dan sertifikat hukum",
  },
  { value: "J150109", code: "150109", label: "Jasa 15.01.09 - Hukum lainnya" },
  {
    value: "J150200",
    code: "150200",
    label: "Jasa 15.02.00 - Akuntansi, pemeriksaan keuangan dan pembukuan",
  },
  {
    value: "J150201",
    code: "150201",
    label: "Jasa 15.02.01 - Pemeriksaan keuangan",
  },
  {
    value: "J150202",
    code: "150202",
    label: "Jasa 15.02.02 - Akuntansi dan pembukuan",
  },
  {
    value: "J150300",
    code: "150300",
    label: "Jasa 15.03.00 - Konsultan pajak dan persiapannya",
  },
  {
    value: "J150301",
    code: "150301",
    label: "Jasa 15.03.01 - Konsultan pajak badan usaha dan persiapannya",
  },
  {
    value: "J150302",
    code: "150302",
    label: "Jasa 15.03.02 - Persiapan pajak pribadi dan perencanaannya",
  },
  {
    value: "J150400",
    code: "150400",
    label: "Jasa 15.04.00 - Bantuan usaha bangkrut dan pengawasan kurator",
  },
  {
    value: "J150401",
    code: "150401",
    label: "Jasa 15.04.01 - Bantuan usaha bangkrut dan pengawasan kurator",
  },
  // Section 16 - Ahli, Teknis dan Bisnis Lainnya
  {
    value: "J160000",
    code: "160000",
    label: "Jasa 16.00.00 - Ahli, teknis dan jasa bisnis lainnya",
  },
  {
    value: "J160100",
    code: "160100",
    label:
      "Jasa 16.01.00 - Konsultasi manajemen, manajemen, teknologi informasi",
  },
  {
    value: "J160101",
    code: "160101",
    label: "Jasa 16.01.01 - Konsultasi manajemen dan jasa manajemen",
  },
  {
    value: "J160102",
    code: "160102",
    label: "Jasa 16.01.02 - Konsultasi bisnis",
  },
  {
    value: "J160103",
    code: "160103",
    label: "Jasa 16.01.03 - Pendukung dan konsultan teknologi informasi",
  },
  {
    value: "J160104",
    code: "160104",
    label: "Jasa 16.01.04 - Desain dan pengembangan teknologi informasi",
  },
  {
    value: "J160105",
    code: "160105",
    label: "Jasa 16.01.05 - Hosting dan infrastruktur teknologi informasi",
  },
  {
    value: "J160109",
    code: "160109",
    label:
      "Jasa 16.01.09 - Manajemen lainnya (kecuali manajemen proyek konstruksi)",
  },
  {
    value: "J160200",
    code: "160200",
    label:
      "Jasa 16.02.00 - Arsitektur, perencanaan perkotaan, arsitektur pertamanan",
  },
  {
    value: "J160201",
    code: "160201",
    label: "Jasa 16.02.01 - Arsitektur dan penasehat arsitektur",
  },
  {
    value: "J160202",
    code: "160202",
    label: "Jasa 16.02.02 - Perencanaan wilayah dan kota",
  },
  {
    value: "J160203",
    code: "160203",
    label: "Jasa 16.02.03 - Arsitektur pertamanan",
  },
  {
    value: "J160300",
    code: "160300",
    label: "Jasa 16.03.00 - Keahlian teknik",
  },
  {
    value: "J160301",
    code: "160301",
    label: "Jasa 16.03.01 - Penasehat keahlian teknik",
  },
  {
    value: "J160302",
    code: "160302",
    label: "Jasa 16.03.02 - Keahlian teknik untuk proyek khusus",
  },
  {
    value: "J160303",
    code: "160303",
    label: "Jasa 16.03.03 - Manajemen proyek untuk proyek konstruksi",
  },
  {
    value: "J160400",
    code: "160400",
    label: "Jasa 16.04.00 - Ilmu pengetahuan dan teknik lainnya",
  },
  {
    value: "J160401",
    code: "160401",
    label: "Jasa 16.04.01 - Geologi, geofisika dan pencarian bijih lainnya",
  },
  {
    value: "J160402",
    code: "160402",
    label: "Jasa 16.04.02 - Penelitian permukaan tanah dan pembuatan peta",
  },
  {
    value: "J160403",
    code: "160403",
    label: "Jasa 16.04.03 - Peramalan cuaca dan meteorologi cuaca",
  },
  {
    value: "J160404",
    code: "160404",
    label: "Jasa 16.04.04 - Analisis dan uji teknis",
  },
  {
    value: "J160500",
    code: "160500",
    label: "Jasa 16.05.00 - Kedokteran hewan",
  },
  {
    value: "J160501",
    code: "160501",
    label: "Jasa 16.05.01 - Kedokteran hewan untuk hewan peliharaan",
  },
  {
    value: "J160502",
    code: "160502",
    label: "Jasa 16.05.02 - Kedokteran hewan untuk hewan ternak",
  },
  {
    value: "J160509",
    code: "160509",
    label: "Jasa 16.05.09 - Kedokteran hewan lainnya",
  },
  {
    value: "J160600",
    code: "160600",
    label: "Jasa 16.06.00 - Periklanan dan penyediaan tempat/waktu untuk iklan",
  },
  { value: "J160601", code: "160601", label: "Jasa 16.06.01 - Periklanan" },
  {
    value: "J160602",
    code: "160602",
    label: "Jasa 16.06.02 - Pembelian atau penjualan tempat/waktu untuk iklan",
  },
  {
    value: "J160603",
    code: "160603",
    label:
      "Jasa 16.06.03 - Pembelian dan penjualan tempat/waktu iklan (kecuali komisi)",
  },
  {
    value: "J160700",
    code: "160700",
    label: "Jasa 16.07.00 - Penelitian pasar dan jajak pendapat masyarakat",
  },
  {
    value: "J160701",
    code: "160701",
    label: "Jasa 16.07.01 - Penelitian pasar dan jajak pendapat masyarakat",
  },
  {
    value: "J160800",
    code: "160800",
    label: "Jasa 16.08.00 - Fotografi dan pencetakan hasilnya",
  },
  {
    value: "J160801",
    code: "160801",
    label: "Jasa 16.08.01 - Fotografi dan dokumentasi video",
  },
  {
    value: "J160802",
    code: "160802",
    label: "Jasa 16.08.02 - Proses fotografi",
  },
  {
    value: "J160900",
    code: "160900",
    label: "Jasa 16.09.00 - Ahli, teknik dan bisnis lainnya",
  },
  { value: "J160901", code: "160901", label: "Jasa 16.09.01 - Desain khusus" },
  { value: "J160902", code: "160902", label: "Jasa 16.09.02 - Desain asli" },
  {
    value: "J160903",
    code: "160903",
    label: "Jasa 16.09.03 - Konsultan ilmu pengetahuan dan ilmu teknik",
  },
  {
    value: "J160904",
    code: "160904",
    label: "Jasa 16.09.04 - Kumpulan informasi asli",
  },
  {
    value: "J160905",
    code: "160905",
    label: "Jasa 16.09.05 - Penerjemah dan interpretasi",
  },
  {
    value: "J160906",
    code: "160906",
    label: "Jasa 16.09.06 - Merk dagang dan hak perdagangan",
  },
  {
    value: "J160909",
    code: "160909",
    label: "Jasa 16.09.09 - Semua jasa ahli, teknis dan bisnis lainnya",
  },
  // Section 17 - Telekomunikasi, Penyiaran dan Informasi
  {
    value: "J170000",
    code: "170000",
    label: "Jasa 17.00.00 - Telekomunikasi, penyiaran dan penyediaan informasi",
  },
  {
    value: "J170100",
    code: "170100",
    label: "Jasa 17.01.00 - Telepon dan alat-alat telekomunikasi lainnya",
  },
  { value: "J170101", code: "170101", label: "Jasa 17.01.01 - Pusat layanan" },
  {
    value: "J170102",
    code: "170102",
    label: "Jasa 17.01.02 - Telefoni tidak bergerak",
  },
  {
    value: "J170103",
    code: "170103",
    label: "Jasa 17.01.03 - Alat telekomunikasi yang bergerak",
  },
  {
    value: "J170104",
    code: "170104",
    label: "Jasa 17.01.04 - Jaringan pribadi",
  },
  { value: "J170105", code: "170105", label: "Jasa 17.01.05 - Transmisi data" },
  {
    value: "J170109",
    code: "170109",
    label: "Jasa 17.01.09 - Telekomunikasi lainnya",
  },
  {
    value: "J170200",
    code: "170200",
    label: "Jasa 17.02.00 - Alat telekomunikasi internet",
  },
  {
    value: "J170201",
    code: "170201",
    label: "Jasa 17.02.01 - Server internet",
  },
  { value: "J170202", code: "170202", label: "Jasa 17.02.02 - Akses internet" },
  {
    value: "J170209",
    code: "170209",
    label: "Jasa 17.02.09 - Internet lainnya",
  },
  {
    value: "J170300",
    code: "170300",
    label: "Jasa 17.03.00 - Penjualan pulsa dan kartu perdana",
  },
  {
    value: "J170301",
    code: "170301",
    label: "Jasa 17.03.01 - Penjualan pulsa dan kartu perdana",
  },
  { value: "J170400", code: "170400", label: "Jasa 17.04.00 - Agen berita" },
  {
    value: "J170401",
    code: "170401",
    label: "Jasa 17.04.01 - Agen berita berupa koran dan majalah",
  },
  {
    value: "J170402",
    code: "170402",
    label: "Jasa 17.04.02 - Agen berita untuk media audiovisual/televisi",
  },
  {
    value: "J170500",
    code: "170500",
    label: "Jasa 17.05.00 - Perpustakaan dan penyimpanan dokumen/pengarsipan",
  },
  { value: "J170501", code: "170501", label: "Jasa 17.05.01 - Perpustakaan" },
  {
    value: "J170502",
    code: "170502",
    label: "Jasa 17.05.02 - Penyimpanan dokumen pengarsipan",
  },
  {
    value: "J170600",
    code: "170600",
    label: "Jasa 17.06.00 - Penyiaran, pemrograman dan distribusi program",
  },
  {
    value: "J170601",
    code: "170601",
    label: "Jasa 17.06.01 - Siaran radio dan televisi asli",
  },
  {
    value: "J170602",
    code: "170602",
    label: "Jasa 17.06.02 - Program saluran siaran radio dan televisi",
  },
  {
    value: "J170603",
    code: "170603",
    label:
      "Jasa 17.06.03 - Penyiaran dan distribusi program dengan banyak saluran",
  },
  // Section 18 - Jasa Pendukung
  { value: "J180000", code: "180000", label: "Jasa 18.00.00 - Pendukung" },
  {
    value: "J180100",
    code: "180100",
    label: "Jasa 18.01.00 - Ketenagakerjaan",
  },
  {
    value: "J180101",
    code: "180101",
    label: "Jasa 18.01.01 - Pencarian dan penyerahan personil ke perusahaan",
  },
  {
    value: "J180102",
    code: "180102",
    label: "Jasa 18.01.02 - Penyediaan tenaga kerja",
  },
  {
    value: "J180200",
    code: "180200",
    label: "Jasa 18.02.00 - Penyelidikan dan keamanan",
  },
  { value: "J180201", code: "180201", label: "Jasa 18.02.01 - Penyelidikan" },
  {
    value: "J180202",
    code: "180202",
    label: "Jasa 18.02.02 - Konsultan keamanan",
  },
  {
    value: "J180203",
    code: "180203",
    label: "Jasa 18.02.03 - Sistem keamanan",
  },
  {
    value: "J180204",
    code: "180204",
    label: "Jasa 18.02.04 - Kendaraan lapis baja",
  },
  { value: "J180205", code: "180205", label: "Jasa 18.02.05 - Penjagaan" },
  {
    value: "J180209",
    code: "180209",
    label: "Jasa 18.02.09 - Keamanan lainnya",
  },
  { value: "J180300", code: "180300", label: "Jasa 18.03.00 - Kebersihan" },
  {
    value: "J180301",
    code: "180301",
    label: "Jasa 18.03.01 - Pembasmian hama dan pemusnahan serangga",
  },
  {
    value: "J180302",
    code: "180302",
    label: "Jasa 18.03.02 - Kebersihan jendela",
  },
  {
    value: "J180303",
    code: "180303",
    label: "Jasa 18.03.03 - Kebersihan umum",
  },
  {
    value: "J180304",
    code: "180304",
    label: "Jasa 18.03.04 - Kebersihan khusus",
  },
  { value: "J180400", code: "180400", label: "Jasa 18.04.00 - Pengepakan" },
  { value: "J180401", code: "180401", label: "Jasa 18.04.01 - Pengepakan" },
  {
    value: "J180500",
    code: "180500",
    label: "Jasa 18.05.00 - Perencanaan wisata, petugas wisata dan hal terkait",
  },
  {
    value: "J180501",
    code: "180501",
    label: "Jasa 18.05.01 - Pemesanan/reservasi angkutan",
  },
  {
    value: "J180502",
    code: "180502",
    label:
      "Jasa 18.05.02 - Pemesanan/reservasi akomodasi, pelayaran dan paket wisata",
  },
  {
    value: "J180503",
    code: "180503",
    label: "Jasa 18.05.03 - Pemesanan/reservasi lainnya",
  },
  { value: "J180504", code: "180504", label: "Jasa 18.05.04 - Petugas wisata" },
  { value: "J180505", code: "180505", label: "Jasa 18.05.05 - Pemandu wisata" },
  {
    value: "J180506",
    code: "180506",
    label: "Jasa 18.05.06 - Promosi wisata dan informasi pengunjung",
  },
  {
    value: "J180900",
    code: "180900",
    label: "Jasa 18.09.00 - Pendukung lainnya",
  },
  { value: "J180901", code: "180901", label: "Jasa 18.09.01 - Laporan kredit" },
  {
    value: "J180902",
    code: "180902",
    label: "Jasa 18.09.02 - Agen pengumpulan",
  },
  {
    value: "J180903",
    code: "180903",
    label: "Jasa 18.09.03 - Pendukung dengan telepon",
  },
  {
    value: "J180904",
    code: "180904",
    label: "Jasa 18.09.04 - Administrasi kantor campuran",
  },
  {
    value: "J180905",
    code: "180905",
    label: "Jasa 18.09.05 - Pendukung kantor khusus",
  },
  {
    value: "J180906",
    code: "180906",
    label: "Jasa 18.09.06 - Bantuan dan pengorganisasian rapat/konvensi",
  },
  {
    value: "J180907",
    code: "180907",
    label: "Jasa 18.09.07 - Pemeliharaan dan perawatan pemandangan alam",
  },
  {
    value: "J180909",
    code: "180909",
    label: "Jasa 18.09.09 - Pendukung dan informasi lainnya",
  },
  // Section 19 - Pendukung Pertanian, Perburuan, Kehutanan, Perikanan, Pertambangan
  {
    value: "J190000",
    code: "190000",
    label:
      "Jasa 19.00.00 - Pendukung pertanian, perburuan, kehutanan, perikanan, pertambangan",
  },
  {
    value: "J190100",
    code: "190100",
    label:
      "Jasa 19.01.00 - Pendukung pertanian, perburuan, kehutanan dan perikanan",
  },
  {
    value: "J190101",
    code: "190101",
    label: "Jasa 19.01.01 - Pendukung untuk produksi hasil panen",
  },
  {
    value: "J190102",
    code: "190102",
    label: "Jasa 19.01.02 - Peternakan hewan",
  },
  {
    value: "J190103",
    code: "190103",
    label: "Jasa 19.01.03 - Pendukung untuk perburuan",
  },
  {
    value: "J190104",
    code: "190104",
    label: "Jasa 19.01.04 - Pendukung untuk kehutanan dan penebangan kayu",
  },
  {
    value: "J190105",
    code: "190105",
    label: "Jasa 19.01.05 - Pendukung untuk perikanan",
  },
  {
    value: "J190200",
    code: "190200",
    label: "Jasa 19.02.00 - Pendukung untuk pertambangan",
  },
  {
    value: "J190201",
    code: "190201",
    label: "Jasa 19.02.01 - Pendukung untuk pertambangan",
  },
  {
    value: "J190300",
    code: "190300",
    label: "Jasa 19.03.00 - Pendukung untuk distribusi listrik, gas dan air",
  },
  {
    value: "J190301",
    code: "190301",
    label: "Jasa 19.03.01 - Pendukung untuk distribusi dan transmisi listrik",
  },
  {
    value: "J190302",
    code: "190302",
    label:
      "Jasa 19.03.02 - Distribusi gas melalui sumber gas (atas dasar biaya/kontrak)",
  },
  {
    value: "J190303",
    code: "190303",
    label:
      "Jasa 19.03.03 - Distribusi air melalui sumber air (atas dasar biaya/kontrak)",
  },
  {
    value: "J190304",
    code: "190304",
    label: "Jasa 19.03.04 - Distribusi uap, air panas dan AC melalui sumbernya",
  },
  {
    value: "J190305",
    code: "190305",
    label: "Jasa 19.03.05 - Distribusi air (kecuali melalui sumber air)",
  },
  // Section 20 - Perawatan, Perbaikan dan Instalasi (kecuali Konstruksi)
  {
    value: "J200000",
    code: "200000",
    label:
      "Jasa 20.00.00 - Perawatan, perbaikan dan instalasi kecuali konstruksi",
  },
  {
    value: "J200100",
    code: "200100",
    label:
      "Jasa 20.01.00 - Perawatan/perbaikan produk logam pabrikan (kecuali mesin)",
  },
  {
    value: "J200101",
    code: "200101",
    label:
      "Jasa 20.01.01 - Perawatan/perbaikan produk logam pabrikan (kecuali mesin)",
  },
  {
    value: "J200102",
    code: "200102",
    label: "Jasa 20.01.02 - Perawatan/perbaikan mesin kantor dan mesin hitung",
  },
  {
    value: "J200103",
    code: "200103",
    label:
      "Jasa 20.01.03 - Perawatan/perbaikan komputer dan suku cadang komputer",
  },
  {
    value: "J200104",
    code: "200104",
    label:
      "Jasa 20.01.04 - Perawatan/perbaikan mesin transportasi dan peralatannya",
  },
  {
    value: "J200105",
    code: "200105",
    label: "Jasa 20.01.05 - Perawatan/perbaikan mesin dan peralatan lainnya",
  },
  {
    value: "J200200",
    code: "200200",
    label: "Jasa 20.02.00 - Perbaikan barang-barang lainnya",
  },
  {
    value: "J200201",
    code: "200201",
    label: "Jasa 20.02.01 - Perbaikan alas kaki dan barang dari kulit",
  },
  {
    value: "J200202",
    code: "200202",
    label: "Jasa 20.02.02 - Perbaikan jam tangan, jam dinding dan perhiasan",
  },
  {
    value: "J200203",
    code: "200203",
    label: "Jasa 20.02.03 - Perbaikan pakaian dan barang tekstil rumah tangga",
  },
  {
    value: "J200204",
    code: "200204",
    label: "Jasa 20.02.04 - Perbaikan barang-barang mebel",
  },
  {
    value: "J200209",
    code: "200209",
    label: "Jasa 20.02.09 - Perawatan/perbaikan barang lainnya",
  },
  {
    value: "J200300",
    code: "200300",
    label: "Jasa 20.03.00 - Instalasi selain konstruksi",
  },
  {
    value: "J200301",
    code: "200301",
    label: "Jasa 20.03.01 - Instalasi produk logam pabrikan (kecuali mesin)",
  },
  {
    value: "J200302",
    code: "200302",
    label: "Jasa 20.03.02 - Instalasi mesin dan peralatan industri/manufaktur",
  },
  {
    value: "J200303",
    code: "200303",
    label: "Jasa 20.03.03 - Instalasi mesin kantor, mesin hitung dan komputer",
  },
  {
    value: "J200304",
    code: "200304",
    label:
      "Jasa 20.03.04 - Instalasi radio, televisi dan alat komunikasi lainnya",
  },
  {
    value: "J200305",
    code: "200305",
    label:
      "Jasa 20.03.05 - Instalasi mesin kedokteran profesional, alat presisi dan optik",
  },
  {
    value: "J200306",
    code: "200306",
    label: "Jasa 20.03.06 - Instalasi mesin dan perlengkapan listrik",
  },
  {
    value: "J200309",
    code: "200309",
    label: "Jasa 20.03.09 - Instalasi barang-barang lain",
  },
  // Section 21 - Pengolahan/Pembuatan (Maklon) dengan Input Industri Lain
  {
    value: "J210000",
    code: "210000",
    label:
      "Jasa 21.00.00 - Pengolahan/pembuatan dengan input dari industri lain (maklon)",
  },
  {
    value: "J210100",
    code: "210100",
    label: "Jasa 21.01.00 - Pengolahan makanan, minuman dan tembakau",
  },
  {
    value: "J210101",
    code: "210101",
    label: "Jasa 21.01.01 - Pengolahan daging",
  },
  {
    value: "J210102",
    code: "210102",
    label: "Jasa 21.01.02 - Pengolahan ikan",
  },
  {
    value: "J210103",
    code: "210103",
    label: "Jasa 21.01.03 - Pengolahan buah dan sayuran",
  },
  {
    value: "J210104",
    code: "210104",
    label:
      "Jasa 21.01.04 - Pengolahan minyak dan lemak dari tumbuhan dan hewan",
  },
  {
    value: "J210105",
    code: "210105",
    label: "Jasa 21.01.05 - Pengolahan produk dari susu",
  },
  {
    value: "J210106",
    code: "210106",
    label: "Jasa 21.01.06 - Pengolahan produk makanan lainnya",
  },
  {
    value: "J210107",
    code: "210107",
    label: "Jasa 21.01.07 - Pengolahan makanan hewan",
  },
  {
    value: "J210108",
    code: "210108",
    label: "Jasa 21.01.08 - Pengolahan minuman",
  },
  {
    value: "J210109",
    code: "210109",
    label: "Jasa 21.01.09 - Pengolahan tembakau",
  },
  {
    value: "J210200",
    code: "210200",
    label: "Jasa 21.02.00 - Pengolahan tekstil, pakaian jadi dan produk kulit",
  },
  {
    value: "J210201",
    code: "210201",
    label: "Jasa 21.02.01 - Pengolahan tekstil",
  },
  {
    value: "J210202",
    code: "210202",
    label: "Jasa 21.02.02 - Pembuatan pakaian jadi",
  },
  {
    value: "J210203",
    code: "210203",
    label: "Jasa 21.02.03 - Pembuatan kulit dan barang dari kulit",
  },
  {
    value: "J210300",
    code: "210300",
    label: "Jasa 21.03.00 - Pengolahan kayu dan kertas",
  },
  {
    value: "J210301",
    code: "210301",
    label: "Jasa 21.03.01 - Pengolahan kayu dan produk kayu",
  },
  {
    value: "J210302",
    code: "210302",
    label: "Jasa 21.03.02 - Pengolahan kertas dan barang dari kertas",
  },
  {
    value: "J210400",
    code: "210400",
    label: "Jasa 21.04.00 - Pengolahan produk minyak, bahan kimia dan farmasi",
  },
  {
    value: "J210401",
    code: "210401",
    label: "Jasa 21.04.01 - Pengolahan produk dari arang dan minyak sulingan",
  },
  {
    value: "J210402",
    code: "210402",
    label: "Jasa 21.04.02 - Pembuatan produk dari bahan kimia",
  },
  {
    value: "J210403",
    code: "210403",
    label: "Jasa 21.04.03 - Pembuatan produk dari barang farmasi",
  },
  {
    value: "J210500",
    code: "210500",
    label:
      "Jasa 21.05.00 - Pembuatan produk karet/plastik dan barang tambang bukan logam",
  },
  {
    value: "J210501",
    code: "210501",
    label: "Jasa 21.05.01 - Pembuatan produk karet dan plastik",
  },
  {
    value: "J210502",
    code: "210502",
    label: "Jasa 21.05.02 - Pembuatan produk dari plastik",
  },
  {
    value: "J210503",
    code: "210503",
    label: "Jasa 21.05.03 - Pembuatan produk barang tambang bukan logam",
  },
  {
    value: "J210600",
    code: "210600",
    label: "Jasa 21.06.00 - Pembuatan logam dasar",
  },
  {
    value: "J210601",
    code: "210601",
    label: "Jasa 21.06.01 - Pembuatan logam dasar",
  },
  {
    value: "J210700",
    code: "210700",
    label:
      "Jasa 21.07.00 - Pembuatan logam pabrikan, mesin dan peralatan lainnya",
  },
  {
    value: "J210701",
    code: "210701",
    label:
      "Jasa 21.07.01 - Pembuatan produk logam berstruktur, tangki, tandon, generator uap",
  },
  {
    value: "J210702",
    code: "210702",
    label: "Jasa 21.07.02 - Pembuatan senjata dan amunisi",
  },
  {
    value: "J210703",
    code: "210703",
    label:
      "Jasa 21.07.03 - Pembuatan dan perawatan produk logam pabrikan lainnya",
  },
  {
    value: "J210704",
    code: "210704",
    label:
      "Jasa 21.07.04 - Pembuatan komputer, barang elektronik dan barang optik",
  },
  {
    value: "J210705",
    code: "210705",
    label: "Jasa 21.07.05 - Pembuatan alat-alat listrik",
  },
  {
    value: "J210706",
    code: "210706",
    label: "Jasa 21.07.06 - Pembuatan mesin serbaguna",
  },
  {
    value: "J210707",
    code: "210707",
    label: "Jasa 21.07.07 - Pembuatan mesin-mesin khusus",
  },
  {
    value: "J210800",
    code: "210800",
    label: "Jasa 21.08.00 - Pembuatan alat-alat transportasi/angkutan",
  },
  {
    value: "J210801",
    code: "210801",
    label: "Jasa 21.08.01 - Pembuatan kendaraan bermotor dan trailer",
  },
  {
    value: "J210802",
    code: "210802",
    label: "Jasa 21.08.02 - Pembuatan alat-alat transportasi/angkutan lainnya",
  },
  {
    value: "J210900",
    code: "210900",
    label: "Jasa 21.09.00 - Pembuatan barang-barang lainnya",
  },
  {
    value: "J210901",
    code: "210901",
    label: "Jasa 21.09.01 - Pembuatan barang-barang lainnya",
  },
  // Section 22 - Pembuatan Barang Lain; Penerbitan/Percetakan; Perbaikan Alat
  {
    value: "J220000",
    code: "220000",
    label:
      "Jasa 22.00.00 - Pembuatan barang lain; penerbitan/percetakan; perbaikan alat",
  },
  {
    value: "J220100",
    code: "220100",
    label: "Jasa 22.01.00 - Penerbitan, percetakan dan produksi ulang",
  },
  {
    value: "J220101",
    code: "220101",
    label: "Jasa 22.01.01 - Penerbitan atas dasar balas jasa/kontrak",
  },
  {
    value: "J220102",
    code: "220102",
    label:
      "Jasa 22.01.02 - Percetakan dan produksi ulang media perekam (kontrak)",
  },
  {
    value: "J220200",
    code: "220200",
    label:
      "Jasa 22.02.00 - Percetakan, pengepresan, pengecapan dan pembuatan plastik sejenis",
  },
  {
    value: "J220201",
    code: "220201",
    label:
      "Jasa 22.02.01 - Percetakan, pengepresan, pengecapan dan pembuatan plastik sejenis",
  },
  {
    value: "J220300",
    code: "220300",
    label:
      "Jasa 22.03.00 - Pemilihan, penempaan, pengecapan dan pembuatan barang logam sejenis",
  },
  {
    value: "J220301",
    code: "220301",
    label: "Jasa 22.03.01 - Pemilihan besi dan baja",
  },
  {
    value: "J220302",
    code: "220302",
    label: "Jasa 22.03.02 - Pemilihan logam-logam bukan besi",
  },
  {
    value: "J220303",
    code: "220303",
    label:
      "Jasa 22.03.03 - Metalurgi (penempaan, pressing, pembentukan gulungan, bubuk logam)",
  },
  {
    value: "J220400",
    code: "220400",
    label:
      "Jasa 22.04.00 - Daur ulang barang-barang (atas dasar balas jasa/kontrak)",
  },
  {
    value: "J220401",
    code: "220401",
    label: "Jasa 22.04.01 - Daur ulang limbah dan sisaan logam (kontrak)",
  },
  {
    value: "J220402",
    code: "220402",
    label: "Jasa 22.04.02 - Daur ulang limbah dan sisaan non-logam (kontrak)",
  },
  // Section 23 - Administrasi Publik; Jaminan Sosial Wajib
  {
    value: "J230000",
    code: "230000",
    label:
      "Jasa 23.00.00 - Administrasi publik dan jasa lainnya untuk masyarakat; jaminan sosial wajib",
  },
  {
    value: "J230100",
    code: "230100",
    label: "Jasa 23.01.00 - Administrasi pemerintahan",
  },
  {
    value: "J230101",
    code: "230101",
    label: "Jasa 23.01.01 - Pemerintahan umum secara keseluruhan",
  },
  {
    value: "J230102",
    code: "230102",
    label:
      "Jasa 23.01.02 - Administrasi publik penyedia layanan pendidikan/kesehatan/sosial",
  },
  {
    value: "J230103",
    code: "230103",
    label: "Jasa 23.01.03 - Administrasi umum cara kerja yang lebih efisien",
  },
  {
    value: "J230109",
    code: "230109",
    label: "Jasa 23.01.09 - Administrasi pemerintahan lainnya",
  },
  {
    value: "J230200",
    code: "230200",
    label: "Jasa 23.02.00 - Administrasi umum untuk komunitas masyarakat umum",
  },
  {
    value: "J230201",
    code: "230201",
    label: "Jasa 23.02.01 - Administrasi luar negeri, diplomat dan konsulat",
  },
  {
    value: "J230202",
    code: "230202",
    label: "Jasa 23.02.02 - Berhubungan dengan bantuan ekonomi luar negeri",
  },
  {
    value: "J230203",
    code: "230203",
    label: "Jasa 23.02.03 - Berhubungan dengan bantuan militer luar negeri",
  },
  {
    value: "J230204",
    code: "230204",
    label: "Jasa 23.02.04 - Pertahanan militer",
  },
  {
    value: "J230205",
    code: "230205",
    label: "Jasa 23.02.05 - Pertahanan sipil",
  },
  {
    value: "J230206",
    code: "230206",
    label: "Jasa 23.02.06 - Polisi dan pemadam kebakaran",
  },
  {
    value: "J230207",
    code: "230207",
    label: "Jasa 23.02.07 - Administrasi terkait pengadilan hukum",
  },
  {
    value: "J230208",
    code: "230208",
    label: "Jasa 23.02.08 - Administrasi penahanan dan rehabilitasi narapidana",
  },
  {
    value: "J230209",
    code: "230209",
    label: "Jasa 23.02.09 - Administrasi keselamatan dan tatanan masyarakat",
  },
  {
    value: "J230300",
    code: "230300",
    label: "Jasa 23.03.00 - Administrasi skema jaminan sosial wajib",
  },
  {
    value: "J230301",
    code: "230301",
    label:
      "Jasa 23.03.01 - Administrasi penyakit persalinan atau ganti rugi cacat",
  },
  {
    value: "J230302",
    code: "230302",
    label:
      "Jasa 23.03.02 - Administrasi skema pensiun pegawai negeri/manfaat ahli waris",
  },
  {
    value: "J230303",
    code: "230303",
    label:
      "Jasa 23.03.03 - Administrasi pesangon/dana kompensasi pemberhentian pekerja",
  },
  {
    value: "J230304",
    code: "230304",
    label: "Jasa 23.03.04 - Administrasi program tunjangan keluarga dan anak",
  },
  // Section 24 - Pendidikan
  { value: "J240000", code: "240000", label: "Jasa 24.00.00 - Pendidikan" },
  {
    value: "J240100",
    code: "240100",
    label: "Jasa 24.01.00 - Pendidikan pra-sekolah dasar",
  },
  {
    value: "J240101",
    code: "240101",
    label: "Jasa 24.01.01 - Pendidikan pra-sekolah dasar",
  },
  {
    value: "J240200",
    code: "240200",
    label: "Jasa 24.02.00 - Pendidikan sekolah dasar",
  },
  {
    value: "J240201",
    code: "240201",
    label: "Jasa 24.02.01 - Pendidikan sekolah dasar",
  },
  {
    value: "J240300",
    code: "240300",
    label: "Jasa 24.03.00 - Pendidikan sekolah menengah",
  },
  {
    value: "J240301",
    code: "240301",
    label: "Jasa 24.03.01 - Pendidikan SMP umum",
  },
  {
    value: "J240302",
    code: "240302",
    label: "Jasa 24.03.02 - Pendidikan SMP teknik dan kejuruan",
  },
  {
    value: "J240303",
    code: "240303",
    label: "Jasa 24.03.03 - Pendidikan SMA umum",
  },
  {
    value: "J240304",
    code: "240304",
    label: "Jasa 24.03.04 - Pendidikan SMA teknik dan kejuruan",
  },
  {
    value: "J240400",
    code: "240400",
    label: "Jasa 24.04.00 - Pendidikan paska-menengah non tersier",
  },
  {
    value: "J240401",
    code: "240401",
    label: "Jasa 24.04.01 - Pendidikan paska-menengah non tersier umum",
  },
  {
    value: "J240402",
    code: "240402",
    label:
      "Jasa 24.04.02 - Pendidikan paska-menengah non tersier teknik dan kejuruan",
  },
  {
    value: "J240500",
    code: "240500",
    label: "Jasa 24.05.00 - Pendidikan tersier",
  },
  {
    value: "J240501",
    code: "240501",
    label: "Jasa 24.05.01 - Pendidikan tersier tingkat pertama",
  },
  {
    value: "J240502",
    code: "240502",
    label: "Jasa 24.05.02 - Pendidikan tersier tingkat kedua",
  },
  {
    value: "J240900",
    code: "240900",
    label:
      "Jasa 24.09.00 - Pendidikan lain informal, pelatihan/kursus, pendukung pendidikan",
  },
  {
    value: "J240901",
    code: "240901",
    label: "Jasa 24.09.01 - Pendidikan dan pelatihan/kursus lainnya",
  },
  {
    value: "J240902",
    code: "240902",
    label: "Jasa 24.09.02 - Pendukung pendidikan",
  },
  // Section 25 - Kesehatan Masyarakat dan Organisasi Sosial
  {
    value: "J250000",
    code: "250000",
    label:
      "Jasa 25.00.00 - Kesehatan masyarakat dan organisasi sosial kemanusiaan",
  },
  {
    value: "J250100",
    code: "250100",
    label: "Jasa 25.01.00 - Kesehatan masyarakat",
  },
  {
    value: "J250101",
    code: "250101",
    label: "Jasa 25.01.01 - Pasien rawat inap",
  },
  {
    value: "J250102",
    code: "250102",
    label: "Jasa 25.01.02 - Kedokteran dan kedokteran gigi",
  },
  {
    value: "J250109",
    code: "250109",
    label: "Jasa 25.01.09 - Kesehatan masyarakat lainnya",
  },
  {
    value: "J250200",
    code: "250200",
    label:
      "Jasa 25.02.00 - Institusi rawat inap/panti untuk orang tua dan orang cacat",
  },
  {
    value: "J250201",
    code: "250201",
    label: "Jasa 25.02.01 - Kesehatan selain rumah sakit",
  },
  {
    value: "J250202",
    code: "250202",
    label:
      "Jasa 25.02.02 - Institusi rawat inap/panti untuk orang tua dan cacat",
  },
  {
    value: "J250300",
    code: "250300",
    label: "Jasa 25.03.00 - Sosial lainnya dengan akomodasi",
  },
  {
    value: "J250301",
    code: "250301",
    label: "Jasa 25.03.01 - Sosial lainnya dengan akomodasi",
  },
  {
    value: "J250400",
    code: "250400",
    label: "Jasa 25.04.00 - Sosial tanpa akomodasi untuk orang tua dan cacat",
  },
  {
    value: "J250401",
    code: "250401",
    label: "Jasa 25.04.01 - Tempat penampungan/rehabilitasi",
  },
  {
    value: "J250409",
    code: "250409",
    label:
      "Jasa 25.04.09 - Sosial lainnya tanpa akomodasi untuk orang tua dan cacat",
  },
  {
    value: "J250500",
    code: "250500",
    label: "Jasa 25.05.00 - Sosial tanpa akomodasi lainnya",
  },
  {
    value: "J250501",
    code: "250501",
    label: "Jasa 25.05.01 - Penitipan anak harian",
  },
  {
    value: "J250502",
    code: "250502",
    label: "Jasa 25.05.02 - Pengarahan dan konseling anak-anak",
  },
  {
    value: "J250503",
    code: "250503",
    label: "Jasa 25.05.03 - Kesejahteraan tanpa akomodasi",
  },
  {
    value: "J250509",
    code: "250509",
    label: "Jasa 25.05.09 - Sosial lainnya tanpa akomodasi",
  },
  // Section 26 - Pengumpulan Kotoran/Limbah; Perlindungan Lingkungan
  {
    value: "J260000",
    code: "260000",
    label:
      "Jasa 26.00.00 - Pengumpulan kotoran/limbah, pengolahan/pembuangan; perlindungan lingkungan",
  },
  {
    value: "J260100",
    code: "260100",
    label:
      "Jasa 26.01.00 - Pembuangan kotoran, pengolahan kotoran dan pembersihan tangki septik",
  },
  {
    value: "J260101",
    code: "260101",
    label: "Jasa 26.01.01 - Pembuangan dan pengolahan kotoran",
  },
  {
    value: "J260102",
    code: "260102",
    label: "Jasa 26.01.02 - Pengosongan dan pembersihan tangki septik",
  },
  {
    value: "J260200",
    code: "260200",
    label: "Jasa 26.02.00 - Pengumpulan limbah",
  },
  {
    value: "J260201",
    code: "260201",
    label: "Jasa 26.02.01 - Pengumpulan limbah berbahaya",
  },
  {
    value: "J260202",
    code: "260202",
    label:
      "Jasa 26.02.02 - Pengumpulan zat dapat didaur ulang dan tidak berbahaya",
  },
  {
    value: "J260203",
    code: "260203",
    label: "Jasa 26.02.03 - Pengumpulan sampah",
  },
  {
    value: "J260300",
    code: "260300",
    label: "Jasa 26.03.00 - Pembuangan dan pengolahan sampah",
  },
  {
    value: "J260301",
    code: "260301",
    label: "Jasa 26.03.01 - Penyiapan, pengumpulan dan penyimpanan sampah",
  },
  {
    value: "J260302",
    code: "260302",
    label:
      "Jasa 26.03.02 - Pengolahan dan pembuangan sampah mengandung zat berbahaya",
  },
  {
    value: "J260303",
    code: "260303",
    label: "Jasa 26.03.03 - Pengolahan dan pembuangan sampah tidak berbahaya",
  },
  { value: "J260400", code: "260400", label: "Jasa 26.04.00 - Perbaikan" },
  {
    value: "J260401",
    code: "260401",
    label: "Jasa 26.04.01 - Perbaikan dan pembersihan tempat/ruangan",
  },
  {
    value: "J260402",
    code: "260402",
    label:
      "Jasa 26.04.02 - Penahanan, pengawasan dan pemantauan; perbaikan tempat lainnya",
  },
  {
    value: "J260403",
    code: "260403",
    label: "Jasa 26.04.03 - Perbaikan gedung",
  },
  {
    value: "J260409",
    code: "260409",
    label: "Jasa 26.04.09 - Perbaikan lainnya",
  },
  {
    value: "J260500",
    code: "260500",
    label: "Jasa 26.05.00 - Sanitasi dan hal sejenisnya",
  },
  {
    value: "J260501",
    code: "260501",
    label: "Jasa 26.05.01 - Penyapuan dan pembersihan salju",
  },
  {
    value: "J260509",
    code: "260509",
    label: "Jasa 26.05.09 - Sanitasi lainnya",
  },
  {
    value: "J260900",
    code: "260900",
    label: "Jasa 26.09.00 - Perlindungan lingkungan lainnya",
  },
  {
    value: "J260901",
    code: "260901",
    label: "Jasa 26.09.01 - Perlindungan lingkungan lainnya",
  },
  // Section 27 - Keanggotaan Organisasi
  {
    value: "J270000",
    code: "270000",
    label: "Jasa 27.00.00 - Keanggotaan organisasi",
  },
  {
    value: "J270100",
    code: "270100",
    label:
      "Jasa 27.01.00 - Disediakan oleh perusahaan, organisasi pekerja dan profesional",
  },
  {
    value: "J270101",
    code: "270101",
    label: "Jasa 27.01.01 - Disediakan oleh perusahaan dan organisasi pekerja",
  },
  {
    value: "J270102",
    code: "270102",
    label: "Jasa 27.01.02 - Disediakan oleh organisasi profesional",
  },
  {
    value: "J270200",
    code: "270200",
    label: "Jasa 27.02.00 - Disediakan oleh serikat perdagangan",
  },
  {
    value: "J270201",
    code: "270201",
    label: "Jasa 27.02.01 - Disediakan oleh serikat perdagangan",
  },
  {
    value: "J270900",
    code: "270900",
    label: "Jasa 27.09.00 - Disediakan oleh keanggotaan organisasi lainnya",
  },
  { value: "J270901", code: "270901", label: "Jasa 27.09.01 - Keagamaan" },
  {
    value: "J270902",
    code: "270902",
    label: "Jasa 27.09.02 - Disediakan oleh organisasi politik",
  },
  {
    value: "J270909",
    code: "270909",
    label: "Jasa 27.09.09 - Disediakan oleh keanggotaan organisasi lainnya",
  },
  // Section 28 - Pariwisata, Kebudayaan dan Olahraga
  {
    value: "J280000",
    code: "280000",
    label: "Jasa 28.00.00 - Pariwisata, kebudayaan dan olahraga",
  },
  { value: "J280100", code: "280100", label: "Jasa 28.01.00 - Audiovisual" },
  {
    value: "J280101",
    code: "280101",
    label: "Jasa 28.01.01 - Perekaman suara",
  },
  {
    value: "J280102",
    code: "280102",
    label:
      "Jasa 28.01.02 - Produksi gambar bergerak, video tape, program TV dan radio",
  },
  {
    value: "J280103",
    code: "280103",
    label: "Jasa 28.01.03 - Paska produksi audiovisual",
  },
  {
    value: "J280104",
    code: "280104",
    label:
      "Jasa 28.01.04 - Distribusi gambar bergerak, video tape dan program televisi",
  },
  {
    value: "J280105",
    code: "280105",
    label: "Jasa 28.01.05 - Proyeksi gambar bergerak",
  },
  {
    value: "J280200",
    code: "280200",
    label:
      "Jasa 28.02.00 - Presentasi dan promosi pertunjukan kesenian dan hiburan langsung",
  },
  {
    value: "J280201",
    code: "280201",
    label:
      "Jasa 28.02.01 - Promosi dan pengorganisasian acara pertunjukan kesenian",
  },
  {
    value: "J280202",
    code: "280202",
    label: "Jasa 28.02.02 - Produksi dan presentasi acara pertunjukan kesenian",
  },
  {
    value: "J280203",
    code: "280203",
    label: "Jasa 28.02.03 - Fasilitas untuk operasi acara kesenian",
  },
  {
    value: "J280209",
    code: "280209",
    label: "Jasa 28.02.09 - Kesenian dan pertunjukan hiburan lainnya",
  },
  {
    value: "J280300",
    code: "280300",
    label: "Jasa 28.03.00 - Seniman pertunjukan dan seniman lainnya",
  },
  {
    value: "J280301",
    code: "280301",
    label: "Jasa 28.03.01 - Seniman pertunjukan",
  },
  {
    value: "J280302",
    code: "280302",
    label: "Jasa 28.03.02 - Penulis, pengubah, pemahat dan seniman lain",
  },
  {
    value: "J280303",
    code: "280303",
    label: "Jasa 28.03.03 - Karya asli dari penulis, pengubah dan seniman lain",
  },
  {
    value: "J280400",
    code: "280400",
    label: "Jasa 28.04.00 - Museum dan pemeliharaannya",
  },
  {
    value: "J280401",
    code: "280401",
    label: "Jasa 28.04.01 - Museum dan pemeliharaan tempat/bangunan bersejarah",
  },
  {
    value: "J280402",
    code: "280402",
    label: "Jasa 28.04.02 - Kebun raya, kebun binatang dan cagar alam",
  },
  {
    value: "J280500",
    code: "280500",
    label: "Jasa 28.05.00 - Olahraga dan olahraga rekreasi",
  },
  {
    value: "J280501",
    code: "280501",
    label:
      "Jasa 28.05.01 - Promosi dan pengorganisasian olahraga dan olahraga rekreasi",
  },
  {
    value: "J280502",
    code: "280502",
    label:
      "Jasa 28.05.02 - Pengoperasian fasilitas olahraga dan olahraga rekreasi",
  },
  {
    value: "J280509",
    code: "280509",
    label: "Jasa 28.05.09 - Olahraga dan olahraga rekreasi lainnya",
  },
  { value: "J280600", code: "280600", label: "Jasa 28.06.00 - Atlet" },
  { value: "J280601", code: "280601", label: "Jasa 28.06.01 - Atlet" },
  {
    value: "J280602",
    code: "280602",
    label: "Jasa 28.06.02 - Pendukung olahraga dan rekreasi",
  },
  {
    value: "J280900",
    code: "280900",
    label: "Jasa 28.09.00 - Hiburan dan rekreasi lainnya",
  },
  {
    value: "J280901",
    code: "280901",
    label: "Jasa 28.09.01 - Taman hiburan dan atraksi sejenisnya",
  },
  {
    value: "J280902",
    code: "280902",
    label: "Jasa 28.09.02 - Perjudian dan pertaruhan",
  },
  {
    value: "J280903",
    code: "280903",
    label: "Jasa 28.09.03 - Mesin hiburan yang menggunakan koin/uang logam",
  },
  {
    value: "J280909",
    code: "280909",
    label: "Jasa 28.09.09 - Rekreasi dan hiburan lainnya",
  },
  // Section 29 - Jasa Lainnya
  { value: "J290000", code: "290000", label: "Jasa 29.00.00 - Jasa lainnya" },
  {
    value: "J290100",
    code: "290100",
    label: "Jasa 29.01.00 - Pencucian, pembersihan dan pewarnaan",
  },
  {
    value: "J290101",
    code: "290101",
    label: "Jasa 29.01.01 - Loundry/mesin cuci dengan koin",
  },
  {
    value: "J290102",
    code: "290102",
    label:
      "Jasa 29.01.02 - Dry-cleaning termasuk pembersihan produk kulit berbulu",
  },
  {
    value: "J290103",
    code: "290103",
    label: "Jasa 29.01.03 - Pembersihan barang tekstil lainnya",
  },
  { value: "J290104", code: "290104", label: "Jasa 29.01.04 - Pengepresan" },
  {
    value: "J290105",
    code: "290105",
    label: "Jasa 29.01.05 - Pencelupan dan pewarnaan",
  },
  {
    value: "J290200",
    code: "290200",
    label: "Jasa 29.02.00 - Kecantikan dan perawatan tubuh",
  },
  {
    value: "J290201",
    code: "290201",
    label: "Jasa 29.02.01 - Penataan dan pemotongan rambut",
  },
  {
    value: "J290202",
    code: "290202",
    label: "Jasa 29.02.02 - Perawatan kosmetik, manikur dan pedikur",
  },
  {
    value: "J290203",
    code: "290203",
    label: "Jasa 29.02.03 - Perawatan tubuh",
  },
  {
    value: "J290209",
    code: "290209",
    label: "Jasa 29.02.09 - Perawatan kecantikan lainnya",
  },
  {
    value: "J290300",
    code: "290300",
    label:
      "Jasa 29.03.00 - Penguburan, pembakaran mayat dan pengurusan pemakaman",
  },
  {
    value: "J290301",
    code: "290301",
    label: "Jasa 29.03.01 - Kuburan dan pembakaran mayat",
  },
  {
    value: "J290302",
    code: "290302",
    label: "Jasa 29.03.02 - Pengurusan pemakaman",
  },
  {
    value: "J290900",
    code: "290900",
    label: "Jasa 29.09.00 - Aneka jasa lainnya",
  },
  {
    value: "J290901",
    code: "290901",
    label: "Jasa 29.09.01 - Pendamping (escort)",
  },
  {
    value: "J290909",
    code: "290909",
    label: "Jasa 29.09.09 - Aneka jasa lainnya",
  },
  // Section 30 - Pembantu Rumah Tangga
  {
    value: "J300000",
    code: "300000",
    label: "Jasa 30.00.00 - Pembantu rumah tangga",
  },
  {
    value: "J300100",
    code: "300100",
    label: "Jasa 30.01.00 - Pembantu rumah tangga",
  },
  {
    value: "J300101",
    code: "300101",
    label: "Jasa 30.01.01 - Pembantu rumah tangga",
  },
  // Section 31 - Jasa oleh Badan/Organisasi Luar Negeri
  {
    value: "J310000",
    code: "310000",
    label:
      "Jasa 31.00.00 - Disediakan oleh badan/organisasi di luar wilayah dalam negeri (luar negeri)",
  },
  {
    value: "J310100",
    code: "310100",
    label: "Jasa 31.01.00 - Disediakan oleh badan/organisasi di luar negeri",
  },
  {
    value: "J310101",
    code: "310101",
    label: "Jasa 31.01.01 - Disediakan oleh badan/organisasi di luar negeri",
  },
];
